var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckDamage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 488.55 343.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-126,.cls-130,.cls-131,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-173,.cls-182,.cls-184,.cls-187,.cls-21,.cls-226,.cls-227,.cls-228,.cls-229,.cls-23,.cls-230,.cls-238,.cls-239,.cls-240,.cls-241,.cls-254,.cls-256,.cls-284,.cls-3,.cls-311,.cls-315,.cls-316,.cls-328,.cls-330,.cls-339,.cls-340,.cls-341,.cls-342,.cls-343,.cls-344,.cls-345,.cls-346,.cls-347,.cls-348,.cls-349,.cls-350,.cls-351,.cls-352,.cls-353,.cls-354,.cls-355,.cls-356,.cls-357,.cls-358,.cls-359,.cls-360,.cls-361,.cls-362,.cls-363,.cls-364,.cls-365,.cls-366,.cls-367,.cls-368,.cls-369,.cls-370,.cls-371,.cls-372,.cls-373,.cls-374,.cls-375,.cls-376,.cls-377,.cls-378,.cls-379,.cls-380,.cls-381,.cls-382,.cls-383,.cls-384,.cls-385,.cls-386,.cls-387,.cls-388,.cls-389,.cls-390,.cls-391,.cls-392,.cls-393,.cls-394,.cls-395,.cls-396,.cls-397,.cls-398,.cls-399,.cls-4,.cls-400,.cls-401,.cls-402,.cls-403,.cls-404,.cls-405,.cls-406,.cls-407,.cls-408,.cls-409,.cls-410,.cls-467,.cls-474,.cls-475,.cls-491,.cls-498,.cls-5,.cls-501,.cls-506,.cls-508,.cls-509,.cls-510,.cls-511,.cls-513,.cls-514,.cls-515,.cls-516,.cls-517,.cls-518,.cls-519,.cls-520,.cls-521,.cls-522,.cls-523,.cls-524,.cls-525,.cls-526,.cls-527,.cls-528,.cls-529,.cls-582,.cls-586,.cls-587,.cls-6,.cls-62,.cls-63,.cls-64,.cls-65,.cls-7,.cls-75{mix-blend-mode:multiply;}.cls-3{fill:url(#radial-gradient);}.cls-4{fill:url(#radial-gradient-2);}.cls-5{fill:url(#radial-gradient-3);}.cls-6{fill:url(#radial-gradient-4);}.cls-7{fill:url(#radial-gradient-5);}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:#ae1815;}.cls-11{fill:url(#radial-gradient-6);}.cls-12{fill:url(#radial-gradient-7);}.cls-13{fill:url(#radial-gradient-8);}.cls-14{fill:url(#linear-gradient-3);}.cls-15{fill:url(#linear-gradient-4);}.cls-16{fill:url(#linear-gradient-5);}.cls-17{fill:url(#linear-gradient-6);}.cls-18{fill:url(#linear-gradient-7);}.cls-19{fill:url(#linear-gradient-8);}.cls-20{fill:url(#linear-gradient-9);}.cls-21{fill:url(#linear-gradient-10);}.cls-22{fill:url(#linear-gradient-11);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{fill:#7f7f83;}.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-127,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-312,.cls-32,.cls-33,.cls-34,.cls-35,.cls-580{mix-blend-mode:overlay;}.cls-25{fill:#87878a;}.cls-26{fill:#8e8e90;}.cls-27{fill:#969697;}.cls-28{fill:#9e9e9e;}.cls-29{fill:#a5a5a4;}.cls-30{fill:#adadab;}.cls-31{fill:#b4b4b1;}.cls-32{fill:#bcbcb8;}.cls-33{fill:#c4c4bf;}.cls-34{fill:#cbcbc5;}.cls-35{fill:#d3d3cc;}.cls-36{fill:url(#radial-gradient-9);}.cls-37{fill:url(#radial-gradient-10);}.cls-38{fill:url(#radial-gradient-11);}.cls-39{fill:url(#radial-gradient-12);}.cls-40{fill:url(#linear-gradient-13);}.cls-41{fill:url(#radial-gradient-13);}.cls-42{fill:url(#linear-gradient-14);}.cls-43{fill:url(#linear-gradient-15);}.cls-44{fill:url(#linear-gradient-16);}.cls-45{fill:url(#linear-gradient-17);}.cls-46{fill:url(#linear-gradient-18);}.cls-47{fill:url(#linear-gradient-19);}.cls-48{fill:url(#linear-gradient-20);}.cls-49{fill:url(#linear-gradient-21);}.cls-50{fill:url(#linear-gradient-22);}.cls-51{fill:url(#linear-gradient-23);}.cls-52{fill:url(#linear-gradient-24);}.cls-53{fill:url(#linear-gradient-25);}.cls-54{fill:url(#linear-gradient-26);}.cls-55{fill:url(#linear-gradient-27);}.cls-56{fill:url(#linear-gradient-28);}.cls-57{fill:url(#linear-gradient-29);}.cls-132,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-185,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-209,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-218,.cls-219,.cls-234,.cls-235,.cls-279,.cls-283,.cls-290,.cls-321,.cls-322,.cls-323,.cls-324,.cls-325,.cls-326,.cls-327,.cls-331,.cls-465,.cls-468,.cls-471,.cls-487,.cls-488,.cls-489,.cls-490,.cls-492,.cls-494,.cls-495,.cls-496,.cls-497,.cls-499,.cls-58,.cls-583,.cls-584,.cls-585,.cls-59,.cls-71,.cls-74,.cls-81,.cls-83{mix-blend-mode:soft-light;}.cls-58{fill:url(#linear-gradient-30);}.cls-59{fill:url(#linear-gradient-31);}.cls-60{fill:url(#linear-gradient-32);}.cls-61{fill:url(#linear-gradient-33);}.cls-62{fill:url(#linear-gradient-34);}.cls-63{fill:url(#linear-gradient-35);}.cls-64{fill:url(#linear-gradient-36);}.cls-65{fill:url(#linear-gradient-37);}.cls-66{fill:url(#linear-gradient-38);}.cls-67{fill:url(#linear-gradient-39);}.cls-68{fill:url(#linear-gradient-40);}.cls-69{fill:#b1740f;}.cls-70{fill:#922415;}.cls-71{fill:url(#linear-gradient-41);}.cls-72{fill:url(#linear-gradient-42);}.cls-73{fill:url(#linear-gradient-43);}.cls-74{fill:url(#linear-gradient-44);}.cls-75{fill:url(#linear-gradient-45);}.cls-76{fill:url(#linear-gradient-46);}.cls-77{fill:url(#radial-gradient-14);}.cls-78{fill:url(#radial-gradient-15);}.cls-79{fill:url(#radial-gradient-16);}.cls-80{fill:url(#radial-gradient-17);}.cls-81{fill:url(#radial-gradient-18);}.cls-82{fill:url(#linear-gradient-47);}.cls-84{fill:gray;}.cls-85{fill:#8c8c8c;}.cls-86{fill:#979797;}.cls-87{fill:#a3a3a3;}.cls-88{fill:#aeaeae;}.cls-89{fill:#bababa;}.cls-90{fill:#c5c5c5;}.cls-91{fill:#d1d1d1;}.cls-92{fill:#dcdcdc;}.cls-93{fill:#e8e8e8;}.cls-350,.cls-94{fill:#f3f3f3;}.cls-132,.cls-138,.cls-172,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-209,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-218,.cls-219,.cls-466,.cls-95{fill:#fff;}.cls-96{fill:url(#radial-gradient-19);}.cls-97{fill:url(#radial-gradient-20);}.cls-98{fill:url(#radial-gradient-21);}.cls-99{fill:url(#radial-gradient-22);}.cls-100{fill:url(#linear-gradient-48);}.cls-101{fill:url(#radial-gradient-23);}.cls-102{fill:url(#linear-gradient-49);}.cls-103{fill:url(#linear-gradient-50);}.cls-104{fill:url(#linear-gradient-51);}.cls-105{fill:url(#linear-gradient-52);}.cls-106{fill:url(#linear-gradient-53);}.cls-107{fill:url(#linear-gradient-54);}.cls-108{fill:url(#linear-gradient-55);}.cls-109{fill:url(#linear-gradient-56);}.cls-110{fill:url(#linear-gradient-57);}.cls-111{fill:url(#linear-gradient-58);}.cls-112{fill:url(#linear-gradient-59);}.cls-113{fill:url(#linear-gradient-60);}.cls-114{fill:url(#linear-gradient-61);}.cls-115{fill:#868688;}.cls-116{fill:#8c8c8e;}.cls-117{fill:#939393;}.cls-118{fill:#999998;}.cls-119{fill:#a0a09e;}.cls-120{fill:#a6a6a3;}.cls-121{fill:#adada9;}.cls-122{fill:#b3b3ae;}.cls-123{fill:#babab3;}.cls-124{fill:#c0c0b9;}.cls-125{fill:#c7c7be;}.cls-126{fill:url(#linear-gradient-62);}.cls-127{fill:url(#linear-gradient-63);}.cls-128,.cls-313,.cls-500{mix-blend-mode:hard-light;}.cls-128{fill:url(#linear-gradient-64);}.cls-129{fill:url(#linear-gradient-65);}.cls-130{fill:url(#linear-gradient-66);}.cls-131{fill:url(#linear-gradient-67);}.cls-133{fill:url(#linear-gradient-68);}.cls-134{fill:#232628;}.cls-135{fill:#637771;}.cls-136{fill:url(#radial-gradient-24);}.cls-137{fill:url(#linear-gradient-69);}.cls-139{fill:#f1f1f1;}.cls-140{fill:#e4e4e4;}.cls-141{fill:#d6d6d6;}.cls-142{fill:#c8c8c8;}.cls-143{fill:#bbb;}.cls-144{fill:#adadad;}.cls-145{fill:#a0a0a0;}.cls-146{fill:#929292;}.cls-147{fill:#848484;}.cls-148{fill:#777;}.cls-149{fill:#696969;}.cls-150{fill:#b74700;}.cls-151{fill:#b94a00;}.cls-152{fill:#bb4d00;}.cls-153{fill:#bc5000;}.cls-154{fill:#be5300;}.cls-155{fill:#c05600;}.cls-156{fill:#c25900;}.cls-157{fill:#c45c00;}.cls-158{fill:#c55f00;}.cls-159{fill:#c76200;}.cls-160{fill:#c96500;}.cls-161{fill:#cb6800;}.cls-162{fill:#cd6b00;}.cls-163{fill:#cf6e00;}.cls-164{fill:#d07100;}.cls-165{fill:#d27400;}.cls-166{fill:#d47700;}.cls-167{fill:#d67a00;}.cls-168{fill:#d87d00;}.cls-169{fill:#d98000;}.cls-170{fill:#db8300;}.cls-171{fill:#dd8600;}.cls-172,.cls-212,.cls-580,.cls-583,.cls-584{opacity:0.5;}.cls-174{fill:url(#linear-gradient-70);}.cls-175{fill:url(#linear-gradient-71);}.cls-176{fill:url(#linear-gradient-72);}.cls-177{fill:url(#linear-gradient-73);}.cls-178{fill:url(#linear-gradient-74);}.cls-179{fill:url(#linear-gradient-75);}.cls-180{fill:url(#linear-gradient-76);}.cls-181{fill:url(#linear-gradient-77);}.cls-182{fill:url(#linear-gradient-78);}.cls-183{fill:url(#linear-gradient-79);}.cls-184{fill:url(#linear-gradient-80);}.cls-185{fill:url(#linear-gradient-81);}.cls-186{fill:url(#linear-gradient-82);}.cls-187{fill:#a8b3af;}.cls-188{fill:#282b2d;}.cls-189{fill:#26292b;}.cls-190{fill:#24282a;}.cls-191{fill:#212426;}.cls-192{fill:#1f2224;}.cls-193{fill:#1d2123;}.cls-194{fill:#1b1f21;}.cls-195{fill:#1a1d1f;}.cls-196{fill:#181b1d;}.cls-197{fill:#161a1c;}.cls-198{fill:#14181a;}.cls-199{fill:#121618;}.cls-200{fill:#101416;}.cls-201{fill:#0f1215;}.cls-202{fill:#0d1113;}.cls-203{fill:#0b0f11;}.cls-204{opacity:0;}.cls-205{opacity:0.06;}.cls-206{opacity:0.13;}.cls-207{opacity:0.19;}.cls-208{opacity:0.25;}.cls-209{opacity:0.31;}.cls-210{opacity:0.38;}.cls-211{opacity:0.44;}.cls-213{opacity:0.56;}.cls-214{opacity:0.63;}.cls-215{opacity:0.69;}.cls-216{opacity:0.75;}.cls-217{opacity:0.81;}.cls-218{opacity:0.88;}.cls-219{opacity:0.94;}.cls-220{clip-path:url(#clip-path);}.cls-221{clip-path:url(#clip-path-2);}.cls-222{clip-path:url(#clip-path-3);}.cls-223{clip-path:url(#clip-path-4);}.cls-224{clip-path:url(#clip-path-5);}.cls-225{clip-path:url(#clip-path-6);}.cls-226{fill:url(#radial-gradient-25);}.cls-227{fill:url(#radial-gradient-26);}.cls-228{fill:url(#radial-gradient-27);}.cls-229{fill:url(#radial-gradient-28);}.cls-230{fill:url(#radial-gradient-29);}.cls-231{fill:url(#linear-gradient-83);}.cls-232{fill:url(#linear-gradient-84);}.cls-233{fill:url(#linear-gradient-85);}.cls-234{fill:url(#linear-gradient-86);}.cls-235{fill:url(#linear-gradient-87);}.cls-236{fill:url(#linear-gradient-88);}.cls-237{fill:url(#linear-gradient-89);}.cls-238{fill:url(#linear-gradient-90);}.cls-239{fill:url(#linear-gradient-91);}.cls-240{fill:url(#linear-gradient-92);}.cls-241{fill:url(#linear-gradient-93);}.cls-242{fill:url(#linear-gradient-94);}.cls-243{fill:url(#linear-gradient-95);}.cls-244{fill:url(#radial-gradient-30);}.cls-245{fill:url(#radial-gradient-31);}.cls-246{fill:url(#radial-gradient-32);}.cls-247{fill:url(#linear-gradient-96);}.cls-248{fill:url(#linear-gradient-97);}.cls-249{fill:url(#linear-gradient-98);}.cls-250{fill:url(#linear-gradient-99);}.cls-251{fill:url(#linear-gradient-100);}.cls-252{fill:url(#linear-gradient-101);}.cls-253{fill:url(#linear-gradient-102);}.cls-254{fill:url(#linear-gradient-103);}.cls-255{fill:url(#linear-gradient-104);}.cls-256{fill:url(#linear-gradient-105);}.cls-257{fill:url(#radial-gradient-33);}.cls-258{fill:url(#radial-gradient-34);}.cls-259{fill:url(#radial-gradient-35);}.cls-260{fill:url(#radial-gradient-36);}.cls-261{fill:url(#linear-gradient-106);}.cls-262{fill:url(#radial-gradient-37);}.cls-263{fill:url(#linear-gradient-107);}.cls-264{fill:url(#linear-gradient-108);}.cls-265{fill:url(#linear-gradient-109);}.cls-266{fill:url(#linear-gradient-110);}.cls-267{fill:url(#linear-gradient-111);}.cls-268{fill:url(#linear-gradient-112);}.cls-269{fill:url(#linear-gradient-113);}.cls-270{fill:url(#linear-gradient-114);}.cls-271{fill:url(#linear-gradient-115);}.cls-272{fill:url(#linear-gradient-116);}.cls-273{fill:url(#linear-gradient-117);}.cls-274{fill:url(#linear-gradient-118);}.cls-275{fill:url(#linear-gradient-119);}.cls-276{fill:url(#linear-gradient-120);}.cls-277{fill:url(#linear-gradient-121);}.cls-278{fill:url(#linear-gradient-122);}.cls-279{fill:url(#linear-gradient-123);}.cls-280{fill:url(#linear-gradient-124);}.cls-281{fill:url(#linear-gradient-125);}.cls-282{fill:url(#linear-gradient-126);}.cls-283{fill:url(#linear-gradient-127);}.cls-284{fill:url(#linear-gradient-128);}.cls-285{fill:url(#linear-gradient-129);}.cls-286{fill:url(#radial-gradient-38);}.cls-287{fill:url(#radial-gradient-39);}.cls-288{fill:url(#radial-gradient-40);}.cls-289{fill:url(#radial-gradient-41);}.cls-290{fill:url(#radial-gradient-42);}.cls-291{fill:url(#linear-gradient-130);}.cls-292{fill:url(#radial-gradient-43);}.cls-293{fill:url(#radial-gradient-44);}.cls-294{fill:url(#radial-gradient-45);}.cls-295{fill:url(#radial-gradient-46);}.cls-296{fill:url(#linear-gradient-131);}.cls-297{fill:url(#radial-gradient-47);}.cls-298{fill:url(#linear-gradient-132);}.cls-299{fill:url(#linear-gradient-133);}.cls-300{fill:url(#linear-gradient-134);}.cls-301{fill:url(#linear-gradient-135);}.cls-302{fill:url(#linear-gradient-136);}.cls-303{fill:url(#linear-gradient-137);}.cls-304{fill:url(#linear-gradient-138);}.cls-305{fill:url(#linear-gradient-139);}.cls-306{fill:url(#linear-gradient-140);}.cls-307{fill:url(#linear-gradient-141);}.cls-308{fill:url(#linear-gradient-142);}.cls-309{fill:url(#linear-gradient-143);}.cls-310{fill:url(#linear-gradient-144);}.cls-311{fill:url(#linear-gradient-145);}.cls-312{fill:url(#linear-gradient-146);}.cls-313{fill:url(#linear-gradient-147);}.cls-314{fill:url(#linear-gradient-148);}.cls-315{fill:url(#linear-gradient-149);}.cls-316{fill:url(#linear-gradient-150);}.cls-317{fill:url(#linear-gradient-151);}.cls-318{fill:url(#radial-gradient-48);}.cls-319{fill:url(#linear-gradient-152);}.cls-320{fill:url(#linear-gradient-153);}.cls-321{fill:url(#linear-gradient-154);}.cls-322{fill:url(#linear-gradient-155);}.cls-323{fill:url(#linear-gradient-156);}.cls-324{fill:url(#linear-gradient-157);}.cls-325{fill:url(#linear-gradient-158);}.cls-326{fill:url(#linear-gradient-159);}.cls-327{fill:url(#linear-gradient-160);}.cls-328{fill:url(#linear-gradient-161);}.cls-329{fill:url(#linear-gradient-162);}.cls-330{fill:url(#linear-gradient-163);}.cls-331{fill:url(#linear-gradient-164);}.cls-332{fill:url(#linear-gradient-165);}.cls-333{clip-path:url(#clip-path-7);}.cls-334{clip-path:url(#clip-path-8);}.cls-335{clip-path:url(#clip-path-9);}.cls-336{clip-path:url(#clip-path-10);}.cls-337{clip-path:url(#clip-path-11);}.cls-338{clip-path:url(#clip-path-12);}.cls-339{fill:#fefefe;}.cls-340{fill:#fdfdfd;}.cls-341{fill:#fcfcfc;}.cls-342{fill:#fbfbfb;}.cls-343{fill:#fafafa;}.cls-344{fill:#f9f9f9;}.cls-345{fill:#f8f8f8;}.cls-346{fill:#f7f7f7;}.cls-347{fill:#f6f6f6;}.cls-348{fill:#f5f5f5;}.cls-349{fill:#f4f4f4;}.cls-351{fill:#f2f2f2;}.cls-352{fill:#f0f0f0;}.cls-353{fill:#efefef;}.cls-354{fill:#eee;}.cls-355{fill:#edeced;}.cls-356{fill:#ecebec;}.cls-357{fill:#ebeaeb;}.cls-358{fill:#eae9ea;}.cls-359{fill:#e9e8e9;}.cls-360{fill:#e8e7e8;}.cls-361{fill:#e7e6e7;}.cls-362{fill:#e6e5e6;}.cls-363{fill:#e5e4e5;}.cls-364{fill:#e4e3e4;}.cls-365{fill:#e3e2e3;}.cls-366{fill:#e2e1e2;}.cls-367{fill:#e1e0e1;}.cls-368{fill:#e0dfe0;}.cls-369{fill:#dfdedf;}.cls-370{fill:#deddde;}.cls-371{fill:#dddcdd;}.cls-372{fill:#dcdbdc;}.cls-373{fill:#dbdadc;}.cls-374{fill:#dad9db;}.cls-375{fill:#d9d8da;}.cls-376{fill:#d8d7d9;}.cls-377{fill:#d7d6d8;}.cls-378{fill:#d6d5d7;}.cls-379{fill:#d5d4d6;}.cls-380{fill:#d4d3d5;}.cls-381{fill:#d3d2d4;}.cls-382{fill:#d2d1d3;}.cls-383{fill:#d1d0d2;}.cls-384{fill:#d0cfd1;}.cls-385{fill:#cfced0;}.cls-386{fill:#cecdcf;}.cls-387{fill:#cdccce;}.cls-388{fill:#cccbcd;}.cls-389{fill:#cbcacc;}.cls-390{fill:#cac9cb;}.cls-391{fill:#c9c7ca;}.cls-392{fill:#c8c6c9;}.cls-393{fill:#c7c5c8;}.cls-394{fill:#c6c4c7;}.cls-395{fill:#c5c3c6;}.cls-396{fill:#c4c2c5;}.cls-397{fill:#c3c1c4;}.cls-398{fill:#c2c0c3;}.cls-399{fill:#c1bfc2;}.cls-400{fill:#c0bec1;}.cls-401{fill:#bfbdc0;}.cls-402{fill:#bebcbf;}.cls-403{fill:#bdbbbe;}.cls-404{fill:#bcbabd;}.cls-405{fill:#bbb9bc;}.cls-406{fill:#bab8bb;}.cls-407{fill:#b9b7ba;}.cls-408{fill:#b8b6b9;}.cls-409{fill:url(#radial-gradient-49);}.cls-410{fill:url(#radial-gradient-50);}.cls-411{fill:url(#linear-gradient-166);}.cls-412{fill:url(#linear-gradient-167);}.cls-413{fill:#191c20;}.cls-414{fill:url(#linear-gradient-168);}.cls-415{fill:url(#linear-gradient-169);}.cls-416{fill:url(#linear-gradient-170);}.cls-417{fill:url(#linear-gradient-171);}.cls-418{fill:#e6e6e6;}.cls-419{fill:#727476;}.cls-420{fill:url(#linear-gradient-172);}.cls-421{fill:url(#linear-gradient-173);}.cls-422{fill:url(#linear-gradient-174);}.cls-423{fill:url(#linear-gradient-175);}.cls-424{fill:url(#linear-gradient-176);}.cls-425{fill:url(#linear-gradient-177);}.cls-426{fill:url(#linear-gradient-178);}.cls-427{fill:url(#linear-gradient-179);}.cls-428{fill:url(#linear-gradient-180);}.cls-429{fill:url(#linear-gradient-181);}.cls-430{fill:url(#linear-gradient-182);}.cls-431{fill:url(#linear-gradient-183);}.cls-432{fill:url(#linear-gradient-184);}.cls-433{fill:url(#radial-gradient-51);}.cls-434{fill:url(#radial-gradient-52);}.cls-435{fill:url(#linear-gradient-185);}.cls-436{fill:url(#linear-gradient-186);}.cls-437{fill:url(#radial-gradient-53);}.cls-438{fill:url(#radial-gradient-54);}.cls-439{fill:url(#linear-gradient-187);}.cls-440{fill:url(#linear-gradient-188);}.cls-441{fill:url(#radial-gradient-55);}.cls-442{fill:url(#radial-gradient-56);}.cls-443{fill:url(#linear-gradient-189);}.cls-444{fill:url(#linear-gradient-190);}.cls-445{fill:url(#linear-gradient-191);}.cls-446{fill:url(#linear-gradient-192);}.cls-447{fill:url(#linear-gradient-193);}.cls-448{fill:url(#radial-gradient-57);}.cls-449{fill:url(#radial-gradient-58);}.cls-450{fill:url(#linear-gradient-194);}.cls-451{fill:url(#linear-gradient-195);}.cls-452{fill:url(#radial-gradient-59);}.cls-453{fill:url(#radial-gradient-60);}.cls-454{fill:url(#linear-gradient-196);}.cls-455{fill:url(#linear-gradient-197);}.cls-456{fill:url(#radial-gradient-61);}.cls-457{fill:url(#radial-gradient-62);}.cls-458{fill:url(#linear-gradient-198);}.cls-459{fill:url(#linear-gradient-199);}.cls-460{fill:url(#linear-gradient-200);}.cls-461{fill:url(#linear-gradient-201);}.cls-462,.cls-467{fill:#bd0000;}.cls-463{fill:#e50000;}.cls-464{fill:#e55400;}.cls-465{fill:url(#linear-gradient-202);}.cls-466{opacity:0.2;}.cls-468{fill:#ffc94f;}.cls-469{fill:url(#linear-gradient-203);}.cls-470{fill:url(#linear-gradient-204);}.cls-471{fill:url(#linear-gradient-205);}.cls-472{fill:url(#linear-gradient-206);}.cls-473{fill:url(#linear-gradient-207);}.cls-474{fill:url(#radial-gradient-63);}.cls-475{fill:url(#radial-gradient-64);}.cls-476{fill:url(#linear-gradient-208);}.cls-477{clip-path:url(#clip-path-13);}.cls-478{clip-path:url(#clip-path-14);}.cls-479{clip-path:url(#clip-path-15);}.cls-480{clip-path:url(#clip-path-16);}.cls-481{clip-path:url(#clip-path-17);}.cls-482{clip-path:url(#clip-path-18);}.cls-483{fill:url(#linear-gradient-209);}.cls-484{fill:url(#linear-gradient-210);}.cls-485{fill:url(#linear-gradient-211);}.cls-486{fill:url(#linear-gradient-212);}.cls-487{fill:url(#linear-gradient-213);}.cls-488{fill:url(#linear-gradient-214);}.cls-489{fill:url(#linear-gradient-215);}.cls-490{fill:url(#linear-gradient-216);}.cls-491{fill:url(#linear-gradient-217);}.cls-492{fill:url(#linear-gradient-218);}.cls-493{fill:url(#linear-gradient-219);}.cls-494{fill:url(#linear-gradient-220);}.cls-495{fill:url(#linear-gradient-221);}.cls-496{fill:url(#linear-gradient-222);}.cls-497{fill:url(#linear-gradient-223);}.cls-498{fill:url(#linear-gradient-224);}.cls-499{fill:url(#linear-gradient-225);}.cls-500{fill:url(#linear-gradient-226);}.cls-501{fill:url(#linear-gradient-227);}.cls-502{fill:url(#linear-gradient-228);}.cls-503{fill:url(#linear-gradient-229);}.cls-504{fill:url(#linear-gradient-230);}.cls-505{fill:url(#linear-gradient-231);}.cls-506{fill:url(#radial-gradient-65);}.cls-507{fill:url(#linear-gradient-232);}.cls-508{fill:url(#linear-gradient-233);}.cls-509{fill:url(#linear-gradient-234);}.cls-510{fill:url(#linear-gradient-235);}.cls-511{fill:url(#linear-gradient-236);}.cls-512{fill:#5b5d60;}.cls-513{fill:#eaeaea;}.cls-514{fill:#e2e2e2;}.cls-515{fill:#dbdbdb;}.cls-516{fill:#d4d4d4;}.cls-517{fill:#cdcdcd;}.cls-518{fill:#c6c6c6;}.cls-519{fill:#bfbfbf;}.cls-520{fill:#b8b8b8;}.cls-521{fill:#b0b0b0;}.cls-522{fill:#a9a9a9;}.cls-523{fill:#a2a2a2;}.cls-524{fill:#9b9b9b;}.cls-525{fill:#949494;}.cls-526{fill:#8d8d8d;}.cls-527{fill:#868686;}.cls-528{fill:#7e7e7e;}.cls-529{fill:#707070;}.cls-530{fill:url(#linear-gradient-237);}.cls-531{fill:url(#linear-gradient-238);}.cls-532{fill:url(#linear-gradient-239);}.cls-533{fill:url(#linear-gradient-240);}.cls-534{fill:url(#linear-gradient-241);}.cls-535{fill:url(#linear-gradient-242);}.cls-536{fill:url(#linear-gradient-243);}.cls-537{fill:url(#linear-gradient-244);}.cls-538{fill:url(#linear-gradient-245);}.cls-539{fill:url(#linear-gradient-246);}.cls-540{fill:url(#linear-gradient-247);}.cls-541{fill:url(#linear-gradient-248);}.cls-542{fill:url(#linear-gradient-249);}.cls-543{fill:url(#linear-gradient-250);}.cls-544{fill:url(#linear-gradient-251);}.cls-545{fill:url(#linear-gradient-252);}.cls-546{fill:url(#linear-gradient-253);}.cls-547{fill:url(#linear-gradient-254);}.cls-548{fill:url(#linear-gradient-255);}.cls-549{fill:url(#linear-gradient-256);}.cls-550{fill:url(#linear-gradient-257);}.cls-551{fill:#ddd;}.cls-552{fill:url(#linear-gradient-258);}.cls-553{fill:url(#linear-gradient-259);}.cls-554{fill:url(#linear-gradient-260);}.cls-555{fill:url(#linear-gradient-261);}.cls-556{fill:url(#linear-gradient-262);}.cls-557{fill:url(#linear-gradient-263);}.cls-558{fill:url(#linear-gradient-264);}.cls-559{fill:url(#linear-gradient-265);}.cls-560{fill:url(#linear-gradient-266);}.cls-561{fill:url(#linear-gradient-267);}.cls-562{fill:url(#linear-gradient-268);}.cls-563{fill:url(#linear-gradient-269);}.cls-564{fill:url(#linear-gradient-270);}.cls-565{fill:url(#linear-gradient-271);}.cls-566{fill:url(#linear-gradient-272);}.cls-567{fill:url(#linear-gradient-273);}.cls-568{fill:url(#linear-gradient-274);}.cls-569{fill:url(#linear-gradient-275);}.cls-570{fill:url(#linear-gradient-276);}.cls-571{fill:url(#linear-gradient-277);}.cls-572{fill:url(#linear-gradient-278);}.cls-573{clip-path:url(#clip-path-19);}.cls-574{clip-path:url(#clip-path-20);}.cls-575{clip-path:url(#clip-path-21);}.cls-576{clip-path:url(#clip-path-22);}.cls-577{clip-path:url(#clip-path-23);}.cls-578{clip-path:url(#clip-path-24);}.cls-579{fill:url(#linear-gradient-279);}.cls-580{fill:url(#linear-gradient-280);}.cls-581{clip-path:url(#clip-path-25);}.cls-582{fill:#b3b3b5;}.cls-583{fill:url(#linear-gradient-281);}.cls-584{fill:url(#linear-gradient-282);}.cls-585{fill:#a0a1a5;}.cls-586{fill:url(#linear-gradient-283);}.cls-587{fill:url(#linear-gradient-284);}.cls-588{fill:url(#radial-gradient-66);}.cls-589{fill:url(#linear-gradient-285);}.cls-590{fill:#0f1216;}.cls-591{fill:url(#radial-gradient-67);}.cls-592{fill:url(#linear-gradient-286);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 243.65,
    cy: 145.95,
    r: 19.47,
    gradientTransform: "translate(-1788.36 254.87) scale(7.98 0.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#babbb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#bfc0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#cdcecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 4194.89,
    cy: -195.24,
    r: 19.46,
    gradientTransform: "translate(-4132.45 384.22) scale(1 0.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#313230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6e706e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a2a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#cacbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 4203.65,
    cy: -218.17,
    r: 19.46,
    gradientTransform: "translate(-4132.45 384.22) scale(1 0.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6f706e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#a2a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#cacbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 4357.75,
    cy: -194.41,
    r: 19.46,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 4350.39,
    cy: -208.73,
    r: 19.46,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 284.68,
    y1: 300.71,
    x2: 301.93,
    y2: 300.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1d2022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#000102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#25282a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2170.11,
    y1: 307.84,
    x2: 2170.11,
    y2: 303.61,
    gradientTransform: "translate(-1867.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#7d7d7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5f5f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#4d4d4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#464644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#484846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#d3d3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#c6c6c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#a3a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6c6c6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555553"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -3069.29,
    cy: 310.07,
    r: 18.31,
    gradientTransform: "matrix(-0.23, -0.97, -0.97, 0.23, -178.64, -2749.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#050503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -3069.29,
    cy: 310.07,
    r: 18.67,
    gradientTransform: "matrix(-1, 0, 0, 1, -2850.14, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#020200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#050503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#10100f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161615"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -3069.29,
    cy: 310.07,
    r: 12.97,
    gradientTransform: "matrix(-1, 0, 0, 1, -2850.14, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#d6d6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#cbcbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b9b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a0a09e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#828280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#80807e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#787876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6b6b69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#595957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4f4f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#545452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#60605f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#646463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0c0c0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#131311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 250.57,
    y1: 298.82,
    x2: 250.57,
    y2: 311.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2887.45,
    y1: -4265.53,
    x2: -2886.19,
    y2: -4265.53,
    gradientTransform: "matrix(1, 0, 0, -1.49, 3062.21, -6070.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#555553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6c6c6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a3a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c6c6c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#d3d3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#484846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#464644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#4d4d4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#5f5f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#7d7d7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -2888.68,
    y1: -4245.96,
    x2: -2884.96,
    y2: -4245.96,
    gradientTransform: "matrix(1, 0, 0, -1.49, 3089.94, -6034.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#555553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#5d5d5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#747472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#999998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#a3a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#464644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4d4d4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5f5f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7d7d7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 145.3,
    y1: 290.55,
    x2: 145.3,
    y2: 302.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 145.3,
    y1: 299.42,
    x2: 145.3,
    y2: 302.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 251.89,
    y1: 291.78,
    x2: 251.89,
    y2: 299.18,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 251.89,
    y1: 297.38,
    x2: 251.89,
    y2: 299.17,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 10710.64,
    y1: 294.3,
    x2: 10710.64,
    y2: 301.89,
    gradientTransform: "matrix(-1, 0, 0, 1, 10934.55, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7c7e7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a9a9a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 10685.68,
    y1: 304.02,
    x2: 10735.2,
    y2: 304.02,
    gradientTransform: "matrix(-1, 0, 0, 1, 10934.55, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#70726f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a7adab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#bdc4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#bec5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#d1d3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#d4d7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d1d6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c6cbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#a9acaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7b7b78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#777774"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 10688.29,
    y1: 305.27,
    x2: 10732.83,
    y2: 305.27,
    gradientTransform: "matrix(-1, 0, 0, 1, 10934.55, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f2f2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 10710.45,
    cy: 315.06,
    r: 18.12,
    gradientTransform: "matrix(-1, 0, 0, 1, 10934.55, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 10710.45,
    cy: 315.06,
    r: 18.47,
    gradientTransform: "matrix(-1, 0, 0, 1, 10934.55, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#282826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#363635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 10710.45,
    cy: 315.06,
    r: 11.45,
    gradientTransform: "matrix(-1, 0, 0, 1, 10934.55, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#020200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#020200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#020200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0a0a08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#21211f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#464645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#575756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0c0c0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#131311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 10710.45,
    cy: 315.06,
    r: 3.46,
    gradientTransform: "matrix(-1, 0, 0, 1, 10934.55, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 10708.82,
    y1: 313.94,
    x2: 10712.78,
    y2: 316.68,
    gradientTransform: "matrix(-1, 0, 0, 1, 10934.55, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0b0b0b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 10710.41,
    cy: 315.06,
    r: 1.77,
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 10709.85,
    y1: 309.87,
    x2: 10711.18,
    y2: 310.79,
    gradientTransform: "matrix(-1, 0, 0, 1, 10934.55, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 10710.04,
    y1: 310,
    x2: 10710.92,
    y2: 310.6,
    gradientTransform: "matrix(-1, 0, 0, 1, 10934.55, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 10709.87,
    y1: 319.5,
    x2: 10711.2,
    y2: 320.43,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 10710.06,
    y1: 319.63,
    x2: 10710.94,
    y2: 320.24,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 10705.68,
    y1: 312.28,
    x2: 10707.02,
    y2: 313.21,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 10705.87,
    y1: 312.41,
    x2: 10706.75,
    y2: 313.02,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 10714.04,
    y1: 317.09,
    x2: 10715.37,
    y2: 318.01,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 10714.23,
    y1: 317.22,
    x2: 10715.1,
    y2: 317.82,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 10705.69,
    y1: 317.1,
    x2: 10707.03,
    y2: 318.03,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 10705.88,
    y1: 317.23,
    x2: 10706.76,
    y2: 317.84,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 10714.03,
    y1: 312.27,
    x2: 10715.36,
    y2: 313.19,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 10714.22,
    y1: 312.4,
    x2: 10715.09,
    y2: 313.01,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 99.33,
    y1: 302.16,
    x2: 99.33,
    y2: 311.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 137.62,
    y1: 294.84,
    x2: 137.62,
    y2: 311.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#80807f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6f6f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#585857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#494948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 137.62,
    y1: 302.38,
    x2: 137.62,
    y2: 303.11,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 137.62,
    y1: 303.1,
    x2: 137.62,
    y2: 303.83,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 113.64,
    y1: 303.11,
    x2: 115.56,
    y2: 303.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 12693.83,
    y1: 303.11,
    x2: 12695.74,
    y2: 303.11,
    gradientTransform: "matrix(1, 0, 0, -1, -12533.96, 606.22)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 116.68,
    y1: 294.84,
    x2: 116.68,
    y2: 311.31,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 158.49,
    y1: 294.84,
    x2: 158.49,
    y2: 311.31,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 117.34,
    y1: 303.11,
    x2: 118.08,
    y2: 303.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#93a49e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a6b4af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c2cbc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#d8dfdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#eaedec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 159.14,
    y1: 303.11,
    x2: 159.88,
    y2: 303.11,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 12753.99,
    y1: 303.11,
    x2: 12754.73,
    y2: 303.11,
    gradientTransform: "matrix(1, 0, 0, -1, -12638.65, 606.22)",
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 12712.18,
    y1: 303.11,
    x2: 12712.93,
    y2: 303.11,
    gradientTransform: "matrix(1, 0, 0, -1, -12555.03, 606.22)",
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 196.18,
    y1: 186.84,
    x2: 196.18,
    y2: 289.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#cacac9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d9dad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e4e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#eaedec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ecefee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#dededd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#dadad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d3d4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#c8cac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bec1bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b7bbb7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 261.6,
    y1: 295.97,
    x2: 263.54,
    y2: 295.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b7bbb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#bec1bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#c8cac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#d3d4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#dadad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#dededd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ecefee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#eaedec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#e4e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d9dad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#cacac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 288.93,
    y1: 295.97,
    x2: 290.87,
    y2: 295.97,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 277.84,
    y1: 297.81,
    x2: 277.84,
    y2: 299.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 151.4,
    y1: 296.38,
    x2: 153.54,
    y2: 296.38,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 190.29,
    y1: 296.38,
    x2: 192.43,
    y2: 296.38,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 172.09,
    y1: 298.52,
    x2: 172.09,
    y2: 300.55,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 192.12,
    y1: 290.06,
    x2: 192.12,
    y2: 296.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 196.93,
    y1: 290.47,
    x2: 196.93,
    y2: 301.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#858c85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#979c97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#b5b8b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#cbccca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#dededd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ecefee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#eaedec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#e4e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d9dad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#cacac9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: -2915.17,
    cy: 304.7,
    r: 20.12,
    gradientTransform: "matrix(-1, 0, 0, 1, -2850.14, 0)",
    xlinkHref: "#radial-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: -2915.17,
    cy: 304.7,
    r: 20.51,
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: -2915.17,
    cy: 304.7,
    r: 14.25,
    xlinkHref: "#radial-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 57.44,
    cy: 310.64,
    r: 21.13,
    gradientTransform: "translate(112.75 595.46) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#090908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#191918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 61.35,
    cy: 261.65,
    r: 24.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#bbbaba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#a6a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#999797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 7.95,
    y1: 264.62,
    x2: 84.41,
    y2: 264.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7bbb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdc1be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d2d6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#e1e4e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#e9eceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ecefee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#dededd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#dadad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d3d4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#c8cac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bec1bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b7bbb7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: -3032.46,
    cy: 315.28,
    r: 18.09,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: -3032.46,
    cy: 315.28,
    r: 18.44,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: -3032.46,
    cy: 315.28,
    r: 11.43,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: -3032.46,
    cy: 315.28,
    r: 3.45,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -3034.08,
    y1: 314.15,
    x2: -3030.14,
    y2: 316.89,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: -3032.5,
    cy: 315.28,
    r: 1.77,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -3033.06,
    y1: 310.09,
    x2: -3031.73,
    y2: 311.01,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -3032.87,
    y1: 310.22,
    x2: -3032,
    y2: 310.83,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -3033.04,
    y1: 319.71,
    x2: -3031.71,
    y2: 320.63,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -3032.85,
    y1: 319.84,
    x2: -3031.98,
    y2: 320.45,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -3037.22,
    y1: 312.5,
    x2: -3035.89,
    y2: 313.43,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -3037.03,
    y1: 312.63,
    x2: -3036.16,
    y2: 313.24,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -3028.88,
    y1: 317.3,
    x2: -3027.55,
    y2: 318.22,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -3028.69,
    y1: 317.43,
    x2: -3027.82,
    y2: 318.03,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -3037.21,
    y1: 317.31,
    x2: -3035.88,
    y2: 318.24,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -3037.02,
    y1: 317.44,
    x2: -3036.15,
    y2: 318.05,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -3028.89,
    y1: 312.49,
    x2: -3027.56,
    y2: 313.41,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -3028.7,
    y1: 312.62,
    x2: -3027.83,
    y2: 313.22,
    gradientTransform: "matrix(-1, 0, 0, 1, -2971.77, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -936.22,
    y1: 232.13,
    x2: -916.55,
    y2: 232.5,
    gradientTransform: "matrix(-0.66, 0.04, 0.02, 1, -604.68, 111.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0c0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1d2527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2e3536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#5c5e5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#727271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#707170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#6b706f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#616563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#464644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -923.53,
    y1: 239.68,
    x2: -923.53,
    y2: 234.86,
    gradientTransform: "matrix(-0.66, 0.04, 0.02, 1, -604.68, 111.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5c5c59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8e8e8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#b6b6b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d6d6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ededec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -936.09,
    y1: 225.32,
    x2: -916.64,
    y2: 225.69,
    gradientTransform: "matrix(-0.66, 0.04, 0.02, 1, -604.68, 111.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#959393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#999797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#a6a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#bbbaba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 16.2,
    y1: 307.86,
    x2: 15.33,
    y2: 307.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b1aeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#a7a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#919090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 29.43,
    y1: 298.65,
    x2: 29.43,
    y2: 315.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#464644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#616563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6b706f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#363838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#202121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#191a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#080909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 16.21,
    y1: 307.18,
    x2: 20.23,
    y2: 307.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 33.78,
    y1: 307.18,
    x2: 42.56,
    y2: 307.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#989897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#777776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#626261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b5b5a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 37.34,
    y1: 306.39,
    x2: 42.59,
    y2: 308.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#464644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#616563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6b706f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#707170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#727271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5c5e5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2e3536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1d2527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0c0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 2114.51,
    cy: 266.07,
    r: 4.99,
    gradientTransform: "translate(-2048.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 2113.86,
    y1: 267.08,
    x2: 2113.86,
    y2: 265.11,
    gradientTransform: "translate(-2048.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#171716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#282826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#363635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 13828.64,
    y1: -209.27,
    x2: 13834.52,
    y2: -209.27,
    gradientTransform: "matrix(-1, 0.08, 0.08, 1, 13814.42, -601.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#636360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7c7c7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#a4a4a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d9d9d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -14523.1,
    y1: -208.71,
    x2: -14522.39,
    y2: -208.71,
    gradientTransform: "translate(14502.15 -657.2) rotate(-4.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -14523.09,
    y1: -208.55,
    x2: -14520,
    y2: -209.94,
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 15021.15,
    y1: -207.23,
    x2: 15023.06,
    y2: -210.46,
    gradientTransform: "matrix(-1, 0.08, 0.08, 1, 14999.08, -696.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5bfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 15017.67,
    y1: -209.47,
    x2: 15022.92,
    y2: -209.47,
    gradientTransform: "matrix(-1, 0.08, 0.08, 1, 14999.08, -696.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 13880.48,
    y1: 320.18,
    x2: 13881.02,
    y2: 320.18,
    gradientTransform: "matrix(-1, 0.04, 0.04, 1, 13866.58, -615.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b6b6a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 13829.99,
    y1: -208.02,
    x2: 13830.53,
    y2: -208.02,
    gradientTransform: "matrix(-1, 0.08, 0.08, 1, 13814.42, -601.95)",
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 13828.64,
    y1: -209.39,
    x2: 13834.52,
    y2: -209.39,
    gradientTransform: "matrix(-1, 0.08, 0.08, 1, 13814.42, -601.95)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 13828.64,
    y1: -209.27,
    x2: 13834.5,
    y2: -209.27,
    gradientTransform: "matrix(-1, 0.08, 0.08, 1, 13814.42, -601.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2d2d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d5d5d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d9d9d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 65,
    y1: 294.19,
    x2: 96.58,
    y2: 318.43,
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 77.14,
    y1: 290.38,
    x2: 77.14,
    y2: 291.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#bababa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 56.87,
    y1: 224.59,
    x2: 57.43,
    y2: 229.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#bbbaba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a6a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#999797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 19.48,
    y1: 247.98,
    x2: 70.18,
    y2: 247.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#637771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a19d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.69,254.85h-.91a.3.3,0,0,1,0-.59h.91Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.72,254.26h.9a.3.3,0,0,1,0,.59h-.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.08,270v1.76a.3.3,0,1,1-.59,0V270Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,248.47l1.76-.17a.29.29,0,0,1,.32.26.31.31,0,0,1-.27.32l-1.75.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.17,270l.14,1.76a.3.3,0,1,1-.59.05L20.58,270Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,250.5l.06,0a.29.29,0,0,1,.14.57h-.08Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 242.87,
    cy: -200.44,
    r: 19.47,
    gradientTransform: "matrix(-7.98, 0, 0, 0.54, 2105.4, 254.87)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 4188.73,
    cy: -899.59,
    r: 19.46,
    gradientTransform: "matrix(-1, 0, 0, 0.26, 4449.5, 384.22)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 4197.49,
    cy: -922.51,
    r: 19.46,
    gradientTransform: "matrix(-1, 0, 0, 0.26, 4449.5, 384.22)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 4351.59,
    cy: -898.75,
    r: 19.46,
    gradientTransform: "matrix(-1, 0, 0, 0.26, 4449.5, 384.22)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 4344.24,
    cy: -913.07,
    r: 19.46,
    gradientTransform: "matrix(-1, 0, 0, 0.26, 4449.5, 384.22)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1639.55,
    y1: 108.47,
    x2: 1639.55,
    y2: 124.94,
    gradientTransform: "matrix(1, 0, 0, -1, -1455.08, 233.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b1b1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#575756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#464645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#20201f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1b1b1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#131312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 1639.55,
    y1: 116.01,
    x2: 1639.55,
    y2: 116.74,
    gradientTransform: "matrix(1, 0, 0, -1, -1455.08, 232.76)",
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 1639.55,
    y1: 116.73,
    x2: 1639.55,
    y2: 117.46,
    gradientTransform: "matrix(1, 0, 0, -1, -1455.08, 234.19)",
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 1615.56,
    y1: 116.74,
    x2: 1617.48,
    y2: 116.74,
    gradientTransform: "matrix(1, 0, 0, -1, -1408.85, 233.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbcbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#bebebd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#bebebd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9c9c9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 11191.9,
    y1: 116.74,
    x2: 11193.82,
    y2: 116.74,
    gradientTransform: "translate(-11031.42)",
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 1618.61,
    y1: 108.47,
    x2: 1618.61,
    y2: 124.94,
    gradientTransform: "matrix(1, 0, 0, -1, -1413.2, 233.48)",
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 1660.42,
    y1: 108.47,
    x2: 1660.42,
    y2: 124.94,
    gradientTransform: "matrix(1, 0, 0, -1, -1496.82, 233.48)",
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 1619.26,
    y1: 116.74,
    x2: 1620,
    y2: 116.74,
    gradientTransform: "matrix(1, 0, 0, -1, -1415.21, 233.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6a7b75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7d8b86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#99a29f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#afb6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c1c4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#cdcece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 1661.06,
    y1: 116.74,
    x2: 1661.8,
    y2: 116.74,
    gradientTransform: "matrix(1, 0, 0, -1, -1498.81, 233.48)",
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 11252.07,
    y1: 116.74,
    x2: 11252.81,
    y2: 116.74,
    gradientTransform: "translate(-11046.02)",
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 11210.26,
    y1: 116.74,
    x2: 11211,
    y2: 116.74,
    gradientTransform: "translate(-11046.02)",
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 1786.6,
    y1: 114.34,
    x2: 1803.85,
    y2: 114.34,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 3672.04,
    y1: 121.47,
    x2: 3672.04,
    y2: 117.24,
    gradientTransform: "matrix(1, 0, 0, -1, -3652.61, 238.6)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: -4571.21,
    cy: 123.7,
    r: 18.31,
    gradientTransform: "translate(3422.74 3268.56) rotate(45)",
    xlinkHref: "#radial-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: -4571.21,
    cy: 123.7,
    r: 18.67,
    gradientTransform: "translate(4674.15)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: -4571.21,
    cy: 123.7,
    r: 12.97,
    gradientTransform: "translate(4674.15)",
    xlinkHref: "#radial-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 1752.49,
    y1: 112.45,
    x2: 1752.49,
    y2: 125.26,
    gradientTransform: "matrix(1, 0, 0, -1, -1680.96, 237.76)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -3417.98,
    y1: -3316.98,
    x2: -3416.72,
    y2: -3316.98,
    gradientTransform: "matrix(1, 0, 0, 1.49, 3565.42, 5072.86)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -3419.21,
    y1: -3297.42,
    x2: -3415.49,
    y2: -3297.42,
    gradientTransform: "matrix(1, 0, 0, 1.49, 3536.44, 5050.8)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1647.22,
    y1: 104.18,
    x2: 1647.22,
    y2: 115.91,
    gradientTransform: "matrix(1, 0, 0, -1, -1470.43, 220.14)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1647.22,
    y1: 113.05,
    x2: 1647.22,
    y2: 115.89,
    gradientTransform: "matrix(1, 0, 0, -1, -1470.43, 228.95)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1753.81,
    y1: 105.41,
    x2: 1753.81,
    y2: 112.81,
    gradientTransform: "matrix(1, 0, 0, -1, -1683.61, 218.26)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 1753.81,
    y1: 111.01,
    x2: 1753.81,
    y2: 112.8,
    gradientTransform: "matrix(1, 0, 0, -1, -1683.61, 223.82)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 9208.72,
    y1: 107.93,
    x2: 9208.72,
    y2: 115.52,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 9183.76,
    y1: 117.65,
    x2: 9233.28,
    y2: 117.65,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 9186.36,
    y1: 118.9,
    x2: 9230.91,
    y2: 118.9,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 9208.53,
    cy: 128.69,
    r: 18.12,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 9208.53,
    cy: 128.69,
    r: 18.47,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 9208.53,
    cy: 128.69,
    r: 11.45,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 9208.53,
    cy: 128.69,
    r: 3.46,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 9206.9,
    y1: 127.57,
    x2: 9210.85,
    y2: 130.31,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 9208.49,
    cy: 128.69,
    r: 1.77,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 9207.93,
    y1: 123.5,
    x2: 9209.26,
    y2: 124.42,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 9208.12,
    y1: 123.63,
    x2: 9208.99,
    y2: 124.23,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 9207.95,
    y1: 133.13,
    x2: 9209.28,
    y2: 134.06,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 9208.13,
    y1: 133.26,
    x2: 9209.01,
    y2: 133.87,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 9203.76,
    y1: 125.91,
    x2: 9205.09,
    y2: 126.84,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 9203.95,
    y1: 126.04,
    x2: 9204.82,
    y2: 126.65,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 9212.12,
    y1: 130.72,
    x2: 9213.45,
    y2: 131.64,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 9212.3,
    y1: 130.85,
    x2: 9213.18,
    y2: 131.45,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 9203.77,
    y1: 130.73,
    x2: 9205.1,
    y2: 131.66,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 9203.96,
    y1: 130.86,
    x2: 9204.83,
    y2: 131.47,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 9212.11,
    y1: 125.9,
    x2: 9213.44,
    y2: 126.82,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 9212.29,
    y1: 126.03,
    x2: 9213.17,
    y2: 126.64,
    gradientTransform: "translate(-9110.53)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1601.25,
    y1: 115.79,
    x2: 1601.25,
    y2: 125.09,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 1698.69,
    y1: 0.88,
    x2: 1698.69,
    y2: 103.29,
    gradientTransform: "matrix(1, 0, 0, -1, -1573.37, 104.63)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 1763.52,
    y1: 109.6,
    x2: 1765.46,
    y2: 109.6,
    gradientTransform: "matrix(1, 0, 0, -1, -1704.85, 219.19)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 1790.86,
    y1: 109.6,
    x2: 1792.79,
    y2: 109.6,
    gradientTransform: "matrix(1, 0, 0, -1, -1759.52, 219.19)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 1779.77,
    y1: 111.44,
    x2: 1779.77,
    y2: 113.39,
    gradientTransform: "matrix(1, 0, 0, -1, -1735.52, 225.02)",
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 1617.61,
    y1: 110.01,
    x2: 1619.74,
    y2: 110.01,
    gradientTransform: "matrix(1, 0, 0, -1, -1413.2, 220.02)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 1653.32,
    y1: 110.01,
    x2: 1655.46,
    y2: 110.01,
    gradientTransform: "matrix(1, 0, 0, -1, -1484.64, 220.02)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 1692.22,
    y1: 110.01,
    x2: 1694.35,
    y2: 110.01,
    gradientTransform: "matrix(1, 0, 0, -1, -1562.42, 220.02)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 1654.78,
    y1: 112.15,
    x2: 1654.78,
    y2: 114.18,
    gradientTransform: "matrix(1, 0, 0, -1, -1485.55, 226.53)",
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 1694.04,
    y1: 103.69,
    x2: 1694.04,
    y2: 110.08,
    gradientTransform: "matrix(1, 0, 0, -1, -1564.07, 213.8)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 1698.85,
    y1: 104.09,
    x2: 1698.85,
    y2: 114.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: -4417.09,
    cy: 118.33,
    r: 20.12,
    gradientTransform: "translate(4590.84 980.34) rotate(12.78)",
    xlinkHref: "#radial-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: -4417.09,
    cy: 118.33,
    r: 20.51,
    gradientTransform: "translate(4674.15)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: -4417.09,
    cy: 118.33,
    r: 14.25,
    gradientTransform: "translate(4674.15)",
    xlinkHref: "#radial-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 1559.37,
    cy: 124.27,
    r: 21.13,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#radial-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 1563.28,
    cy: 75.28,
    r: 24.62,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 1509.87,
    y1: 78.25,
    x2: 1586.34,
    y2: 78.25,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: -4534.39,
    cy: 128.91,
    r: 18.09,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: -4534.39,
    cy: 128.91,
    r: 18.44,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: -4534.39,
    cy: 128.91,
    r: 11.43,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: -4534.39,
    cy: 128.91,
    r: 3.45,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: -4536.01,
    y1: 127.78,
    x2: -4532.06,
    y2: 130.52,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: -4534.43,
    cy: 128.91,
    r: 1.77,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: -4534.98,
    y1: 123.72,
    x2: -4533.65,
    y2: 124.64,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: -4534.8,
    y1: 123.85,
    x2: -4533.92,
    y2: 124.46,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: -4534.96,
    y1: 133.34,
    x2: -4533.63,
    y2: 134.26,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: -4534.78,
    y1: 133.47,
    x2: -4533.9,
    y2: 134.08,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: -4539.14,
    y1: 126.13,
    x2: -4537.81,
    y2: 127.06,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: -4538.96,
    y1: 126.26,
    x2: -4538.08,
    y2: 126.87,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: -4530.8,
    y1: 130.93,
    x2: -4529.47,
    y2: 131.85,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: -4530.61,
    y1: 131.06,
    x2: -4529.74,
    y2: 131.66,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: -4539.13,
    y1: 130.94,
    x2: -4537.8,
    y2: 131.87,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: -4538.95,
    y1: 131.07,
    x2: -4538.07,
    y2: 131.68,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: -4530.81,
    y1: 126.12,
    x2: -4529.48,
    y2: 127.04,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: -4530.62,
    y1: 126.25,
    x2: -4529.75,
    y2: 126.85,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: -3200.2,
    y1: 132.12,
    x2: -3180.54,
    y2: 132.5,
    gradientTransform: "matrix(0.66, 0.04, -0.02, 1, 2428.69, 111.35)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: -3187.51,
    y1: 139.67,
    x2: -3187.51,
    y2: 134.86,
    gradientTransform: "matrix(0.66, 0.04, -0.02, 1, 2428.69, 111.35)",
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: -3200.08,
    y1: 125.31,
    x2: -3180.62,
    y2: 125.68,
    gradientTransform: "matrix(0.66, 0.04, -0.02, 1, 2428.69, 111.35)",
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 1518.12,
    y1: 121.49,
    x2: 1517.25,
    y2: 121.49,
    gradientTransform: "matrix(1, 0, 0, -1, -1211.36, 242.98)",
    xlinkHref: "#linear-gradient-64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 1531.35,
    y1: 112.28,
    x2: 1531.35,
    y2: 129.27,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#linear-gradient-65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 1518.14,
    y1: 120.81,
    x2: 1522.15,
    y2: 120.81,
    gradientTransform: "matrix(1, 0, 0, -1, -1216.28, 241.63)",
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 1535.7,
    y1: 120.81,
    x2: 1544.48,
    y2: 120.81,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#linear-gradient-67"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 1539.26,
    y1: 120.02,
    x2: 1544.51,
    y2: 121.64,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: 3616.43,
    cy: 79.7,
    r: 4.99,
    gradientTransform: "matrix(-1, 0, 0, 1, 3872.45, 0)",
    xlinkHref: "#radial-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 3615.79,
    y1: 80.71,
    x2: 3615.79,
    y2: 78.74,
    gradientTransform: "matrix(-1, 0, 0, 1, 3872.45, 0)",
    xlinkHref: "#linear-gradient-69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 12316.6,
    y1: -275.8,
    x2: 12322.47,
    y2: -275.8,
    gradientTransform: "translate(-11990.4 -601.95) rotate(4.55)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: -13011.05,
    y1: -275.24,
    x2: -13010.35,
    y2: -275.24,
    gradientTransform: "matrix(-1, -0.08, -0.08, 1, -12678.14, -657.2)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: -13011.05,
    y1: -275.08,
    x2: -13007.96,
    y2: -276.47,
    gradientTransform: "matrix(-1, -0.08, -0.08, 1, -12678.14, -657.2)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 13509.1,
    y1: -273.76,
    x2: 13511.02,
    y2: -276.99,
    gradientTransform: "translate(-13175.06 -696.28) rotate(4.55)",
    xlinkHref: "#linear-gradient-73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 13505.63,
    y1: -276,
    x2: 13510.88,
    y2: -276,
    gradientTransform: "translate(-13175.06 -696.28) rotate(4.55)",
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 12372.03,
    y1: 196.9,
    x2: 12372.58,
    y2: 196.9,
    gradientTransform: "translate(-12042.57 -615.71) rotate(2.4)",
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 12317.94,
    y1: -274.54,
    x2: 12318.49,
    y2: -274.54,
    gradientTransform: "translate(-11990.4 -601.95) rotate(4.55)",
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 12316.6,
    y1: -275.92,
    x2: 12322.47,
    y2: -275.92,
    gradientTransform: "translate(-11990.4 -601.95) rotate(4.55)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 12316.6,
    y1: -275.8,
    x2: 12322.46,
    y2: -275.8,
    gradientTransform: "translate(-11990.4 -601.95) rotate(4.55)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 1566.93,
    y1: 107.82,
    x2: 1598.5,
    y2: 132.06,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 1579.06,
    y1: 104.01,
    x2: 1579.06,
    y2: 105.6,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 1558.79,
    y1: 38.22,
    x2: 1559.35,
    y2: 43.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 1521.4,
    y1: 61.61,
    x2: 1572.11,
    y2: 61.61,
    gradientTransform: "matrix(-1, 0, 0, 1, 1824.01, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.4,68.48h.91a.3.3,0,0,0,0-.59h-.91Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.37,67.89h-.9a.3.3,0,0,0,0,.59h.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304,83.64V85.4a.3.3,0,1,0,.59,0V83.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.05,62.1l-1.76-.17a.28.28,0,0,0-.31.26.29.29,0,0,0,.26.32l1.75.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.92,83.62l-.14,1.76a.3.3,0,0,0,.59.05l.14-1.76Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.07,64.13l-.07,0a.29.29,0,0,0-.13.57h.07Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 4068.08,
    cy: -1385.48,
    r: 12.3,
    gradientTransform: "matrix(-1, 0, 0, 0.18, 4449.5, 585.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#606260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#909190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#b8b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fafbfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: 3997.67,
    cy: -1385.48,
    r: 12.3,
    xlinkHref: "#radial-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 416.62,
    y1: 298.59,
    x2: 416.62,
    y2: 311.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 416.62,
    y1: 190.09,
    x2: 416.62,
    y2: 289.74,
    gradientTransform: "translate(176.57 656.66) rotate(-90)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 452.86,
    y1: 292.06,
    x2: 452.86,
    y2: 332.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 452.86,
    y1: 292.99,
    x2: 452.86,
    y2: 321.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#494a3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3b3d35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2b2d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#222424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1f2122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#323332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#51514b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#64635a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#6b6960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#6d6b62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#727269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#77786f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 381.71,
    y1: 292.06,
    x2: 381.71,
    y2: 332.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 381.47,
    y1: 293.21,
    x2: 381.47,
    y2: 321.27,
    xlinkHref: "#linear-gradient-169"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 415.45,
    y1: 239.7,
    x2: 417.78,
    y2: 239.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#acacaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#a4a5a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#949794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8e928f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#979a98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a8aaa8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#b3b6b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#babcba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#bcbebc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#bec0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#c6c8c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#d4d5d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2a2a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 412.41,
    y1: 239.7,
    x2: 413.16,
    y2: 239.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b7e7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#929593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#c9cccb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ecefee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f9fcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#f8fbfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#eef1f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d4d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#aaadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#808383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#707372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6c6f6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#727573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#979a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#b2b5b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#c2c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#c8cbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#bcbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#9ea1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#6c6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 411.04,
    y1: 285.02,
    x2: 414.53,
    y2: 285.02,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 411.04,
    y1: 194.99,
    x2: 414.53,
    y2: 194.99,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 412.41,
    y1: 291.18,
    x2: 414.08,
    y2: 291.18,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 400.3,
    y1: 274.44,
    x2: 413.58,
    y2: 274.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b7e7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#808383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#707372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6c6f6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9fa2a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#c8cbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bcbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9ea1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6c6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 420.28,
    y1: 239.7,
    x2: 421.03,
    y2: 239.7,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 418.91,
    y1: 285.02,
    x2: 422.4,
    y2: 285.02,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 418.91,
    y1: 194.99,
    x2: 422.4,
    y2: 194.99,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 419.36,
    y1: 291.18,
    x2: 421.03,
    y2: 291.18,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 1817.55,
    y1: 274.44,
    x2: 1830.83,
    y2: 274.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 2250.58, 0)",
    xlinkHref: "#linear-gradient-177"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 373.82,
    y1: 206.29,
    x2: 384.06,
    y2: 206.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b7e7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#797c7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#6c6f6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#808383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#919494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#bec1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#c8cbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bcbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9ea1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6c6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 374.49,
    y1: 206.29,
    x2: 383.4,
    y2: 206.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#70726f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#a7adab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#bdc4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#bec5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#d1d3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d4d7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d6d5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: 374.11,
    cy: 204.11,
    r: 0.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8cbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#bec1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#919494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#808383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#6c6f6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#797c7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b7e7c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: 374.11,
    cy: 208.33,
    r: 0.44,
    xlinkHref: "#radial-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 373.82,
    y1: 240.9,
    x2: 384.06,
    y2: 240.9,
    xlinkHref: "#linear-gradient-183"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 374.49,
    y1: 240.9,
    x2: 383.4,
    y2: 240.9,
    xlinkHref: "#linear-gradient-184"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: 374.11,
    cy: 238.72,
    r: 0.44,
    xlinkHref: "#radial-gradient-51"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: 374.11,
    cy: 242.94,
    r: 0.44,
    xlinkHref: "#radial-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 373.82,
    y1: 275.51,
    x2: 384.06,
    y2: 275.51,
    xlinkHref: "#linear-gradient-183"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 374.49,
    y1: 275.51,
    x2: 383.4,
    y2: 275.51,
    xlinkHref: "#linear-gradient-184"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: 374.11,
    cy: 273.33,
    r: 0.44,
    xlinkHref: "#radial-gradient-51"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: 374.11,
    cy: 277.55,
    r: 0.44,
    xlinkHref: "#radial-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 373.61,
    y1: 206.29,
    x2: 374.61,
    y2: 206.29,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 373.61,
    y1: 240.9,
    x2: 374.61,
    y2: 240.9,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 373.61,
    y1: 275.51,
    x2: 374.61,
    y2: 275.51,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 1749.06,
    y1: 206.29,
    x2: 1759.3,
    y2: 206.29,
    gradientTransform: "matrix(-1, 0, 0, 1, 2208.4, 0)",
    xlinkHref: "#linear-gradient-183"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 1749.73,
    y1: 206.29,
    x2: 1758.64,
    y2: 206.29,
    gradientTransform: "matrix(-1, 0, 0, 1, 2208.4, 0)",
    xlinkHref: "#linear-gradient-184"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: 1749.35,
    cy: 204.11,
    r: 0.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 2208.4, 0)",
    xlinkHref: "#radial-gradient-51"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: 1749.35,
    cy: 208.33,
    r: 0.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 2208.4, 0)",
    xlinkHref: "#radial-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 1749.06,
    y1: 240.9,
    x2: 1759.3,
    y2: 240.9,
    gradientTransform: "matrix(-1, 0, 0, 1, 2208.4, 0)",
    xlinkHref: "#linear-gradient-183"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 1749.73,
    y1: 240.9,
    x2: 1758.64,
    y2: 240.9,
    gradientTransform: "matrix(-1, 0, 0, 1, 2208.4, 0)",
    xlinkHref: "#linear-gradient-184"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-59",
    cx: 1749.35,
    cy: 238.72,
    r: 0.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 2208.4, 0)",
    xlinkHref: "#radial-gradient-51"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-60",
    cx: 1749.35,
    cy: 242.94,
    r: 0.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 2208.4, 0)",
    xlinkHref: "#radial-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 1749.06,
    y1: 275.51,
    x2: 1759.3,
    y2: 275.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 2208.4, 0)",
    xlinkHref: "#linear-gradient-183"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 1749.73,
    y1: 275.51,
    x2: 1758.64,
    y2: 275.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 2208.4, 0)",
    xlinkHref: "#linear-gradient-184"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-61",
    cx: 1749.35,
    cy: 273.33,
    r: 0.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 2208.4, 0)",
    xlinkHref: "#radial-gradient-51"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-62",
    cx: 1749.35,
    cy: 277.55,
    r: 0.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 2208.4, 0)",
    xlinkHref: "#radial-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 1748.85,
    y1: 206.29,
    x2: 1749.85,
    y2: 206.29,
    gradientTransform: "matrix(1, 0, 0, -1, -1290.31, 412.59)",
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 1748.85,
    y1: 240.9,
    x2: 1749.85,
    y2: 240.9,
    gradientTransform: "matrix(1, 0, 0, -1, -1290.31, 481.81)",
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 1748.85,
    y1: 275.51,
    x2: 1749.85,
    y2: 275.51,
    gradientTransform: "matrix(1, 0, 0, -1, -1290.31, 551.02)",
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 385.12,
    y1: 303.06,
    x2: 385.12,
    y2: 308.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1d2022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#000102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#25282a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25282a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: -6555.09,
    y1: -542.03,
    x2: -6553.19,
    y2: -542.03,
    gradientTransform: "matrix(1, 0, 0, -1, 6939.32, -235.44)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 388.14,
    y1: 298,
    x2: 388.14,
    y2: 302.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1d2022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#070a0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191c1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 1770.77,
    y1: 303.06,
    x2: 1770.77,
    y2: 308.23,
    gradientTransform: "matrix(1, 0, 0, -1, -1322.8, 611.29)",
    xlinkHref: "#linear-gradient-201"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: -6555.09,
    y1: 843.63,
    x2: -6553.19,
    y2: 843.63,
    gradientTransform: "translate(7002.06 -537.04)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 1773.79,
    y1: 298,
    x2: 1773.79,
    y2: 302.96,
    gradientTransform: "matrix(-1, 0, 0, 1, 2218.74, 0)",
    xlinkHref: "#linear-gradient-203"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 416.62,
    y1: 293.18,
    x2: 416.62,
    y2: 297.85,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-63",
    cx: 4068.08,
    cy: -2401.22,
    r: 12.3,
    xlinkHref: "#radial-gradient-49"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-64",
    cx: 3997.67,
    cy: -2401.22,
    r: 12.3,
    xlinkHref: "#radial-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 418.02,
    y1: 0.16,
    x2: 418.02,
    y2: 72.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#cacac9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d9dad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e4e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#eaedec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ecefee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#dededd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d2d3d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#bec1bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5e6669"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361,69.79l.28-.93a.42.42,0,1,1,.81.24l-.28.94Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.49,74.5l-.28.94a.42.42,0,1,1-.81-.24l.28-.94Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.5,77.91l.7.69a.41.41,0,0,1,0,.59.43.43,0,0,1-.6,0l-.7-.69Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.47,58.23l-.08-1a.42.42,0,0,1,.39-.45.42.42,0,0,1,.46.38l.07,1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.63,88.39l.6.77a.42.42,0,0,1-.66.52l-.61-.77Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.48,59.52l-.09-1a.43.43,0,0,1,.39-.46.43.43,0,0,1,.46.38l.08,1Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 418.02,
    y1: 37.14,
    x2: 418.02,
    y2: 128.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e3e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#e0e2e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e0e0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#d8d9d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#cdcfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#babeba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#b7bbb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#b4b8b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#acafab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9e9f9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93938e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 452.45,
    y1: 111.22,
    x2: 452.45,
    y2: 146.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191918"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 381.53,
    y1: 111.22,
    x2: 381.53,
    y2: 146.94,
    xlinkHref: "#linear-gradient-210"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 370.44,
    y1: 101.54,
    x2: 391.5,
    y2: 101.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8c8c8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#c3c3c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#d7d7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#cfcfce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#c2c2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#afafae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#979795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#7a7a77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a5a57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 376.93,
    y1: 101.42,
    x2: 381.67,
    y2: 101.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 382.89,
    y1: 101.42,
    x2: 387.63,
    y2: 101.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 371.37,
    y1: 99.87,
    x2: 374.87,
    y2: 99.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 371.37,
    y1: 102.17,
    x2: 374.87,
    y2: 102.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 370.44,
    y1: 101.54,
    x2: 391.33,
    y2: 101.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 371.28,
    y1: 99.8,
    x2: 391.22,
    y2: 99.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 4130.16,
    y1: 101.54,
    x2: 4151.23,
    y2: 101.54,
    gradientTransform: "matrix(-1, 0, 0, 1, 4594.66, 0)",
    xlinkHref: "#linear-gradient-212"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 4136.66,
    y1: 101.42,
    x2: 4141.4,
    y2: 101.42,
    gradientTransform: "matrix(-1, 0, 0, 1, 4594.66, 0)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 4142.61,
    y1: 101.42,
    x2: 4147.35,
    y2: 101.42,
    gradientTransform: "matrix(-1, 0, 0, 1, 4594.66, 0)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 4131.09,
    y1: 99.87,
    x2: 4134.6,
    y2: 99.87,
    gradientTransform: "matrix(-1, 0, 0, 1, 4594.66, 0)",
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 4131.09,
    y1: 102.17,
    x2: 4134.6,
    y2: 102.17,
    gradientTransform: "matrix(-1, 0, 0, 1, 4594.66, 0)",
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 4130.16,
    y1: 101.54,
    x2: 4151.05,
    y2: 101.54,
    gradientTransform: "matrix(-1, 0, 0, 1, 4594.66, 0)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 4131,
    y1: 99.8,
    x2: 4150.95,
    y2: 99.8,
    gradientTransform: "matrix(1, 0, 0, -1, -3685.11, 199.59)",
    xlinkHref: "#linear-gradient-218"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: -1739.43,
    y1: 7771.73,
    x2: -1739.43,
    y2: 7771.2,
    gradientTransform: "translate(2156.93 -7672.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#838688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#9b9d9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: -1739.43,
    y1: 7771.19,
    x2: -1739.43,
    y2: 7770.67,
    gradientTransform: "translate(2156.93 -7672.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b5757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#949b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9fa5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c1c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#dcdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 418.06,
    y1: 110.37,
    x2: 418.06,
    y2: 97.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#39393a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2b2e32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1b1d20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 418.06,
    y1: 105.12,
    x2: 418.06,
    y2: 101.48,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 418.06,
    y1: 101.34,
    x2: 418.06,
    y2: 97.7,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 418.06,
    y1: 108.89,
    x2: 418.06,
    y2: 105.26,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-65",
    cx: 417.8,
    cy: 110.67,
    r: 28.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#f3f3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e4e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#cfcfd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#b3b4b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#919293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#686a6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3a3c3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2a2c2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 417.17,
    y1: 127.92,
    x2: 417.17,
    y2: 114.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 397.66,
    y1: 121.9,
    x2: 397.66,
    y2: 117.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#696a6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5b5d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2a2c2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 287.16,
    y1: 121.88,
    x2: 287.16,
    y2: 117.15,
    gradientTransform: "matrix(-1, 0, 0, 1, 725.62, 0)",
    xlinkHref: "#linear-gradient-233"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 463.46,
    y1: 121.24,
    x2: 457.97,
    y2: 121.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#9fa5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#c1c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#dcdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 370.77,
    y1: 121.25,
    x2: 375.86,
    y2: 121.25,
    xlinkHref: "#linear-gradient-235"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 381.56,
    y1: 120.63,
    x2: 381.56,
    y2: 118.38,
    xlinkHref: "#linear-gradient-212"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 381.56,
    y1: 120.57,
    x2: 381.56,
    y2: 118.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60605d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#8c8c8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#c3c3c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#d7d7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#cfcfce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#c2c2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#afafae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#979795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#7a7a77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60605d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 381.56,
    y1: 120.51,
    x2: 381.56,
    y2: 118.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#8b8b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#c3c3c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#d7d7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#cfcfce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#c2c2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#afafae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#979795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#797977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 381.56,
    y1: 120.45,
    x2: 381.56,
    y2: 118.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d6d6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8d8d8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#c4c4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dadad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d0d0cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#c3c3c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#b0b0af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#989896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7b7b78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6d6a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 381.56,
    y1: 120.39,
    x2: 381.56,
    y2: 118.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#737371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#8d8d8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c4c4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dadad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d0d0cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#c3c3c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#b0b0af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#989896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7a7a78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737371"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 381.56,
    y1: 120.33,
    x2: 381.56,
    y2: 118.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#797977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8d8d8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c4c4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dadad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d0d0cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#c3c3c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#b0b0af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#989896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b7b79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#797977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 381.56,
    y1: 120.27,
    x2: 381.56,
    y2: 118.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f7f7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8d8d8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#c4c4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dadad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d0d0cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#c3c3c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#b0b0af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#989896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f7f7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 381.56,
    y1: 120.21,
    x2: 381.56,
    y2: 118.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#868684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8e8e8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#b1b1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#999997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868684"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: 381.56,
    y1: 120.15,
    x2: 381.56,
    y2: 118.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c8c8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8e8e8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dbdbda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#d1d1d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#c4c4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#b1b1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#999997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c8c8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: 381.56,
    y1: 120.09,
    x2: 381.56,
    y2: 118.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#929290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dbdbda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#d1d1d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#c4c4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#b1b1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#999997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: 381.56,
    y1: 120.04,
    x2: 381.56,
    y2: 118.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#989897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dbdbda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#d1d1d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#c4c4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#b1b1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989897"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: 381.56,
    y1: 119.98,
    x2: 381.56,
    y2: 118.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f9f9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#c6c6c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#b2b2b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f9f9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 381.56,
    y1: 119.92,
    x2: 381.56,
    y2: 118.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a5a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#b2b2b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a5a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 381.56,
    y1: 119.86,
    x2: 381.56,
    y2: 118.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ababaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#c6c6c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b2b2b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ababaa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: 381.56,
    y1: 119.8,
    x2: 381.56,
    y2: 118.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b1b1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#c6c6c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#dadad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#d2d2d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2b2b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b1b1b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 381.56,
    y1: 119.74,
    x2: 381.56,
    y2: 118.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b8b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#c7c7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8b8b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 381.56,
    y1: 119.68,
    x2: 381.56,
    y2: 118.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bebebd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c7c7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 381.56,
    y1: 119.62,
    x2: 381.56,
    y2: 118.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4c4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c7c7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c6c6c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4c4c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: 381.56,
    y1: 119.56,
    x2: 381.56,
    y2: 118.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cacaca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cacaca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 381.56,
    y1: 119.5,
    x2: 381.56,
    y2: 118.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d1d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#d4d4d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d1d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: 381.56,
    y1: 119.44,
    x2: 381.56,
    y2: 118.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7d7d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: 453.54,
    y1: 120.63,
    x2: 453.54,
    y2: 118.38,
    xlinkHref: "#linear-gradient-212"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: 453.54,
    y1: 120.57,
    x2: 453.54,
    y2: 118.38,
    xlinkHref: "#linear-gradient-238"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: 453.54,
    y1: 120.51,
    x2: 453.54,
    y2: 118.39,
    xlinkHref: "#linear-gradient-239"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: 453.54,
    y1: 120.45,
    x2: 453.54,
    y2: 118.4,
    xlinkHref: "#linear-gradient-240"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: 453.54,
    y1: 120.39,
    x2: 453.54,
    y2: 118.41,
    xlinkHref: "#linear-gradient-241"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: 453.54,
    y1: 120.33,
    x2: 453.54,
    y2: 118.42,
    xlinkHref: "#linear-gradient-242"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: 453.54,
    y1: 120.27,
    x2: 453.54,
    y2: 118.43,
    xlinkHref: "#linear-gradient-243"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: 453.54,
    y1: 120.21,
    x2: 453.54,
    y2: 118.44,
    xlinkHref: "#linear-gradient-244"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: 453.54,
    y1: 120.15,
    x2: 453.54,
    y2: 118.44,
    xlinkHref: "#linear-gradient-245"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: 453.54,
    y1: 120.09,
    x2: 453.54,
    y2: 118.45,
    xlinkHref: "#linear-gradient-246"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: 453.54,
    y1: 120.04,
    x2: 453.54,
    y2: 118.46,
    xlinkHref: "#linear-gradient-247"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: 453.54,
    y1: 119.98,
    x2: 453.54,
    y2: 118.47,
    xlinkHref: "#linear-gradient-248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: 453.54,
    y1: 119.92,
    x2: 453.54,
    y2: 118.48,
    xlinkHref: "#linear-gradient-249"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: 453.54,
    y1: 119.86,
    x2: 453.54,
    y2: 118.49,
    xlinkHref: "#linear-gradient-250"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: 453.54,
    y1: 119.8,
    x2: 453.54,
    y2: 118.5,
    xlinkHref: "#linear-gradient-251"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: 453.54,
    y1: 119.74,
    x2: 453.54,
    y2: 118.5,
    xlinkHref: "#linear-gradient-252"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    x1: 453.54,
    y1: 119.68,
    x2: 453.54,
    y2: 118.51,
    xlinkHref: "#linear-gradient-253"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    x1: 453.54,
    y1: 119.62,
    x2: 453.54,
    y2: 118.52,
    xlinkHref: "#linear-gradient-254"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    x1: 453.54,
    y1: 119.56,
    x2: 453.54,
    y2: 118.53,
    xlinkHref: "#linear-gradient-255"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    x1: 453.54,
    y1: 119.5,
    x2: 453.54,
    y2: 118.54,
    xlinkHref: "#linear-gradient-256"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    x1: 453.54,
    y1: 119.44,
    x2: 453.54,
    y2: 118.55,
    xlinkHref: "#linear-gradient-257"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M465.12,78.51l-.69.69a.43.43,0,0,1-.6,0,.41.41,0,0,1,0-.59l.7-.69Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480.72,58.16l.08-1a.42.42,0,0,1,.45-.38.41.41,0,0,1,.39.45l-.08,1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M466.07,88.91l-.6.77a.42.42,0,0,1-.6.07.43.43,0,0,1-.07-.59l.61-.77Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M483.71,59.44l.09-1a.42.42,0,0,1,.46-.38.42.42,0,0,1,.38.46l-.08,1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.2,70l-.28-.94a.42.42,0,0,1,.29-.53.41.41,0,0,1,.52.29l.28.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.35,74.26l.28.94a.43.43,0,0,1-.28.53.43.43,0,0,1-.53-.29l-.28-.94Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    x1: 377.51,
    y1: 62.88,
    x2: 458.52,
    y2: 62.88,
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    x1: 373.52,
    y1: 82.18,
    x2: 462.52,
    y2: 82.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e5e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e0e0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#cbcbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452.51,49.37a2.49,2.49,0,0,0-2.36-1.84l-32-.73-32.29.73a2.49,2.49,0,0,0-2.36,1.84c-1.4,5.14-5.32,20.09-6,28.77l40.65.81,40.36-.81C457.83,69.46,453.91,54.51,452.51,49.37Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    x1: 388.88,
    y1: 62.88,
    x2: 410.23,
    y2: 62.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ababab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    x1: 421.6,
    y1: 63.3,
    x2: 453.7,
    y2: 63.3,
    xlinkHref: "#linear-gradient-281"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    x1: 463.85,
    y1: 77.52,
    x2: 448.08,
    y2: 78.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfc3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#d0d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#e5e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fcfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    x1: 371.58,
    y1: 77.05,
    x2: 387.66,
    y2: 79.22,
    xlinkHref: "#linear-gradient-283"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-66",
    cx: 845.28,
    cy: 694.62,
    r: 0.59,
    gradientTransform: "matrix(0.45, 0.89, -0.89, 0.45, 655.8, -989.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#191c20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1e2024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#2b2d31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#404245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3e4043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2d3033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#222428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#1b1e22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191c20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    x1: 1206.99,
    y1: 667.35,
    x2: 1207.59,
    y2: 667.35,
    gradientTransform: "translate(1135.01 -1098.07) rotate(92.56)",
    xlinkHref: "#radial-gradient-66"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-67",
    cx: 1556.02,
    cy: -527.31,
    r: 0.59,
    gradientTransform: "matrix(-0.56, 0.83, 0.83, 0.56, 1723.12, -923.69)",
    xlinkHref: "#radial-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    x1: 1230.51,
    y1: -746.76,
    x2: 1231.11,
    y2: -746.76,
    gradientTransform: "matrix(-0.08, 1, 1, 0.08, 1261.77, -1090.85)",
    xlinkHref: "#radial-gradient-66"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 3,
    height: 2,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAYAAACddGYaAAAACXBIWXMAAAsSAAALEgHS3X78AAAAI0lEQVQIW2M0NjP9z8DAwPDl8xcGli+fvzAwMDAwvHzxnAEAemMKEbfA57kAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image-2",
    width: 3,
    height: 1,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAABCAYAAAAb4BS0AAAACXBIWXMAAAsSAAALEgHS3X78AAAAD0lEQVQIW2P8//8/AwwAACD5Av8tIlAeAAAAAElFTkSuQmCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 155.28,
    cy: 333.19,
    rx: 155.28,
    ry: 10.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 62.44,
    cy: 332.7,
    rx: 19.47,
    ry: 5.14
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 71.19,
    cy: 326.65,
    rx: 19.47,
    ry: 5.14
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 225.29,
    cy: 332.92,
    rx: 19.47,
    ry: 5.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M237.4,329.14c0,2.84-8.71,5.14-19.46,5.14s-19.47-2.3-19.47-5.14,8.72-5.14,19.47-5.14S237.4,326.3,237.4,329.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M299.37,303.65l-6.64-2.07v-8h-1.8V301l-4.4-1.25v-2.5h-1.85v4.89l6.25,1.34v4.32h11V303.6Zm-6.64,3.54v-3.38l4.95.93v2.45Zm6.64,0v-3.05h2.12v3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M302,303.5h1.58a0,0,0,0,1,0,0v4.34a0,0,0,0,1,0,0H302a.22.22,0,0,1-.22-.22v-3.9A.22.22,0,0,1,302,303.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 303.56,
    y: 303.5,
    width: 0.38,
    height: 4.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 219.15,
    cy: 310.07,
    r: 18.31,
    transform: "translate(-132.71 452.76) rotate(-76.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M203,308.3l-2.42-.27.42-2.4,2.39.56c0-.22.11-.45.17-.67l-2.34-.69.83-2.29,2.24,1,.3-.63-2.19-1.09,1.22-2.11,2,1.34c.12-.19.27-.37.41-.56l-2-1.46,1.57-1.87,1.78,1.68c.16-.16.32-.33.49-.48l-1.69-1.78,1.87-1.57,1.47,2c.18-.14.36-.28.55-.41l-1.34-2,2.11-1.22,1.1,2.19c.21-.1.41-.21.62-.3l-1-2.24,2.29-.83.7,2.34.67-.17-.57-2.39,2.4-.42.28,2.42.68,0-.14-2.45h2.44l-.15,2.45.69,0,.28-2.42,2.4.42-.57,2.39.67.17.7-2.34,2.29.83-1,2.24c.22.09.42.2.63.3l1.1-2.19,2.11,1.22-1.35,2,.56.41,1.47-2,1.87,1.57-1.69,1.78.49.48,1.78-1.68,1.57,1.87-2,1.46c.14.19.28.37.41.56l2-1.34,1.22,2.11-2.2,1.09c.1.21.21.41.3.63l2.25-1,.83,2.29-2.34.69c.06.22.11.45.17.67l2.39-.56.42,2.4-2.43.27c0,.23,0,.46.05.69l2.45-.14v2.44l-2.45-.15c0,.23,0,.46-.05.69l2.43.28-.42,2.4-2.39-.57c-.05.22-.11.45-.17.67l2.34.7-.83,2.29-2.24-1-.3.63,2.19,1.1-1.22,2.11-2-1.35c-.13.19-.28.37-.41.56l2,1.47L232.67,323l-1.78-1.68-.49.49,1.69,1.78-1.87,1.57-1.46-2-.56.41,1.34,2-2.11,1.22-1.09-2.2c-.21.1-.42.21-.63.3l1,2.25-2.29.83-.69-2.34-.67.17.56,2.39-2.4.42-.27-2.43c-.23,0-.47,0-.7.05l.15,2.45h-2.44l.14-2.45c-.23,0-.46,0-.69-.05l-.27,2.43-2.4-.42.56-2.39-.67-.17-.69,2.34-2.29-.83,1-2.25c-.22-.09-.42-.2-.63-.3l-1.09,2.2-2.11-1.22,1.34-2-.56-.41-1.46,2-1.87-1.57,1.68-1.78-.48-.49L205.63,323l-1.57-1.86,2-1.47c-.14-.19-.28-.37-.41-.56l-2,1.35-1.22-2.11,2.19-1.1c-.1-.21-.21-.41-.3-.63l-2.24,1-.83-2.29,2.34-.7c-.06-.22-.12-.45-.17-.67l-2.39.57-.42-2.4,2.42-.28c0-.23,0-.46,0-.69l-2.45.15v-2.44l2.45.14C202.94,308.76,203,308.53,203,308.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M219.15,297.09a13,13,0,1,1-13,13A13,13,0,0,1,219.15,297.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 231.42,
    y: 298.9,
    width: 38.29,
    height: 12.71,
    rx: 2.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 174.01,
    y: 291.16,
    width: 1.26,
    height: 24.22,
    transform: "translate(510.19 203.91) rotate(103.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 201.21,
    y: 292.95,
    width: 3.72,
    height: 34.25,
    rx: 0.63,
    transform: "translate(551.86 184.68) rotate(103.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 82.77,
    y: 290.63,
    width: 125.05,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 82.77,
    y: 299.44,
    width: 125.05,
    height: 2.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 207.82,
    y: 291.83,
    width: 88.13,
    height: 7.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 207.82,
    y: 297.39,
    width: 88.13,
    height: 1.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M205.38,302.16a21.25,21.25,0,0,1,18.5-10.22,21.83,21.83,0,0,1,18.55,10.29C230,302,218.68,302,205.38,302.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M199.43,317.19s-2.86-26.62,24.73-26.62c25.46,0,24.89,22.9,24.65,26.44h-4s2-22.57-20.66-22.57-20.72,23-20.72,23S201.77,317.38,199.43,317.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M224.68,293.08c22.26,0,21.76,20.59,21.53,23.93h-1.39s2-22.57-20.66-22.57-20.72,23-20.72,23-.65,0-1.71-.11h0S200.44,293.08,224.68,293.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M221.44,293.54c.25,1.82-9.51,1.2-14.38,9S204.42,314.7,202,314.7c-2,0-2.17-9.32,2.09-15.57C209.23,291.6,221,290.44,221.44,293.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M220.38,293.83c.26,1.71-8.8,1.3-13.36,8.56s-2.64,11.48-4.89,11.47c-1.93,0-1.95-8.76,2.07-14.65C209,292.16,219.94,291,220.38,293.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M219.32,294.13c.28,1.58-8.09,1.38-12.34,8.1S204.35,313,202.24,313c-1.81,0-1.72-8.2,2.06-13.73C208.79,292.72,218.86,291.49,219.32,294.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M218.26,294.42c.3,1.46-7.38,1.47-11.32,7.65-4.07,6.34-2.63,10.13-4.58,10.11-1.71,0-1.49-7.64,2-12.81C208.57,293.28,217.78,292,218.26,294.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M217.2,294.72c.32,1.34-6.68,1.55-10.3,7.19-3.8,5.85-2.62,9.46-4.43,9.43-1.59,0-1.26-7.08,2-11.88C208.35,293.84,216.7,292.54,217.2,294.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M216.14,295c.34,1.22-6,1.65-9.28,6.73-3.52,5.38-2.62,8.8-4.27,8.76-1.49,0-1-6.52,2-11C208.13,294.4,215.62,293.07,216.14,295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M215.09,295.31c.35,1.1-5.26,1.73-8.28,6.27-3.25,4.89-2.61,8.12-4.11,8.08s-.8-6,2-10C207.91,295,214.54,293.59,215.09,295.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M214,295.6c.37,1-4.55,1.82-7.26,5.82-3,4.4-2.6,7.45-4,7.4s-.58-5.4,2-9.12C207.68,295.52,213.47,294.12,214,295.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M213,295.9c.39.86-3.84,1.91-6.24,5.36-2.71,3.91-2.6,6.77-3.8,6.72s-.34-4.84,2-8.19C207.46,296.09,212.4,294.65,213,295.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M211.91,296.19c.42.74-3.14,2-5.22,4.91-2.45,3.41-2.59,6.1-3.64,6s-.12-4.28,2-7.27C207.24,296.65,211.33,295.17,211.91,296.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M210.85,296.49c.45.61-2.43,2.07-4.2,4.44-2.19,2.93-2.59,5.43-3.49,5.37s.11-3.72,2-6.35S210.27,295.69,210.85,296.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M209.79,296.78c.48.48-1.73,2.16-3.18,4-1.93,2.43-2.59,4.75-3.33,4.69s.34-3.16,1.93-5.43S209.21,296.2,209.79,296.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 224.1,
    cy: 315.06,
    r: 18.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M208.1,313.32l-2.4-.27.42-2.38,2.36.56c.05-.22.1-.45.17-.66l-2.32-.69.82-2.27,2.22,1,.3-.62-2.17-1.08,1.2-2.09,2,1.33c.13-.19.27-.37.41-.55l-2-1.45,1.55-1.84,1.77,1.66c.15-.16.32-.33.48-.48l-1.67-1.76,1.85-1.55,1.45,1.95c.18-.14.36-.28.55-.41l-1.33-2,2.09-1.21,1.09,2.17.61-.3-1-2.21,2.26-.83.7,2.32.66-.17-.57-2.36,2.38-.42.28,2.4.68,0-.15-2.43h2.42l-.15,2.43.68,0,.28-2.4,2.38.42-.57,2.36.66.17.69-2.32,2.27.83-1,2.21.61.3,1.09-2.17,2.09,1.21-1.33,2c.19.13.37.27.55.41l1.45-1.95,1.85,1.55-1.67,1.76.48.48,1.77-1.66,1.55,1.84-2,1.45c.14.18.28.36.41.55l2-1.33,1.2,2.09L238.53,308l.3.62,2.22-1,.82,2.27-2.32.69c.06.21.12.44.17.66l2.36-.56.42,2.38-2.4.27c0,.22,0,.45.05.68l2.42-.14v2.41l-2.42-.15c0,.23,0,.46-.05.68l2.4.28-.42,2.38-2.36-.57c-.05.22-.1.45-.17.67l2.32.69-.82,2.27-2.22-1c-.09.21-.2.41-.3.62l2.17,1.09-1.2,2.09-2-1.34c-.12.19-.27.37-.4.56L239,326l-1.55,1.84-1.76-1.67-.49.49,1.67,1.76L235.05,330,233.61,328c-.19.13-.36.28-.55.4l1.32,2-2.09,1.21-1.08-2.18c-.2.11-.41.21-.62.3l1,2.22-2.27.83-.68-2.32-.66.17.56,2.36-2.38.42-.27-2.4-.69,0,.15,2.43h-2.42l.15-2.43-.69,0-.27,2.4-2.38-.42.56-2.36-.66-.17-.69,2.32-2.26-.83,1-2.22c-.21-.09-.42-.19-.62-.3l-1.08,2.18-2.09-1.21,1.32-2c-.19-.12-.36-.27-.55-.4L213.15,330l-1.85-1.55,1.66-1.76-.48-.49-1.76,1.67L209.17,326l2-1.45c-.13-.19-.28-.37-.4-.56l-2,1.34-1.2-2.09,2.17-1.09c-.1-.21-.21-.41-.3-.62l-2.22,1-.82-2.27,2.32-.69c-.07-.22-.12-.45-.17-.67l-2.36.57-.42-2.38,2.4-.28c0-.22,0-.45,0-.68l-2.42.15v-2.41l2.42.14C208.07,313.77,208.07,313.54,208.1,313.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 224.1,
    cy: 315.07,
    r: 11.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M224.1,311.61a3.46,3.46,0,1,1-3.46,3.45A3.46,3.46,0,0,1,224.1,311.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M224.1,312.66a2.41,2.41,0,1,1-2.41,2.4A2.41,2.41,0,0,1,224.1,312.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M224.14,313.29a1.78,1.78,0,1,1-1.77,1.77A1.77,1.77,0,0,1,224.14,313.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M224.15,309.43a.82.82,0,1,1-.81.82A.82.82,0,0,1,224.15,309.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M224.15,309.71a.54.54,0,0,1,0,1.07.54.54,0,0,1,0-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M224.13,319.07a.82.82,0,1,1-.81.81A.81.81,0,0,1,224.13,319.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M224.13,319.35a.54.54,0,1,1-.53.53A.53.53,0,0,1,224.13,319.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M229,312.26a.81.81,0,0,1-.3,1.11.81.81,0,1,1,.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M228.78,312.4a.53.53,0,1,1-.92.53.54.54,0,0,1,.19-.73A.53.53,0,0,1,228.78,312.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M220.66,317.06a.8.8,0,0,1-.29,1.11.82.82,0,1,1,.29-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M220.42,317.2a.54.54,0,0,1-.19.73.53.53,0,0,1-.73-.2.53.53,0,1,1,.92-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M228.71,316.78a.81.81,0,0,1,.3,1.11.81.81,0,1,1-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M228.57,317a.53.53,0,0,1,.2.73.53.53,0,1,1-.92-.53A.52.52,0,0,1,228.57,317Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M220.38,311.94a.81.81,0,1,1-1.11.3A.81.81,0,0,1,220.38,311.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M220.24,312.18a.54.54,0,0,1,.19.73.53.53,0,0,1-.73.2.54.54,0,0,1,.54-.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "108.72 311.65 82.78 311.65 82.78 302.26 115.88 302.26 108.72 311.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 113.52,
    y: 294.94,
    width: 48.21,
    height: 16.34,
    rx: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 113.52,
    y: 302.39,
    width: 48.21,
    height: 0.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 113.52,
    y: 303.1,
    width: 48.21,
    height: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M114.57,294.94h.93a0,0,0,0,1,0,0v16.34a0,0,0,0,1,0,0h-.93a1,1,0,0,1-1-1V296A1,1,0,0,1,114.57,294.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M160.79,294.94h.93a0,0,0,0,1,0,0v16.34a0,0,0,0,1,0,0h-.93a1,1,0,0,1-1-1V296A1,1,0,0,1,160.79,294.94Z",
    transform: "translate(321.47 606.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 116.05,
    y: 294.94,
    width: 1.26,
    height: 16.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 157.86,
    y: 294.94,
    width: 1.26,
    height: 16.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 117.33,
    y: 294.94,
    width: 0.72,
    height: 16.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 159.13,
    y: 294.94,
    width: 0.72,
    height: 16.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 115.33,
    y: 294.94,
    width: 0.72,
    height: 16.34,
    transform: "translate(231.38 606.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 157.14,
    y: 294.94,
    width: 0.72,
    height: 16.34,
    transform: "translate(315 606.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 88.41,
    y: 187.48,
    width: 215.53,
    height: 101.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 261.55,
    y: 291.94,
    width: 1.92,
    height: 8.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 288.88,
    y: 291.94,
    width: 1.92,
    height: 8.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 258.75,
    y: 297.95,
    width: 38.29,
    height: 3.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "264.81 301.13 261.1 301.13 258.75 297.95 262.45 297.95 264.81 301.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "272.88 301.13 269.17 301.13 266.81 297.95 270.52 297.95 272.88 301.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "280.94 301.13 277.24 301.13 274.88 297.95 278.59 297.95 280.94 301.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "289.01 301.13 285.31 301.13 282.95 297.95 286.66 297.95 289.01 301.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "297.08 301.13 293.38 301.13 291.02 297.95 294.73 297.95 297.08 301.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 258.75,
    y: 297.95,
    width: 38.19,
    height: 1.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 151.35,
    y: 291.94,
    width: 2.12,
    height: 8.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 190.24,
    y: 291.94,
    width: 2.12,
    height: 8.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 148.08,
    y: 298.67,
    width: 48.02,
    height: 3.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "156.55 301.96 152.01 301.96 149.13 298.68 153.67 298.68 156.55 301.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "166.43 301.96 161.89 301.96 159.01 298.68 163.54 298.68 166.43 301.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "176.31 301.96 171.77 301.96 168.89 298.68 173.42 298.68 176.31 301.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "186.19 301.96 181.65 301.96 178.76 298.68 183.3 298.68 186.19 301.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "196.06 301.96 191.53 301.96 188.64 298.68 193.18 298.68 196.06 301.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 148.08,
    y: 298.67,
    width: 48.02,
    height: 1.92
  }), /*#__PURE__*/React.createElement("image", {
    width: 219,
    height: 104,
    transform: "translate(87.24 186.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANsAAABoCAYAAAB43YWbAAAACXBIWXMAAAsSAAALEgHS3X78AAAC4ElEQVR4Xu3dPU4bYRAG4DHZgEioEPQRJ4nEOVAuluQkiHsQcgGXkCZQMCmMjX8ImJ8ZUzxPATba9Ta8ms+z48+jHz+/59+bmwDq7GxvxxARsbf3OY6/Hj91PPBMwzDExe+LOP91Pgnb0ZejpUMyIkZLzyMyY033B65/zry3Oz/iJa/xvs6PeO5rvP35Ec95jfd5fsS6r/Ga8xcPGI/H8WEYIiImYYuIODs7jZOTb/MJA15pPB7ntG5tPX4o8FaEDQrl3LpT2KBFChtUG929aRM2KGQZCRsgbFBtNLn7JmxQyDISuqWwQRthg1Kp9Q8d5geXhQ2aCBuUyrtPqxnXglKWkbABwgalJt1IEyRQzDISNkDYoNRdN9K4FtSyjIQNEDZoImxQyiAytLh/z2ZcC9oIG5RKe5BAB61/2ABhg1K6kdDCMhK6mY2EakubtO5+2v3vocDLZcbsG7NVNmgyCduTX8oNvEzOfqtsUCgz7EEC3YQNSvnKKGi3FRGROiRQQusf2iwvIxU2qGVcC2pNW/8RwgbFdCOhnW4kFJp+ni2Na0EDrX/ooPUPLXQjYQOEDUpp/UM7rX8oZCs7aLP8Nb8KG5RT2aCQPUigjd21oJ1uJBTSjYQ2bmpDn4Wpf6tIKGEQGdpYRkI7YYNCeX+bTesfauXsp8oG1exBAp1S6x8qZabWP3QTNmiiGwmFDCJDGxMk0EfrH+qtDiJ7ywZFTJBArxQ2KLXSjdT6hyqTbO3u7Khs0EXYoJrWP9RbHUT2lg3KqWzQRNigUM71/rX+oYnKBk2EDQplZoxGtkWAVlr/UOzq6ioiVDYopRsJG6CyQZMtNQ3q2F0L2izvrqW8QTmVDZoM809Oz07ba1xGzBa20zvt8N48HIx88OGy65vriIgYRhFx+ecy9g8PZn/chO2P2wv3JKrl/KO+yy5ed/EPpRYv03ft1Uus9w/6Wo9e9+EDSm6B7R8exO3tbURE/AORwfnC//9z9QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 88.29,
    y: 290.1,
    width: 207.66,
    height: 6.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M88.29,290.1v9.46a1.15,1.15,0,0,0,1.16,1.15h11.69a1.16,1.16,0,0,0,1-.5l5-7.22H305.57V290.1Zm14.91,6.46-1.51,2.17a1.13,1.13,0,0,1-1,.5H97.47a1.16,1.16,0,0,1-1.16-1.15v-2.45a1.16,1.16,0,0,1,1.16-1.16h4.86a1.15,1.15,0,0,1,1.15,1.16A1.72,1.72,0,0,1,103.2,296.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-77",
    cx: 65.03,
    cy: 304.7,
    r: 20.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M47.26,302.75l-2.67-.3.47-2.64,2.62.63c.06-.25.12-.5.19-.74l-2.58-.76.92-2.52,2.46,1.07.33-.69-2.41-1.2,1.34-2.32,2.24,1.47c.14-.21.3-.41.45-.61l-2.17-1.6,1.72-2.06,2,1.85.54-.54-1.86-2,2.06-1.72,1.61,2.16c.2-.15.4-.31.61-.45l-1.48-2.23,2.32-1.34,1.21,2.41c.23-.11.45-.23.69-.33l-1.08-2.46,2.52-.92.77,2.58.74-.19-.63-2.62,2.64-.47.31,2.66.75,0-.16-2.7h2.68l-.17,2.7.76,0,.31-2.66,2.64.47-.63,2.62.74.19.77-2.58,2.51.92-1.07,2.46.69.33,1.21-2.41,2.32,1.34L75,289.83c.22.14.41.3.62.45l1.61-2.16,2,1.72-1.85,2,.53.54,2-1.85,1.72,2.06-2.16,1.6.45.61,2.23-1.47,1.34,2.32-2.41,1.2c.11.23.23.45.33.69l2.47-1.07.91,2.52-2.57.76c.07.24.13.49.19.74l2.62-.63.46,2.64-2.66.3c0,.26,0,.51,0,.76l2.69-.15V306l-2.69-.17c0,.25,0,.51,0,.76l2.66.31L85,309.58,82.38,309c-.06.24-.12.49-.19.73l2.57.77L83.85,313l-2.46-1.07-.33.68,2.4,1.21-1.34,2.32-2.23-1.48c-.14.21-.3.41-.45.62l2.16,1.61-1.72,2.05-1.95-1.86a6.88,6.88,0,0,1-.54.54l1.85,2-2,1.72-1.6-2.17c-.21.15-.41.31-.62.45l1.48,2.24-2.32,1.34-1.2-2.41-.69.33,1.06,2.47-2.51.91L70,321.86c-.24.07-.48.12-.73.18l.62,2.63-2.64.46-.3-2.66-.77,0,.17,2.69H63.69l.16-2.69-.76,0-.3,2.66-2.64-.46.62-2.63c-.25-.06-.5-.11-.74-.18l-.76,2.57-2.52-.91,1.07-2.47c-.24-.1-.46-.22-.69-.33l-1.2,2.41-2.32-1.34,1.47-2.24c-.21-.14-.41-.3-.61-.45l-1.6,2.17-2.06-1.72,1.85-2c-.18-.17-.36-.35-.53-.54l-2,1.86-1.72-2.05,2.17-1.61c-.15-.21-.31-.41-.45-.62l-2.24,1.48-1.34-2.32L49,312.58c-.11-.22-.23-.45-.33-.68L46.21,313l-.92-2.52,2.58-.77c-.07-.24-.13-.49-.19-.73l-2.62.63-.47-2.64,2.67-.31c0-.25,0-.51,0-.76l-2.7.17v-2.68l2.7.15C47.22,303.26,47.23,303,47.26,302.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M65,290.44A14.26,14.26,0,1,1,50.77,304.7,14.25,14.25,0,0,1,65,290.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 29.98,
    y: 282.59,
    width: 52.8,
    height: 30.28,
    transform: "translate(112.75 595.46) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M16.21,268.31,33.82,268,70.12,260a4.18,4.18,0,0,0,3.29-4.19l-.61-27.17-34.23,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M42.56,298.79a13.1,13.1,0,0,1,12.24-8.41H84.41v-39l-1.53-27.43a1.31,1.31,0,0,0-1.36-1.23c-6.92.28-39.81,1.79-46.58,5-5.17,2.49-10.84,11.79-14.84,18.05-2.87,4.48-9.2,14.45-10.48,19.54C8.53,269.64,7.88,278.59,8,283c.09,5.89,1.8,23.51,1.8,23.51H39.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M35,228.15c4.67-3.16,41.77-5.25,44.24-4.38s.88,30.91-.5,33.81-42.29,11.49-46.07,12.13-16.69.79-17.92-1.46S22.12,236.88,35,228.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M35.17,228.19c4.62-3.1,41.44-5.29,43.82-4.32s.77,30.48-.59,33.33-41.78,11.28-45.5,11.9-16.5.78-17.71-1.43S22.41,236.76,35.17,228.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M35.3,228.23c4.56-3,41.12-5.32,43.4-4.27,2.44,1.13.66,30.07-.68,32.86S36.76,267.88,33.08,268.5s-16.29.76-17.49-1.41S22.7,236.63,35.3,228.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M35.43,228.27c4.51-3,40.79-5.35,43-4.21,2.42,1.26.56,29.64-.77,32.38s-40.75,10.84-44.38,11.45-16.09.74-17.27-1.38S23,236.51,35.43,228.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M35.56,228.31c4.45-2.93,40.47-5.37,42.56-4.16,2.4,1.4.45,29.22-.86,31.91S37,266.69,33.44,267.28s-15.88.73-17-1.35S23.28,236.38,35.56,228.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M35.69,228.35c4.4-2.87,40.14-5.39,42.14-4.1,2.38,1.53.34,28.79-1,31.42s-39.72,10.42-43.26,11-15.68.72-16.83-1.32S23.57,236.26,35.69,228.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M35.83,228.39c4.33-2.81,39.8-5.41,41.71-4,2.36,1.69.24,28.38-1,30.95s-39.2,10.2-42.7,10.77-15.47.7-16.61-1.3S23.86,236.14,35.83,228.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M36,228.43c4.28-2.75,39.47-5.42,41.29-4,2.33,1.83.13,27.95-1.13,30.47S37.44,264.9,34,265.45s-15.27.69-16.4-1.27S24.15,236,36,228.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M36.09,228.47c4.22-2.69,39.13-5.43,40.87-3.94,2.3,2,0,27.53-1.22,30s-38.17,9.77-41.57,10.31S19.1,265.52,18,263.6,24.44,235.89,36.09,228.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M36.22,228.51c4.17-2.63,38.8-5.44,40.45-3.88,2.27,2.14-.08,27.1-1.31,29.52s-37.65,9.55-41,10.09-14.86.65-16-1.22S24.72,235.77,36.22,228.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M36.35,228.55c4.11-2.57,38.46-5.45,40-3.83,2.23,2.3-.19,26.69-1.4,29.05s-37.14,9.34-40.45,9.86-14.66.64-15.74-1.19S25,235.64,36.35,228.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M36.49,228.59c4-2.52,38.1-5.46,39.6-3.77,2.19,2.46-.29,26.26-1.49,28.56S38,262.51,34.71,263s-14.45.63-15.52-1.16S25.3,235.52,36.49,228.59Z"
  })), /*#__PURE__*/React.createElement("image", {
    width: 64,
    height: 75,
    transform: "translate(13.24 225.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABLCAYAAADAroEdAAAACXBIWXMAAAsSAAALEgHS3X78AAAEf0lEQVR4Xu2bUWgcVRSG/5lMLNlFKE5Ss3UVTdW+2hYN5CHaGiQSX7SiTawt1gghlRWsYrF0C5taKVWhampsTRUUbTE22gpFH4pIIZSATR4a0GjahyVrhG2LJU2y2ZnjQ3Yms9uduZPJ7uzMHb+XWXbOkJxz/3PvOffuCEQEP9J/tJ8m/rqMdw8dwJNPbMKu17pwJTmFbFZBVlFzV8VwVRGNyJi+OYfIqnvxbPszAgAIXgrAN1+dpJc6t6Mn/ibkunrMzGYwMzuHO1bejmQqzXocABCPxwWr+x8d/oDCoRX48OPPMDJ6UXA1AKdODlL/573YvPlpKIoKRVWhKCpUteBz7t6ePXstnXFKX+9hun5jGrt3v13eAHz9xRGanSfMz2eRmc/q11W1K5FMpZmjVU6OH+ulZCoNiWXohEMH9tJMthrRiIybM3N4NfZ6xRy14oGGtaUPwPFjvSTX1SOZSmPHKzs96TgAEAECUNoAnDs7QJWWtn0WUl9kWNmmrbWFzg+P+cT5BQUQShSA2tpaamxq9o3zRpYdgNPf/UixWIxl5jmoVCkwcuk3AOwCxHPkVv9lTYKnB76kaET29Gxvhlb9OFbAz2dO0MjYZV86D2BhFoRDBSQSifKVjy6xbAUAPsz7Iiw5AG2tLQRw4Dw5XAUam5pZJr7AUQpoue/70Qf0CNgOwKaNj1M0IvPhPBwUQo9tfNT2rowvWIoCYt0v8yP9HEuaAx5at55l4kNspsBPZ074qMe3D9lNgQsX/2CZ+BrLUvjc2QHfNjssyE4vcH54zOo2F5imADclrwnMOYCXktcci1Wg/s56rkcfYNQB3Tu7i33NF2aTYN+RPm5nfiOmCritWkHqn6uFX/OH2SSYTKXLdirrJYp2g1JVle/3+mxTTAHxffuKmXLNLSnA89Jn5JYUaGttoWhENn2AOwpToLGpma8dHwZFl8GgyB9A/rZ4x5YXgiV/FCjgxfanAiV/IyIADI+Os+y4I29DJAi1vxkigEDKn7khwj82t8V55X8F5BD39/QEpwM0oPcCKhGCVgQBWOwF7ru7Aelr/1obc4heCdbUhCBJjn4r5W/0XoCAaqmKYc0fugImU5OBDIA+B/w9lQpkCuirgAABQiC7gAXENWvux9XrN1h2/JFLAakmVINQZoW1MYdoKSCNT/wezBTQJsF4PC4IAYxA3paYKAYvAHntsBhEBRjbYVEMblcsAYAgCHj/vYO06423PCGFRCJB0YiMoaFRhMNhhENhvHNwf0n/N00BEgCsbbgL41cmrexdwfgmyuDg9+jo6ET71udL6riGdggkAcC3p37A+g2PWD9RJgpfv3H7dEoCgD8nJrHhYVf/LoBFqQOo2La8BADbt21DJjPNsi0p2sjfs7oOLW3PVcR5ILcKdHV3CZWoBaIRuaLOA4ZdYTerQW30KyV7I3oA3FKA1947WgyACwrwmvOAMQVE0ZU3Qh9sWM0ycZU8BbhxPrBla6dnRh8wBOBaesrKbtm4oS4n6AH45dehsh+TH/30E5aJ6/wHHODAuDDLHywAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-96",
    cx: 60.69,
    cy: 315.28,
    r: 18.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M44.72,313.53l-2.4-.27.42-2.37,2.36.56c0-.22.1-.44.17-.66L43,310.1l.83-2.26,2.21,1c.09-.21.2-.42.3-.62l-2.17-1.08,1.2-2.08,2,1.32c.12-.19.27-.37.4-.55l-2-1.44,1.55-1.85,1.76,1.66.48-.48-1.66-1.75,1.84-1.55,1.45,1.94.55-.4-1.33-2,2.09-1.2,1.08,2.16.62-.3-1-2.21,2.27-.82.69,2.31.66-.17-.57-2.35,2.38-.42L59,299.3l.67,0-.14-2.42H61.9l-.15,2.42.68,0,.28-2.39,2.37.42-.57,2.35.67.17.69-2.31,2.26.82-1,2.21.61.3,1.09-2.16,2.09,1.2-1.34,2,.56.4,1.44-1.94,1.85,1.55-1.67,1.75.49.48,1.76-1.66,1.54,1.85-2,1.44c.14.18.28.36.41.55l2-1.32,1.21,2.08-2.17,1.08c.1.2.2.41.29.62l2.22-1,.82,2.26-2.31.69c.06.22.11.44.17.66l2.35-.56.42,2.37-2.39.27c0,.23,0,.46,0,.69l2.42-.15v2.41l-2.42-.15c0,.23,0,.46,0,.69l2.39.28-.42,2.37-2.35-.57c-.05.22-.11.44-.17.66l2.31.69-.82,2.27-2.21-1-.3.62,2.17,1.09-1.21,2.08-2-1.33c-.12.19-.27.37-.4.55l1.94,1.45-1.54,1.85-1.76-1.67-.48.48,1.66,1.76-1.85,1.55-1.44-1.95c-.18.13-.36.28-.55.41l1.33,2-2.09,1.2-1.08-2.17c-.2.1-.41.21-.62.3l1,2.22-2.26.82-.69-2.32c-.21.07-.44.12-.66.17l.56,2.36-2.37.42-.27-2.4c-.23,0-.46,0-.69.05l.15,2.42H59.49l.14-2.42c-.23,0-.46,0-.68-.05l-.27,2.4-2.38-.42.56-2.36c-.22-.05-.44-.1-.66-.17L55.52,333l-2.27-.82,1-2.22c-.21-.09-.41-.2-.62-.3l-1.07,2.17-2.09-1.2,1.32-2c-.19-.13-.36-.28-.55-.41l-1.44,1.95-1.84-1.55,1.66-1.76-.49-.48-1.75,1.67-1.55-1.85,2-1.45c-.14-.18-.28-.36-.41-.55l-2,1.33-1.2-2.08,2.16-1.09c-.1-.2-.2-.41-.29-.62l-2.21,1L43,320.45l2.32-.69c-.07-.22-.12-.44-.17-.66l-2.36.57-.42-2.37,2.4-.28c0-.23,0-.46,0-.69l-2.42.15v-2.41l2.42.15C44.69,314,44.69,313.76,44.72,313.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M60.69,303.85a11.43,11.43,0,1,1-11.43,11.43A11.43,11.43,0,0,1,60.69,303.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M60.69,311.83a3.45,3.45,0,1,1-3.45,3.45A3.44,3.44,0,0,1,60.69,311.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M60.69,312.88a2.4,2.4,0,1,1-2.4,2.4A2.39,2.39,0,0,1,60.69,312.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M60.73,313.51A1.77,1.77,0,1,1,59,315.28,1.77,1.77,0,0,1,60.73,313.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M60.74,309.66a.81.81,0,1,1-.81.81A.81.81,0,0,1,60.74,309.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M60.74,309.94a.52.52,0,0,1,.53.53.53.53,0,0,1-.53.53.53.53,0,0,1-.53-.53A.53.53,0,0,1,60.74,309.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M60.72,319.28a.81.81,0,1,1-.81.81A.81.81,0,0,1,60.72,319.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M60.72,319.56a.53.53,0,1,1-.53.53A.54.54,0,0,1,60.72,319.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M65.61,312.48a.81.81,0,0,1-1.41.81.81.81,0,0,1,1.41-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M65.36,312.62a.52.52,0,0,1-.19.72.54.54,0,0,1-.73-.19.53.53,0,0,1,.2-.73A.52.52,0,0,1,65.36,312.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M57.26,317.27a.81.81,0,1,1-1.1-.3A.81.81,0,0,1,57.26,317.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M57,317.41a.53.53,0,1,1-.73-.2A.54.54,0,0,1,57,317.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M65.3,317a.81.81,0,1,1-1.11.3A.81.81,0,0,1,65.3,317Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M65.16,317.23a.54.54,0,0,1,.19.73.52.52,0,0,1-.72.19.52.52,0,0,1-.2-.72A.53.53,0,0,1,65.16,317.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M57,312.16a.81.81,0,0,1,.29,1.11.81.81,0,0,1-1.1.3.81.81,0,0,1,.81-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M56.84,312.4a.54.54,0,1,1-.73.2A.54.54,0,0,1,56.84,312.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M7.8,301.56c.13-1.57,12.51-1.64,12.88-1.36a20.83,20.83,0,0,0-3,7.72,65.23,65.23,0,0,0-.85,7.71s-6.73,0-8.17-1.77C7.74,312.75,7.7,302.83,7.8,301.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M16.12,300.72c.13.63-.67,10.31-1.8,12-.88,1.29-4.19.63-4.86.67S7.34,305.45,8,301.54C8.13,300.45,15.92,299.74,16.12,300.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M15.84,300.78c.12.6-.73,9.53-1.78,11.08-.81,1.21-3.91.72-4.53.76s-2-7.48-1.44-11.08C8.26,300.52,15.65,299.83,15.84,300.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M15.56,300.83c.11.58-.79,8.75-1.75,10.19-.75,1.13-3.63.82-4.21.85s-1.94-7.05-1.38-10.32C8.39,300.59,15.39,299.92,15.56,300.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M15.28,300.88c.09.55-.84,8-1.72,9.3-.69,1-3.35.91-3.89.94s-1.84-6.61-1.31-9.56C8.52,300.66,15.12,300,15.28,300.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M15,300.94c.09.52-.9,7.2-1.68,8.4-.63,1-3.08,1-3.57,1S8,304.19,8.49,301.56C8.65,300.73,14.86,300.09,15,300.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M14.71,301c.07.49-1,6.42-1.65,7.51-.57.88-2.8,1.1-3.25,1.12s-1.65-5.75-1.18-8.05C8.79,300.8,14.59,300.18,14.71,301Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M14.43,301.05a28.66,28.66,0,0,1-1.63,6.61c-.49.8-2.51,1.19-2.92,1.21s-1.55-5.31-1.12-7.29C8.92,300.87,14.33,300.27,14.43,301.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M14.15,301.1a26.35,26.35,0,0,1-1.6,5.72,4.83,4.83,0,0,1-2.6,1.31c-.36,0-1.45-4.89-1-6.55C9.05,300.93,14.06,300.36,14.15,301.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M13.87,301.15A24.21,24.21,0,0,1,12.3,306a4.8,4.8,0,0,1-2.28,1.4c-.31,0-1.34-4.45-1-5.79C9.19,301,13.8,300.44,13.87,301.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M13.59,301.21a23.07,23.07,0,0,1-1.54,3.93,4.93,4.93,0,0,1-2,1.49c-.27,0-1.22-4-.92-5C9.32,301.07,13.54,300.53,13.59,301.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M13.3,301.26a20.7,20.7,0,0,1-1.5,3,5.44,5.44,0,0,1-1.64,1.58,10.54,10.54,0,0,1-.86-4.28C9.46,301.14,13.27,300.62,13.3,301.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M13,301.32c0,.32-1.3,1.75-1.48,2.14a6.17,6.17,0,0,1-1.3,1.67,9.71,9.71,0,0,1-.8-3.52C9.62,301.22,13,300.71,13,301.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M10.05,310.73a37.5,37.5,0,0,0,6.72-.12c-.06,2.81.05,5,.05,5s-6.73,0-8.17-1.77c-.34-.41-.56-2-.69-4A8.79,8.79,0,0,0,10.05,310.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M7.8,301.56c.13-1.57,12.51-1.64,12.88-1.36l-.26,1.49a48,48,0,0,0-10.4-.22C9.09,301.63,7.77,301.93,7.8,301.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 15.32,
    y: 300.1,
    width: 0.88,
    height: 15.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "39.28 315.61 16.2 315.61 16.2 298.75 42.65 298.75 39.28 310.47 39.28 315.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 16.21,
    y: 298.75,
    width: 4.02,
    height: 16.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "33.78 315.61 39.16 315.61 38.85 308.32 42.55 298.75 33.78 298.75 33.78 315.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M16.21,311.83H37.93v-1.36H19.31a4,4,0,0,0-2.44.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M40.5,298.75l-2.56,9.14a21.55,21.55,0,0,0-.79,5.75v2h2.13v-2.13a21.39,21.39,0,0,1,.83-5.9l2.54-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M13.17,263.51c.65-1.31,1.16-5.85,11.52-22.72,4.13-6.71,8.28-10.16,7.19-10.9h0c-4.26,3.84-8.56,10.85-11.78,15.89-2.66,4.15-8.28,13-10.12,18.33l-.09.29c0,.05-.29.12-.29.12s0,.45,0,.8C9.62,265.32,12.52,264.81,13.17,263.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M31.41,230.33c-4.1,3.92-8.21,10.59-11.31,15.45-2.66,4.15-8.28,13-10.12,18.33l-.09.29c.91-.25,2.3-.76,2.73-1.62.66-1.31,1.5-5.77,11.86-22.64C27.63,235,30.7,232,31.41,230.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M68,266.07a3,3,0,1,1-3-3A3,3,0,0,1,68,266.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M71.16,267.12H59.69a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H71.16a1,1,0,0,1,1,1h0A1,1,0,0,1,71.16,267.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 19.29,
    y: 291.44,
    width: 6.26,
    height: 3.28,
    rx: 0.64,
    transform: "translate(44.84 586.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 19.36,
    y: 291.47,
    width: 6.09,
    height: 3.17,
    rx: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 19.44,
    y: 291.51,
    width: 5.93,
    height: 3.06,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 19.51,
    y: 291.54,
    width: 5.76,
    height: 2.95,
    rx: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 19.58,
    y: 291.58,
    width: 5.59,
    height: 2.84,
    rx: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 19.66,
    y: 291.61,
    width: 5.42,
    height: 2.73,
    rx: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 19.73,
    y: 291.65,
    width: 5.26,
    height: 2.62,
    rx: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 19.81,
    y: 291.69,
    width: 5.09,
    height: 2.5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 19.88,
    y: 291.72,
    width: 4.92,
    height: 2.39,
    rx: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 19.95,
    y: 291.76,
    width: 4.76,
    height: 2.28,
    rx: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 20.03,
    y: 291.79,
    width: 4.59,
    height: 2.17,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 20.1,
    y: 291.83,
    width: 4.42,
    height: 2.06,
    rx: 0.43,
    transform: "translate(44.62 585.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 19.63,
    y: 291.53,
    width: 5.72,
    height: 2.75,
    rx: 0.56,
    transform: "translate(44.97 585.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 19.64,
    y: 291.54,
    width: 5.68,
    height: 2.66,
    rx: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 19.66,
    y: 291.54,
    width: 5.65,
    height: 2.58,
    rx: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 19.68,
    y: 291.55,
    width: 5.61,
    height: 2.5,
    rx: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 19.7,
    y: 291.56,
    width: 5.58,
    height: 2.41,
    rx: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 19.71,
    y: 291.56,
    width: 5.54,
    height: 2.33,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 19.73,
    y: 291.57,
    width: 5.51,
    height: 2.25,
    rx: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 19.75,
    y: 291.58,
    width: 5.47,
    height: 2.17,
    rx: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 19.77,
    y: 291.58,
    width: 5.44,
    height: 2.08,
    rx: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 19.78,
    y: 291.59,
    width: 5.4,
    height: 2,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 19.8,
    y: 291.6,
    width: 5.37,
    height: 1.92,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 19.82,
    y: 291.61,
    width: 5.33,
    height: 1.83,
    rx: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 19.84,
    y: 291.61,
    width: 5.3,
    height: 1.75,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 19.85,
    y: 291.62,
    width: 5.26,
    height: 1.67,
    rx: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 19.87,
    y: 291.63,
    width: 5.23,
    height: 1.58,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 19.89,
    y: 291.63,
    width: 5.19,
    height: 1.5,
    rx: 0.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 19.9,
    y: 291.64,
    width: 5.16,
    height: 1.42,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 19.92,
    y: 291.65,
    width: 5.13,
    height: 1.33,
    rx: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 19.94,
    y: 291.65,
    width: 5.09,
    height: 1.25,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 19.96,
    y: 291.66,
    width: 5.06,
    height: 1.17,
    rx: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 19.97,
    y: 291.67,
    width: 5.02,
    height: 1.09,
    rx: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 19.99,
    y: 291.68,
    width: 4.99,
    height: 1,
    rx: 0.32,
    transform: "translate(44.97 584.35) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M24.89,292a21.19,21.19,0,0,1-4.82.18c-.19-.23-.14-.47.45-.5S24.92,291.67,24.89,292Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-173",
    width: 7,
    height: 9,
    transform: "translate(7.24 283.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAYAAAD+WDajAAAACXBIWXMAAAsSAAALEgHS3X78AAAAYUlEQVQYV4WMMQqAMBAEN5pvxOeYXwW5z5lOi3wh9jGQdm1Ewik4sMUxu2diXJlSQs4HekIIGJ2bllorNPu+wd4t0wsRYSknhtek41+KCL+k7Q9det5q4f0MkERrjSShcwGilzU3sT8pmwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M7.37,285.32c0-.43.12-.78.33-.8l4.77-.44c.4,0,.75.7.8,1.59l.21,3.65c0,.59-.14,1.08-.4,1.13l-4.86.84c-.21,0-.42-.29-.46-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M9.66,287.86c.09,1.26,0,2.29-.19,2.31s-.43-1-.51-2.3,0-2.32.2-2.31S9.58,286.6,9.66,287.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M9.16,285.56c.19,0,.42,1,.5,2.3s0,2.29-.19,2.31l2.47-1.38-.16-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M8.71,288.13c.09,1.29,0,2.35-.2,2.37s-.45-1-.54-2.35,0-2.39.21-2.38S8.63,286.84,8.71,288.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M13.48,289.31l-.21-3.68c0-.86-.43-1.58-.82-1.55l-.76.06c-.18,0-.31.32-.29.72l.28,5.34c0,.24.12.43.23.41l1.17-.17C13.34,290.4,13.52,289.9,13.48,289.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M12.6,284.45c.2.93-4,.36-4.49,1.06s-.08,5.28-.17,5.21-.7-5.36-.29-5.75C7.85,284.78,12.54,284.21,12.6,284.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M12,285.82c0,.76,0,1.37-.2,1.36s-.31-.65-.35-1.43.06-1.38.21-1.36S12,285.06,12,285.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M12.17,288.81c.05.77,0,1.39-.18,1.41s-.31-.61-.36-1.39,0-1.4.18-1.4S12.12,288.05,12.17,288.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M12.27,286.66c-.77.08-3.29-.18-3.58.1s-.13,4-.42,4.19a1.43,1.43,0,0,1-.36.12,1.18,1.18,0,0,1-.15-.5l-.39-5.25v-.09c.09-.42.28-.7.54-.72l4.56-.43a.46.46,0,0,1,.22.06,1.37,1.37,0,0,1,.45.76,2.46,2.46,0,0,1,.07.29,3.5,3.5,0,0,1,.06.48l0,.39A1.15,1.15,0,0,1,12.27,286.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M7.8,290.78l4.9-1.73c.28-.1.46-.64.43-1.28l-.06-1c-.06-.93-.06-1.77-.46-2.11a4.11,4.11,0,0,0-1.71-.42l.89-.08.68-.07a.46.46,0,0,1,.22.06,1.37,1.37,0,0,1,.45.76,2.46,2.46,0,0,1,.07.29,3.5,3.5,0,0,1,.06.48l.21,3.65c0,.59-.14,1.08-.4,1.13l-4.86.84C8,291.32,7.87,291.1,7.8,290.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M69.83,290.37A41.09,41.09,0,0,1,78.35,299a16.64,16.64,0,0,1,2.15,5.85c.82,5.61.83,14.2,1.26,16.3a17.5,17.5,0,0,0,1.74,5.59,4.83,4.83,0,0,0,2.13,1.82s-.7-6.54-.77-10.9c-.09-5.92-.45-27.3-.45-27.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "69.83 290.37 84.42 290.37 84.44 291.98 71.86 291.98 69.83 290.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M34.94,227.73a14.59,14.59,0,0,0-3.54,2.6H83.24l-.36-6.41a1.31,1.31,0,0,0-1.36-1.23C74.6,223,41.71,224.48,34.94,227.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M22.07,254.32s0,0,0-.06c.37-.8,9.18-19.95,16.06-22.31,5.27-1.81,21.8-2.92,29.42-3.36a3.71,3.71,0,0,1,3.92,3.71v17.81a4.1,4.1,0,0,1-2.66,3.83L33.47,267.11a4.22,4.22,0,0,1-1.49.27H18.53a.59.59,0,0,1-.55-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M19.48,266.07s4-12.33,6-15.81c2.22-3.85,9.07-15.88,13.06-17.07,3.67-1.1,14.22-2.45,29.07-3.3h.14a2.4,2.4,0,0,1,2.4,2.41v18.21a2.21,2.21,0,0,1-1.43,2.06L42.63,255.8A7.27,7.27,0,0,0,37.44,259l-4.53,6.9a2.31,2.31,0,0,1-.83.15Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-83",
    width: 58,
    height: 43,
    transform: "translate(15.24 226.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAArCAYAAAApMZsWAAAACXBIWXMAAAsSAAALEgHS3X78AAAD6klEQVRoQ9VYT0sbWxw9V9KMlryCMdCHRpxIg7SoKxeGcdWKunPplxDyDYIzPHVrX+EVK7wu/ACvOxNfwY1IU7NR8E82jkYEcSGixkQyyXmLvEklxo7zkvhmDhy4M/O7d+6Z3/nNnTuCJNwCTdMoSV54vWW+ehVGa2srWlslvHz5K54/b8PNTQ7pdBrPnnnw9u07YfYVThCqaRpfvPgFr1+/QSDQgY6OAFpaWpDNZjE1NQXDMCosFos/Pb6+vsbo6CgODg6wsLCA/f19xGIx8SRCNU0jAEQiEXg8HvT19SGVSmFycrJmvKIoKBQKMAwDhUIB29vbAjbR2dnJ3t5eXF1dYWtrS4BkUxiPx6nrOqPRKAEQABVFqbQB0GqMRnBwcJC7u7vWgXYZj8fvibLq00z6/f7yXKwC7fDs7Kwi0ir2KakoCj0PmtwmRkZGmMlkAADr6+u2a6qZMAwDLVZBj0E+nycAHB8fg6SjRAJAsVhE3Rnd2dlhf38/ADhSJFAWWldGE4mE40UCdVr306dFTkxMAHC2SKDOjO7u7gFwvkigLPQ/fRmdnJwwGAy6QiQAhMNh2s7o169/MxgMWoU5CoZh2HvraprG1dVVAO6wrAnb1s1ms/T5fK4SCQBdXV2Pt66mafT5fFZhjoRhGI/P6MXFBdvb212XTQAIBAKPy2gikXCtSMDGOrq4uGgV4mgUi0VYbnHM/aVVnJPZ1tZGyxoVQhBw13JSDUmSfl6jGxsbrhcJWFhXVVVH/AppBHt6eh627uHhIUOhEOjybALl8qtp3fn5OYZCoVqXXAfzHVMzo0dHR5Rl2fXZFEJQURSMjY3dr1FVVSu/Kq2872Ti37+Rp6enJHlfqJvXTQAcHh5mJBKhoijUdZ3mtXvbNEmSqk85HkII+v1+hMNhAMDMzAySyW+QZflH6d19Im5aUsx5msxkMpybm+WD8XcPnG7banH5fJ7xeJxW/cgq666srMCJEEJwYGAAQ0NDkCQJ8/PzSKVSkCRJjI+PW3Uvw1TsNNuiKnu6rvPDh99p1e/B8czG9+/J/11ktbhcLsePH/9oyJzu3cSqQzN4V1w0GuXm5iZVVW3oXEAS798vPLnIWtb8/PnPps0BJKHr+pMIrRZ3fn7O5eXlpt+XZPlbt9mba3N8AFhaWkJ3dzeSySRisVhT7lcTs7O/NSWbqMre3t5ew+vODhtq22pxuq7zy5e/GjJ2vfQAQC6Xw83NDUmiVCpVLpptj6f8XWGeN9sAQQKXl5dIp9MAgLW1Ndze3iKZTEKWZSHLMpwAoaoqp6enH3wSXq8XpVKpIvpHu4RSqXwMAOl0+unrzgb+ARfL3lBEYHxAAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-83",
    width: 55,
    height: 41,
    transform: "translate(17.24 227.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAApCAYAAACRB7GtAAAACXBIWXMAAAsSAAALEgHS3X78AAAElElEQVRoQ9WZTWhUVxiGn3PnJikB5ydNXchEmiiMdSySMHVzo104FZFEK3bTYq0G3Gh1iiBYMIE5Jk7dqLGaRbOoCBbspqGBhg4kK6/uLsZNskqCWTRgSn7wh8To14VkOjMxuckkMTcPHIaB7xzuM+93zgxnlIiwHtBai2EoDMPIGUVFRfh8PgzD4NWrV7x8+ZILF35UAGot5bTWYpo+TNOkuLgYpRTFxcWUlHxAMBjAMHz4fAbhcAWm6WPbtk+wbZuOjg5aW1tz1mpru8Xdu7+RTqe5fftXTp06rVZdTmstAIGAH6UUfr8fv99PZWUVJSXFTExMcv78eZ48ecLmzZuxbdttyQwiorLfR6NRCYVCHD9+nPHxsZVPTmstoVCQYDDIjh2fUlVVxYEDB5ienmZqamre16mpqZwHLZTt27fLuXPn2LjxIxCRFRnJZFI6Ov4Qx3EEyBmWZYnb/JUclmWJ4zhiLvw5LI5U6rLU19dTU1NDIpHAsizu37+/IkkUwszMDIZhLD+5ZDIpo6OjmZTc6t/HiMVi8ujRo+Ulp7WWs2fPUldXB8zd4GvF69evefPmDQXLaa0lHo8TCoUA74jBWzkAw6VuXiorP8ayLMBbYvB2z0GBcjdv/izHjn0HeE8MlpFcKnVZjh79FvCmGBQo19LSLIcOfUkoFPKsGBTYltFolGg06la25swmt+jTUmst6XQa8G47zrKkttRaS319PbZte14MlihXXv4hNTU1bmWeYdF7TmstJ040AN5vx1kWnVw4HKa0tNStzFMs6kBJpS6LaRYB6yc1+L8tF5SLRCIcOfLVQiWexLUtm5svyazYekoNXOS01rJz505g/YkB7Nq1C6XmkQsE/Bw8eCjzq3+9MTAwwMDAwFw5rbVUVFQArOlVQaEopWTr1q08f/58rlwwGODq1WvvmudplFJiWZYAdHV1MTg4NFcuHA4Ti8XWzV5TSkl5eblEIhEArl+/Rnv7LzQ1NamcrwKttWzatImRkZF3LuQVlFI5l63d3d08ftzL0NAQicQPmVByLmXb2m7J6dPfA947JfOFnj59yoMHNkNDQ0xOTnLxYuPc582+ErNt2zPXc7ODrMvdhoYGcRxHWluvS3PzJXGbm2nL2Zb0Avkp9ff3YdsPGBn5h+rqalVdXT3f1BwycmVlIU6ePLlQ7aqSL/TixQu6uv5ieHiYe/d+p6mpacnbJLPnenp6ZO/evch73mvZUolEgrq6Ovr7+3j27Fnmf7ZCMQGuXPlJIpFtbrUrRn5Kg4ODpNN/Mz4+TjweV/F4fL6pS8IEKC0t5fDhw261yyJfaHp6ms7OP+nr6+POnTsFtZ0bJsCWLVuA1Tn+s6UaGxvZt+8Lent7SaVSqyKUjdnS0iyx2GdudUsiPyXHcXj48AGjo/9SW7tb1dbunm/qimJu2LCB/fv3u9W5ki80NjZGT083/f39dHZ2rnpK78IMh8NAYS2ZL9Te3k5ZWYjh4WFu3LixJkLZKMdx5MyZM3zzzddutXMQEWZmZtiz5/NM2621UDYqmUxKIOB3q5uXiYlJAE9JzfIf9hyl58YyedwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M35.26,245.45a17.25,17.25,0,0,1,14-9.58l20.89-1.79h0V232.3a2.4,2.4,0,0,0-2.4-2.41h-.14c-14.85.85-25.4,2.2-29.07,3.3-4,1.19-10.84,13.22-13.06,17.07-2,3.48-6,15.81-6,15.81h12.6a2.31,2.31,0,0,0,.83-.15l1.7-2.58-5.65,0a1.55,1.55,0,0,1-1.39-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M41.73,256l-8.82,10,4.67-32.87,1.22-.44L36.57,257a.72.72,0,0,0,1,.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M19.17,276.51c-2.05,0-2.72-.92-2.72-1.44V270.8a.65.65,0,0,1,.72-.65h3.94a.73.73,0,0,1,.77.8c0,.59,0,3.28,0,4C21.86,275.51,21,276.51,19.17,276.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M16.51,270.83c0-.35.25-.57.71-.64H21.1a.74.74,0,0,1,.73.81c0,.63,0,3.26,0,4a1.27,1.27,0,0,1-.56.87,3.48,3.48,0,0,1-2.08.6c-2,0-2.65-.89-2.65-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M16.57,270.86c0-.34.25-.55.7-.63l1.34,0h1.61s.86,0,.87,0a.74.74,0,0,1,.7.82c0,.66,0,3.23,0,3.9a1.23,1.23,0,0,1-.57.82,3.56,3.56,0,0,1-2,.56c-1.9,0-2.58-.84-2.58-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M16.63,270.89c0-.33.25-.54.69-.62l1.32,0h1.59c.06,0,.84,0,.86,0,.29,0,.64.25.65.84s0,3.2,0,3.83a1.24,1.24,0,0,1-.57.79,3.75,3.75,0,0,1-2,.52c-1.84,0-2.52-.81-2.52-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M16.69,270.92c0-.31.25-.52.69-.6.07,0,1.19,0,1.29,0h1.57a7,7,0,0,1,.84.05c.28,0,.6.27.61.84,0,.73,0,3.18-.05,3.78,0,.23-.23.49-.57.74a3.86,3.86,0,0,1-1.93.48c-1.76,0-2.45-.76-2.45-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M16.75,271c0-.31.25-.52.68-.6.09,0,1.15-.05,1.28-.05h1.54a6.28,6.28,0,0,1,.82.06c.26,0,.56.29.57.86,0,.76,0,3.15-.05,3.72,0,.22-.24.46-.58.7a4.31,4.31,0,0,1-1.88.43c-1.69,0-2.38-.72-2.38-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M16.81,271c0-.3.25-.5.67-.59.11,0,1.11-.06,1.26-.06h1.52a3.76,3.76,0,0,1,.81.08c.24,0,.52.3.53.86,0,.8,0,3.13-.06,3.67,0,.21-.25.43-.59.65a4.51,4.51,0,0,1-1.82.4c-1.62,0-2.32-.68-2.32-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M16.87,271c0-.29.25-.49.66-.58.13,0,1.06-.06,1.24-.06h1.51a3.4,3.4,0,0,1,.78.08c.22.05.48.32.49.88,0,.83,0,3.1-.07,3.61,0,.2-.26.4-.58.6a4.9,4.9,0,0,1-1.78.36c-1.55,0-2.25-.64-2.25-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M16.93,271.05c0-.28.25-.47.66-.57.14,0,1-.07,1.21-.07h1.49a2.59,2.59,0,0,1,.76.1c.21.05.44.34.45.89,0,.86,0,3.07-.07,3.55,0,.19-.27.36-.59.56a5.56,5.56,0,0,1-1.73.32c-1.47,0-2.18-.6-2.18-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M17,271.08c0-.27.25-.46.65-.55a10.69,10.69,0,0,1,1.2-.09H20.3a2.43,2.43,0,0,1,.75.11c.18.06.39.36.4.9a34,34,0,0,1-.07,3.5c0,.18-.29.33-.6.51a5.79,5.79,0,0,1-1.67.28c-1.41,0-2.12-.56-2.12-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M17.05,271.11c0-.25.24-.45.64-.54a8.46,8.46,0,0,1,1.18-.09h1.44a2.2,2.2,0,0,1,.73.11c.17.07.35.38.37.92a31.65,31.65,0,0,1-.09,3.44c0,.17-.29.3-.59.47a7.21,7.21,0,0,1-1.63.24c-1.33,0-2.05-.53-2.05-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M17.12,271.14c0-.24.23-.43.62-.53a8,8,0,0,1,1.16-.1h1.42a1.65,1.65,0,0,1,.72.13c.14.07.3.4.32.92a27.89,27.89,0,0,1-.09,3.39c0,.16-.28.32-.6.42a6.4,6.4,0,0,1-1.58.2c-1.26,0-2-.48-2-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M17.18,271.17c0-.23.23-.42.61-.52a6.48,6.48,0,0,1,1.14-.11h1.41a1.46,1.46,0,0,1,.69.14c.13.08.26.42.28.94a23.07,23.07,0,0,1-.09,3.33.82.82,0,0,1-.61.37,7.46,7.46,0,0,1-1.52.16c-1.2,0-1.91-.44-1.91-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M17.24,271.2c0-.22.23-.4.61-.51a6,6,0,0,1,1.12-.12h1.38c.24,0,.62.07.67.16a1.53,1.53,0,0,1,.24.95,20.33,20.33,0,0,1-.1,3.27c0,.14-.29.27-.61.33a10.53,10.53,0,0,1-1.47.12c-1.12,0-1.84-.4-1.84-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M17.3,271.23c0-.21.23-.39.6-.49a4.43,4.43,0,0,1,1.1-.13h1.36a1.24,1.24,0,0,1,.66.16,2.12,2.12,0,0,1,.2,1,18,18,0,0,1-.11,3.22c-.05.13-.3.24-.61.28a12.65,12.65,0,0,1-1.42.08c-1.06,0-1.78-.36-1.78-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M17.36,271.26c0-.2.23-.37.59-.48a3.83,3.83,0,0,1,1.08-.14h1.34a.94.94,0,0,1,.64.18,2.6,2.6,0,0,1,.16,1,16.17,16.17,0,0,1-.11,3.16.8.8,0,0,1-.62.24s-1.31,0-1.37,0c-1,0-1.71-.32-1.71-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M20.38,275.14H19.06c-.91,0-1.64-.28-1.64-.62V271.3c0-.35.73-.63,1.64-.63h1.32c.3,0,.56.08.62.19A14.74,14.74,0,0,1,21,275C20.94,275.06,20.68,275.14,20.38,275.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M19.6,272.49c.11-.21-1.32,3-2.64,2.86-.72-.06-.15-4.81,0-4.94.41-.43,3.24-.3,3.71-.08S19.46,272.77,19.6,272.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M19.53,272.4c.1-.2-1.26,2.8-2.51,2.69-.7-.06-.18-4.52-.05-4.65.39-.41,3.05-.29,3.51-.08S19.39,272.65,19.53,272.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M19.45,272.3c.09-.17-1.19,2.63-2.37,2.52-.67-.05-.2-4.22-.08-4.35.36-.39,2.86-.28,3.31-.09S19.32,272.53,19.45,272.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M19.37,272.2c.09-.15-1.12,2.46-2.24,2.36-.63-.05-.21-3.93-.1-4.05.33-.38,2.67-.28,3.1-.1S19.25,272.41,19.37,272.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M19.29,272.11c.08-.14-1,2.28-2.1,2.19-.61-.06-.23-3.64-.13-3.76.3-.35,2.48-.27,2.9-.1S19.18,272.29,19.29,272.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M19.21,272c.07-.12-1,2.1-2,2-.58,0-.26-3.34-.16-3.46.27-.33,2.29-.26,2.7-.1S19.11,272.17,19.21,272Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M19.13,271.91c.07-.09-.9,1.93-1.82,1.86-.55,0-.28-3-.19-3.16.24-.32,2.1-.25,2.49-.12S19,272.05,19.13,271.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M19.05,271.82c.06-.08-.83,1.75-1.69,1.68-.52,0-.29-2.75-.21-2.86.21-.3,1.91-.24,2.29-.12S19,271.93,19.05,271.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M19,271.72c.05-.06-.76,1.58-1.55,1.52-.49,0-.32-2.45-.24-2.56.18-.28,1.72-.24,2.09-.13S18.89,271.81,19,271.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M18.89,271.62c.05,0-.69,1.4-1.41,1.35-.46,0-.34-2.15-.27-2.26s1.53-.23,1.88-.13S18.82,271.68,18.89,271.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M18.81,271.53s-.62,1.22-1.28,1.18c-.43,0-.35-1.86-.29-2s1.34-.22,1.68-.14S18.75,271.56,18.81,271.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M18.73,271.43s-.55,1.05-1.14,1c-.4,0-.37-1.57-.32-1.67s1.15-.22,1.47-.15S18.69,271.45,18.73,271.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M18.65,271.33s-.48.88-1,.85c-.37,0-.4-1.27-.35-1.37s1-.21,1.27-.15S18.62,271.33,18.65,271.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M18.57,271.24s-.41.7-.86.68-.42-1-.38-1.07.77-.2,1.07-.16S18.55,271.2,18.57,271.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M18.49,271.14a.89.89,0,0,1-.73.51c-.31,0-.43-.67-.4-.77s.58-.19.86-.17S18.48,271.09,18.49,271.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M18.41,271c0,.08-.27.35-.59.35s-.45-.38-.43-.48.39-.18.66-.17A.36.36,0,0,1,18.41,271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M18.33,271c0,.09-.2.17-.45.17s-.46-.08-.46-.17.2-.18.46-.18S18.33,270.85,18.33,271Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-220"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(16.24 253.5)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "translate(17.24 253.5)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(18.24 253.5)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-222"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 4,
    transform: "translate(17.24 269.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAECAYAAABP2FU6AAAACXBIWXMAAAsSAAALEgHS3X78AAAAE0lEQVQIW2NgYGD4z8TAwMCAIAAQQAEGq2B6TAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 25,
    transform: "translate(17.24 247.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAZCAYAAAASTF8GAAAACXBIWXMAAAsSAAALEgHS3X78AAAAWUlEQVQoU+2KsQ2AIBRE7wiVLED+GoZZLFgeC2IlA0hxViToCMaXXPPeURIGJLXljL0UuDUlkdSQrZ3o/YKn94hmOGolZqKZlhAkCfMIQJKebwDuLf7w+XADOrInpjjHVuUAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-223"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 2,
    transform: "translate(20.24 247.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAACCAYAAAB/qH1jAAAACXBIWXMAAAsSAAALEgHS3X78AAAAKElEQVQIWwXBQREAIAgAsJ19POLwILVnDqmAG0xWzY4YzMoq3c89B3zJ6gviZuqjkgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-224"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 4,
    transform: "translate(20.24 269.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAYAAACk7+45AAAACXBIWXMAAAsSAAALEgHS3X78AAAAKklEQVQIWwXBwQkAIAwEwY0Y8zgwLQjpv8ZzBsC2iVPl2816MwDEzrQkPqKFBtTbZjTJAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 3,
    height: 23,
    transform: "translate(19.24 249.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAXCAYAAADOb/UyAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQYV1WOQQ6CQAxF3+9GcCYSAxLDyoSg3v9qHOC7GAawu9/XvhbbALZNSPLwGADgOU3eyTYjAG1dAYQkakVEHEHnEBKSvJOmbQsZxpFz+ZrScbTqY14Wqj7e3w9VHyklon6Rc/a974tgXVdVUmx1508N7GrZ5tI0vnVdIa95BuAHFQMpKey9ggEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 2,
    transform: "translate(20.24 249.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAACCAYAAAB/qH1jAAAACXBIWXMAAAsSAAALEgHS3X78AAAAK0lEQVQIW2NgYGD47+zm9p+BgeG/tJzcf0YWFpb///79Y5CUkWEQFhFhAACuhgm1I+pT1QAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M26.9,261.05h-4a2.1,2.1,0,0,1-2.11-2.11V244a2.28,2.28,0,0,1,2.29-2.29H27a1.07,1.07,0,0,1,1,.74,27.36,27.36,0,0,1,1.22,8.48A36.93,36.93,0,0,1,28,260.25,1.09,1.09,0,0,1,26.9,261.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M26.88,260.94H23a2.11,2.11,0,0,1-2.11-2.12V244.1a2.28,2.28,0,0,1,2.28-2.28h3.76a1.06,1.06,0,0,1,1,.74,27.6,27.6,0,0,1,1.19,8.4,36.73,36.73,0,0,1-1.22,9.18A1.08,1.08,0,0,1,26.88,260.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M26.86,260.82H23.13A2.12,2.12,0,0,1,21,258.7V244.21a2.27,2.27,0,0,1,2.28-2.27h3.62a1.05,1.05,0,0,1,1,.73A27.83,27.83,0,0,1,29.08,251a37,37,0,0,1-1.19,9A1.07,1.07,0,0,1,26.86,260.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M26.84,260.71H23.25a2.12,2.12,0,0,1-2.12-2.13V244.32a2.27,2.27,0,0,1,2.27-2.27h3.49a1,1,0,0,1,1,.73A28.08,28.08,0,0,1,29,251a36.41,36.41,0,0,1-1.16,8.93A1.05,1.05,0,0,1,26.84,260.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M26.83,260.59H23.38a2.13,2.13,0,0,1-2.13-2.13v-14a2.26,2.26,0,0,1,2.26-2.26h3.36a1,1,0,0,1,1,.72A28.86,28.86,0,0,1,28.94,251a36.39,36.39,0,0,1-1.12,8.79A1,1,0,0,1,26.83,260.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M26.81,260.48H23.5a2.13,2.13,0,0,1-2.13-2.14v-13.8a2.26,2.26,0,0,1,2.25-2.26h3.23a1,1,0,0,1,1,.72,28.77,28.77,0,0,1,1.06,8.05,36.88,36.88,0,0,1-1.08,8.66A1,1,0,0,1,26.81,260.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M26.79,260.36H23.62a2.13,2.13,0,0,1-2.13-2.14V244.65a2.24,2.24,0,0,1,2.25-2.25h3.08a1,1,0,0,1,1,.71,29.56,29.56,0,0,1,1,8,36.13,36.13,0,0,1-1.06,8.54A1,1,0,0,1,26.79,260.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M26.77,260.24h-3a2.14,2.14,0,0,1-2.14-2.14V244.75a2.25,2.25,0,0,1,2.25-2.24H26.8a1,1,0,0,1,.94.71,29.88,29.88,0,0,1,1,7.88,36.65,36.65,0,0,1-1,8.4A1,1,0,0,1,26.77,260.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M26.75,260.13H23.87A2.15,2.15,0,0,1,21.72,258V244.86A2.23,2.23,0,0,1,24,242.63h2.82a1,1,0,0,1,.93.7,30.94,30.94,0,0,1,1,7.79,36.58,36.58,0,0,1-1,8.27A1,1,0,0,1,26.75,260.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M26.73,260H24a2.15,2.15,0,0,1-2.15-2.15V245a2.23,2.23,0,0,1,2.23-2.23h2.69a.94.94,0,0,1,.91.7,30.89,30.89,0,0,1,.93,7.7,36.74,36.74,0,0,1-1,8.15A.94.94,0,0,1,26.73,260Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M26.71,259.9h-2.6A2.16,2.16,0,0,1,22,257.74V245.08a2.21,2.21,0,0,1,2.22-2.22h2.55a.91.91,0,0,1,.9.69,31.13,31.13,0,0,1,.91,7.61,36.64,36.64,0,0,1-.92,8A.93.93,0,0,1,26.71,259.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M26.69,259.78H24.23a2.16,2.16,0,0,1-2.16-2.16V245.19A2.22,2.22,0,0,1,24.29,243h2.42a.92.92,0,0,1,.89.69,32.43,32.43,0,0,1,.87,7.53,36.61,36.61,0,0,1-.88,7.88A.92.92,0,0,1,26.69,259.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M26.67,259.67H24.36a2.17,2.17,0,0,1-2.17-2.17V245.3a2.21,2.21,0,0,1,2.21-2.21h2.29a.88.88,0,0,1,.87.68,32.4,32.4,0,0,1,.84,7.44,36.55,36.55,0,0,1-.85,7.75A.89.89,0,0,1,26.67,259.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M26.65,259.55H24.48a2.17,2.17,0,0,1-2.17-2.17v-12a2.21,2.21,0,0,1,2.2-2.21h2.16a.88.88,0,0,1,.86.68,33.87,33.87,0,0,1,.8,7.35,36.82,36.82,0,0,1-.81,7.63A.88.88,0,0,1,26.65,259.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M26.64,259.44h-2a2.17,2.17,0,0,1-2.17-2.17V245.51a2.19,2.19,0,0,1,2.19-2.19h2a.87.87,0,0,1,.85.67,34.5,34.5,0,0,1,.77,7.27,37.84,37.84,0,0,1-.77,7.49A.88.88,0,0,1,26.64,259.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M26.62,259.32h-1.9a2.18,2.18,0,0,1-2.18-2.17V245.62a2.19,2.19,0,0,1,2.19-2.19h1.89a.86.86,0,0,1,.84.68,35.87,35.87,0,0,1,.74,7.17,36.9,36.9,0,0,1-.75,7.36A.85.85,0,0,1,26.62,259.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M26.6,259.21H24.85A2.19,2.19,0,0,1,22.66,257v-11.3a2.18,2.18,0,0,1,2.18-2.18H26.6a.83.83,0,0,1,.82.67,35.93,35.93,0,0,1,.71,7.08,38.14,38.14,0,0,1-.71,7.24A.84.84,0,0,1,26.6,259.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M25,249.93c.14-.75-1.76,10.45-3.51,10-1-.24-.22-16.75.53-17.39s3.75-1,4.37-.22S24.78,250.89,25,249.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M24.89,249.55c.14-.68-1.66,9.84-3.32,9.44-.93-.23-.25-15.72.46-16.34s3.53-1,4.13-.25S24.71,250.43,24.89,249.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M24.82,249.17c.13-.61-1.57,9.23-3.14,8.85-.89-.21-.27-14.69.39-15.29s3.3-.95,3.89-.27S24.65,250,24.82,249.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M24.75,248.79c.11-.54-1.48,8.61-3,8.27-.84-.2-.29-13.66.32-14.25s3.09-.92,3.66-.3S24.59,249.51,24.75,248.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M24.67,248.41c.11-.47-1.38,8-2.78,7.68-.81-.18-.32-12.63.25-13.2s2.87-.9,3.42-.32S24.53,249.05,24.67,248.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M24.6,248c.1-.41-1.29,7.37-2.6,7.09-.77-.17-.35-11.61.17-12.15s2.66-.88,3.2-.35S24.46,248.6,24.6,248Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M24.52,247.66c.09-.34-1.19,6.76-2.42,6.5-.72-.15-.36-10.57.11-11.1s2.44-.86,3-.37S24.4,248.14,24.52,247.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M24.45,247.28c.08-.27-1.1,6.15-2.24,5.92-.69-.15-.39-9.55,0-10.06a2.87,2.87,0,0,1,2.73-.4C25.47,243.18,24.34,247.67,24.45,247.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M24.38,246.9c.06-.2-1,5.53-2.06,5.33-.65-.13-.42-8.51,0-9a2.59,2.59,0,0,1,2.49-.42C25.25,243.19,24.27,247.21,24.38,246.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M24.3,246.53c.06-.14-.92,4.91-1.87,4.73-.61-.11-.44-7.48-.11-7.95a2.27,2.27,0,0,1,2.25-.45C25,243.2,24.21,246.75,24.3,246.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M24.23,246.15c0-.07-.83,4.3-1.7,4.15-.57-.1-.46-6.46-.18-6.91a2,2,0,0,1,2-.47C24.81,243.21,24.14,246.29,24.23,246.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M24.15,245.77c.05,0-.73,3.69-1.51,3.56-.53-.08-.49-5.42-.25-5.86a1.77,1.77,0,0,1,1.78-.5C24.6,243.21,24.1,245.84,24.15,245.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M24.08,245.39c0,.08-.64,3.07-1.33,3-.49-.07-.51-4.4-.33-4.82A1.51,1.51,0,0,1,24,243C24.38,243.22,24,245.38,24.08,245.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M24,245c0,.14-.55,2.45-1.15,2.38s-.54-3.36-.4-3.76a1.23,1.23,0,0,1,1.31-.55C24.16,243.23,24,244.92,24,245Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M23.93,244.64c0,.21-.45,1.84-1,1.8s-.56-2.34-.46-2.72a1,1,0,0,1,1.07-.57C24,243.24,23.91,244.46,23.93,244.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M23.86,244.26c0,.28-.37,1.24-.79,1.21s-.59-1.31-.54-1.67a.81.81,0,0,1,.85-.6C23.73,243.25,23.85,244,23.86,244.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M23.79,243.88a.62.62,0,0,1-.61.63.63.63,0,1,1,.61-.63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-226",
    cx: 167.92,
    cy: 147.31,
    rx: 155.28,
    ry: 10.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M241.3,146.82c0,2.84,8.71,5.14,19.46,5.14s19.47-2.3,19.47-5.14-8.71-5.13-19.47-5.13S241.3,144,241.3,146.82Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-228",
    cx: 252.01,
    cy: 140.77,
    rx: 19.47,
    ry: 5.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M78.44,147c0,2.84,8.72,5.14,19.47,5.14s19.46-2.3,19.46-5.14-8.71-5.13-19.46-5.13S78.44,144.21,78.44,147Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-230",
    cx: 105.26,
    cy: 143.26,
    rx: 19.47,
    ry: 5.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-231",
    x: 160.36,
    y: 108.57,
    width: 48.21,
    height: 16.34,
    rx: 1.1,
    transform: "translate(368.93 233.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 160.36,
    y: 116.02,
    width: 48.21,
    height: 0.73,
    transform: "translate(368.93 232.76) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 160.36,
    y: 116.73,
    width: 48.21,
    height: 0.73,
    transform: "translate(368.93 234.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M207.64,108.57h.93a0,0,0,0,1,0,0v16.34a0,0,0,0,1,0,0h-.93a1,1,0,0,1-1-1V109.62A1,1,0,0,1,207.64,108.57Z",
    transform: "translate(415.16 233.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M161.41,108.57h.93a0,0,0,0,1,0,0v16.34a0,0,0,0,1,0,0h-.93a1,1,0,0,1-1-1V109.62A1,1,0,0,1,161.41,108.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 204.77,
    y: 108.57,
    width: 1.26,
    height: 16.34,
    transform: "translate(410.81 233.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 162.97,
    y: 108.57,
    width: 1.26,
    height: 16.34,
    transform: "translate(327.19 233.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 204.04,
    y: 108.57,
    width: 0.72,
    height: 16.34,
    transform: "translate(408.8 233.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 162.24,
    y: 108.57,
    width: 0.72,
    height: 16.34,
    transform: "translate(325.21 233.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 206.04,
    y: 108.57,
    width: 0.72,
    height: 16.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 164.23,
    y: 108.57,
    width: 0.72,
    height: 16.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M20.17,117.23v4.24h11v-4.32l6.25-1.34v-4.9H35.56v2.51l-4.4,1.25v-7.46h-1.8v8l-6.64,2.07Zm4.24,3.59v-2.45l4.95-.93v3.38Zm-3.81,0v-3h2.12v3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M18.75,117.13h1.58a0,0,0,0,1,0,0v4.34a0,0,0,0,1,0,0H18.75a.22.22,0,0,1-.22-.22v-3.9A.22.22,0,0,1,18.75,117.13Z",
    transform: "translate(38.86 238.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 18.15,
    y: 117.13,
    width: 0.38,
    height: 4.34,
    transform: "translate(36.67 238.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-244",
    cx: 102.94,
    cy: 123.7,
    r: 18.31,
    transform: "translate(-57.32 109.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M119.12,121.93l2.42-.27-.42-2.4-2.39.56c0-.22-.11-.45-.17-.67l2.34-.69-.83-2.29-2.24,1-.3-.62,2.19-1.09-1.22-2.11-2,1.34c-.12-.2-.27-.37-.41-.56l2-1.46-1.57-1.87-1.78,1.68c-.16-.16-.32-.33-.49-.48l1.69-1.78L114,108.61l-1.47,2c-.18-.14-.36-.28-.55-.41l1.34-2-2.11-1.22-1.1,2.19c-.21-.1-.41-.21-.62-.3l1-2.24-2.29-.83-.7,2.34-.67-.17.57-2.39-2.4-.42-.28,2.42-.68,0,.14-2.45h-2.44l.15,2.45-.69,0-.28-2.42-2.4.42.57,2.39-.67.17-.7-2.34-2.29.83,1,2.24c-.22.09-.42.2-.63.3l-1.1-2.19-2.11,1.22,1.35,2-.56.41-1.47-2L90,110.18,91.69,112l-.49.48-1.78-1.68-1.57,1.87,2,1.46c-.14.19-.28.36-.41.56l-2-1.34-1.22,2.11,2.2,1.09c-.1.21-.21.41-.3.62l-2.25-1L85,118.46l2.34.69c-.06.22-.11.45-.17.67l-2.39-.56-.42,2.4,2.43.27c0,.23,0,.46,0,.69l-2.45-.14v2.44l2.45-.15c0,.23,0,.46,0,.69l-2.43.28.42,2.4,2.39-.57c0,.22.11.45.17.67l-2.34.7.83,2.29,2.24-1,.3.63L86.16,132l1.22,2.11,2-1.35c.13.19.28.37.41.56l-2,1.47,1.57,1.86L91.2,135c.16.16.32.33.49.49L90,137.22l1.86,1.57,1.46-2,.56.41-1.34,2,2.11,1.22,1.09-2.2.63.3-1,2.25,2.29.83.69-2.34.67.17-.56,2.39,2.4.42.27-2.43c.24,0,.47,0,.7,0l-.15,2.45h2.44l-.14-2.45c.23,0,.46,0,.69,0l.27,2.43,2.4-.42-.56-2.39.67-.17.69,2.34,2.29-.83-1-2.25c.21-.09.41-.2.62-.3l1.09,2.2,2.11-1.22-1.34-2c.2-.13.37-.27.56-.41l1.46,2,1.87-1.57-1.68-1.78.48-.49,1.78,1.68,1.57-1.86-2-1.47c.14-.19.28-.37.41-.56l2,1.35,1.22-2.11-2.19-1.1c.1-.21.21-.41.3-.63l2.24,1,.83-2.29-2.34-.7c.06-.22.12-.45.17-.67l2.39.57.42-2.4-2.42-.28c0-.23,0-.46,0-.69l2.45.15v-2.44l-2.45.14C119.15,122.39,119.14,122.16,119.12,121.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M102.94,110.72a13,13,0,1,0,13,13A13,13,0,0,0,102.94,110.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 52.38,
    y: 112.53,
    width: 38.29,
    height: 12.71,
    rx: 2.14,
    transform: "translate(143.05 237.76) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 146.83,
    y: 104.79,
    width: 1.26,
    height: 24.22,
    transform: "translate(226.88 -53.69) rotate(76.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 117.16,
    y: 106.57,
    width: 3.72,
    height: 34.25,
    rx: 0.63,
    transform: "translate(211.65 -20.83) rotate(76.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 114.27,
    y: 104.26,
    width: 125.05,
    height: 11.63,
    transform: "translate(353.58 220.14) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 114.27,
    y: 113.07,
    width: 125.05,
    height: 2.82,
    transform: "translate(353.58 228.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-252",
    x: 26.14,
    y: 105.46,
    width: 88.13,
    height: 7.34,
    transform: "translate(140.41 218.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-253",
    x: 26.14,
    y: 111.02,
    width: 88.13,
    height: 1.78,
    transform: "translate(140.41 223.82) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M116.71,115.79a21.25,21.25,0,0,0-18.5-10.22,21.83,21.83,0,0,0-18.55,10.29C92.08,115.65,103.41,115.6,116.71,115.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M122.66,130.82s2.86-26.62-24.73-26.62c-25.46,0-24.89,22.9-24.65,26.44h4s-2-22.57,20.66-22.57,20.72,23,20.72,23S120.32,131,122.66,130.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M97.41,106.71c-22.26,0-21.76,20.59-21.53,23.93h1.39s-2-22.57,20.66-22.57,20.72,23,20.72,23,.65,0,1.71-.11h0S121.65,106.71,97.41,106.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M100.65,107.17c-.25,1.82,9.51,1.2,14.38,9s2.64,12.15,5,12.15c2,0,2.18-9.32-2.09-15.57C112.86,105.23,101.07,104.07,100.65,107.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M101.71,107.46c-.26,1.71,8.8,1.3,13.36,8.56s2.64,11.48,4.89,11.47c1.93,0,2-8.76-2.07-14.65C113.08,105.79,102.15,104.59,101.71,107.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M102.77,107.76c-.28,1.58,8.09,1.38,12.34,8.1s2.63,10.81,4.74,10.79c1.81,0,1.72-8.2-2.06-13.73C113.3,106.35,103.23,105.12,102.77,107.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M103.83,108.05c-.3,1.46,7.38,1.47,11.32,7.65,4.07,6.34,2.63,10.13,4.58,10.11,1.71,0,1.49-7.64-2-12.81C113.52,106.91,104.31,105.65,103.83,108.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M104.89,108.35c-.32,1.34,6.68,1.55,10.3,7.19,3.8,5.85,2.62,9.46,4.43,9.43,1.59,0,1.26-7.08-2-11.88C113.74,107.47,105.39,106.17,104.89,108.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M106,108.64c-.33,1.22,6,1.65,9.28,6.73,3.52,5.38,2.62,8.8,4.27,8.76,1.49,0,1-6.52-2-11C114,108,106.47,106.7,106,108.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M107,108.94c-.35,1.1,5.25,1.73,8.27,6.27,3.25,4.89,2.61,8.12,4.11,8.08s.8-6-2-10C114.18,108.59,107.55,107.22,107,108.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M108.06,109.23c-.37,1,4.55,1.82,7.26,5.82,3,4.4,2.6,7.45,4,7.4s.58-5.4-2-9.12C114.41,109.15,108.62,107.75,108.06,109.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M109.12,109.53c-.39.86,3.84,1.91,6.24,5.36,2.71,3.91,2.6,6.77,3.8,6.72s.34-4.84-2-8.19C114.63,109.72,109.69,108.28,109.12,109.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M110.18,109.82c-.42.74,3.14,2,5.22,4.9,2.45,3.42,2.59,6.11,3.64,6s.12-4.28-2-7.27C114.85,110.28,110.76,108.8,110.18,109.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M111.24,110.12c-.45.61,2.43,2.07,4.2,4.44,2.19,2.93,2.59,5.43,3.49,5.37s-.11-3.72-2-6.35S111.82,109.32,111.24,110.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M112.3,110.41c-.48.48,1.73,2.16,3.18,4,1.93,2.43,2.59,4.75,3.33,4.69s-.34-3.16-1.93-5.43S112.88,109.83,112.3,110.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-257",
    cx: 97.99,
    cy: 128.69,
    r: 18.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M114,127l2.4-.28L116,124.3l-2.36.56c0-.22-.1-.45-.17-.66l2.32-.69-.82-2.27-2.22,1-.3-.62,2.17-1.08-1.2-2.09-2,1.33c-.13-.19-.27-.37-.41-.55l2-1.45-1.55-1.84-1.77,1.66c-.15-.17-.32-.33-.48-.48l1.67-1.76-1.85-1.55-1.45,2c-.18-.14-.36-.28-.55-.41l1.33-2-2.09-1.21-1.09,2.17-.61-.3,1-2.21-2.26-.83-.7,2.32-.66-.17.57-2.36-2.38-.42-.28,2.4-.67,0,.14-2.43H96.78l.16,2.43-.69,0-.28-2.4-2.38.42.57,2.36-.66.17-.69-2.32-2.27.83,1,2.21-.61.3-1.09-2.17-2.09,1.21,1.33,2c-.19.13-.37.27-.55.41l-1.45-2-1.85,1.55,1.67,1.76-.48.48-1.77-1.66-1.55,1.84,2,1.45c-.14.18-.28.36-.41.55l-2-1.33-1.21,2.09,2.17,1.08-.3.62-2.22-1-.82,2.27,2.32.69c-.06.21-.12.44-.17.66L80,124.3l-.42,2.37L82,127c0,.22,0,.45,0,.68l-2.42-.14v2.41l2.42-.15c0,.23,0,.46,0,.68l-2.4.28.42,2.38,2.36-.57c0,.22.1.45.17.67l-2.32.69.82,2.27,2.22-1c.09.21.2.41.3.62l-2.17,1.09L82.6,139l2-1.34c.12.19.27.37.4.56l-2,1.45,1.55,1.84,1.76-1.67c.16.17.32.33.49.49l-1.67,1.76L87,143.62l1.44-2c.19.13.37.28.56.4l-1.33,2,2.09,1.21,1.08-2.18c.2.11.41.21.62.3l-1,2.22,2.27.83.68-2.32.66.17-.56,2.36,2.38.42.27-2.4.7,0-.16,2.43H99.2l-.14-2.43.68,0,.27,2.4,2.38-.42-.56-2.36.66-.17.69,2.32,2.26-.83-1-2.22c.21-.09.42-.19.62-.3l1.08,2.18,2.09-1.21-1.32-2c.19-.12.36-.27.55-.4l1.44,2,1.85-1.55-1.66-1.76.48-.49,1.76,1.67,1.55-1.84-2-1.45c.13-.19.28-.37.41-.56l2,1.34,1.2-2.09-2.17-1.09c.11-.21.21-.41.3-.62l2.22,1,.82-2.27-2.32-.69c.07-.22.12-.45.18-.67l2.35.57.42-2.38-2.4-.28c0-.22,0-.45.05-.68l2.42.15v-2.41l-2.42.14C114,127.4,114,127.17,114,127Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-259",
    cx: 97.99,
    cy: 128.69,
    r: 11.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M98,125.24a3.46,3.46,0,1,0,3.46,3.45A3.46,3.46,0,0,0,98,125.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M98,126.29a2.41,2.41,0,1,0,2.41,2.4A2.41,2.41,0,0,0,98,126.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M98,126.92a1.78,1.78,0,1,0,1.77,1.77A1.77,1.77,0,0,0,98,126.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M97.94,123.06a.82.82,0,1,0,.81.82A.82.82,0,0,0,97.94,123.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M97.94,123.34a.54.54,0,0,0,0,1.07.54.54,0,0,0,0-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M98,132.7a.82.82,0,1,0,.81.81A.81.81,0,0,0,98,132.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M98,133a.54.54,0,1,0,.53.53A.53.53,0,0,0,98,133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M93.07,125.89a.81.81,0,0,0,.3,1.11.81.81,0,1,0-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M93.31,126a.53.53,0,1,0,.92.53.54.54,0,0,0-.19-.73A.53.53,0,0,0,93.31,126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M101.43,130.69a.81.81,0,1,0,1.11-.3A.81.81,0,0,0,101.43,130.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M101.67,130.83a.54.54,0,0,0,.19.73.53.53,0,0,0,.73-.2.53.53,0,1,0-.92-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M93.38,130.41a.81.81,0,0,0-.3,1.11.81.81,0,1,0,.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M93.52,130.65a.53.53,0,0,0-.2.73.55.55,0,0,0,.73.2.54.54,0,0,0,.19-.73A.52.52,0,0,0,93.52,130.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M101.71,125.57a.81.81,0,0,0-.29,1.11.81.81,0,1,0,.29-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M101.85,125.81a.54.54,0,0,0-.19.73.53.53,0,0,0,.73.2.54.54,0,0,0-.54-.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "213.37 125.28 239.32 125.28 239.32 115.89 206.21 115.89 213.37 125.28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 17.55,
    y: 1.52,
    width: 215.53,
    height: 101.6,
    transform: "translate(250.64 104.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 58.62,
    y: 105.57,
    width: 1.92,
    height: 8.06,
    transform: "translate(119.16 219.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-278",
    x: 31.29,
    y: 105.57,
    width: 1.92,
    height: 8.06,
    transform: "translate(64.5 219.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 25.06,
    y: 111.58,
    width: 38.29,
    height: 3.17,
    transform: "translate(88.4 226.34) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "57.28 114.76 60.99 114.76 63.34 111.58 59.64 111.58 57.28 114.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "49.21 114.76 52.92 114.76 55.28 111.58 51.57 111.58 49.21 114.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "41.15 114.76 44.85 114.76 47.21 111.58 43.5 111.58 41.15 114.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "33.08 114.76 36.78 114.76 39.14 111.58 35.43 111.58 33.08 114.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "25.01 114.76 28.71 114.76 31.07 111.58 27.36 111.58 25.01 114.76"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: 25.15,
    y: 111.58,
    width: 38.19,
    height: 1.85,
    transform: "translate(88.5 225.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 204.35,
    y: 105.57,
    width: 2.12,
    height: 8.89,
    transform: "translate(410.81 220.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 168.63,
    y: 105.57,
    width: 2.12,
    height: 8.89,
    transform: "translate(339.37 220.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 129.74,
    y: 105.57,
    width: 2.12,
    height: 8.89,
    transform: "translate(261.59 220.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 125.99,
    y: 112.3,
    width: 86.48,
    height: 3.29,
    transform: "translate(338.46 227.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "205.05 115.59 209.59 115.59 212.47 112.3 207.94 112.3 205.05 115.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "195.17 115.59 199.71 115.59 202.59 112.3 198.06 112.3 195.17 115.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "185.29 115.59 189.83 115.59 192.72 112.3 188.18 112.3 185.29 115.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "175.42 115.59 179.95 115.59 182.84 112.3 178.3 112.3 175.42 115.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "165.54 115.59 170.07 115.59 172.96 112.3 168.42 112.3 165.54 115.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "155.66 115.59 160.2 115.59 163.08 112.3 158.54 112.3 155.66 115.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "145.78 115.59 150.32 115.59 153.2 112.3 148.67 112.3 145.78 115.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "135.9 115.59 140.44 115.59 143.33 112.3 138.79 112.3 135.9 115.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "126.03 115.59 130.56 115.59 133.45 112.3 128.91 112.3 126.03 115.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 125.99,
    y: 112.3,
    width: 86.48,
    height: 1.92,
    transform: "translate(338.46 226.53) rotate(180)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 218,
    height: 104,
    transform: "translate(16.24 0.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANoAAABoCAYAAACXH+6lAAAACXBIWXMAAAsSAAALEgHS3X78AAACy0lEQVR4Xu3dwU4TURQG4HOHRheC+AYYfRNJGl7TEOJK40vVICtJyqKROi6aYksHDDrniOH7NgyTmUJCTu5/z70ztLMPZ/3hq8OAMe11e9HvnO0HD8d2788dvmAUwx/bx+W3y5hEi3j7+k1cXHyN79fL6LN+C3hiNitpcnOyjzh+d9wGrgf+wOnp+/7o6CgiIrqIVZEBeboIgxhk61Zf+kibIcKT9WsQ69YH4iOMq22ExS6AdF1r69HMkAZZREdI0trOHE2VQaau/7EuMsUGWW4WrEVHGNdAdAQymaNBgY2uo2KDMYmOUMzufSiwMaKpNhjT4IK1UQ3ymKNBgY05miENxuV5NEg38DyaKoNMuo6QRnSEdK1FnJ+fx4v9fQvWkGWxWNwcewsWpFrFR9EREq06j70Fa0jXW7CGEl1ExPPnz0RHSLDeWCw6QgEL1pCsDyMaJGux1XU0R4PxrTcWG9EgW2+OBsnsDIF0oiMUudV1NKTB+ERHSGdTMRQSHSFV227vi44wPl1HKKLrCOk8JgPpdrqO5miQR3SEVLe6jkAe0RESDbT3VRqMr3mVAVQRHSHRwKZilQZZREdIZVMxpNN1hCK6jpDOqwwgnefRoIz2PiTzPBrU0N6HXNr7UMKmYigjOkIim4qhhK4jlBEdIVFb/Qtr0RFy6TpCGdERElmwhhKrSZroCAVER0ik6wglLFhDia32/mKxuOdS4G8Y0SDRwKZiYHzmaFBGoUGigfY+MD6biqGMQoNE3lQMJWwqhjIKDRKJjlCiae9DBe19KKLQIFFr9jpCEe19KKHQIJHoCEV67X2oodAgkegIZfqYREQcHLyMiIjZbObljpBgcr28jslkEtPpye+uBR5gOj2J5XIZs/MvMZnPr+Lj50/rl/Xca/uSNng45NHcN/Dt3af/8X0Dp4Y/6hHct3H67j/Nw+6bz692Lv2f/QSr6bucdIWQpwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-284",
    x: 26.14,
    y: 103.73,
    width: 207.66,
    height: 6.35,
    transform: "translate(259.94 213.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M16.52,103.73v2.89H215l5,7.22a1.13,1.13,0,0,0,.95.5h11.69a1.15,1.15,0,0,0,1.16-1.15v-9.46Zm202.09,5.53a1.15,1.15,0,0,1,1.15-1.16h4.87a1.16,1.16,0,0,1,1.15,1.16v2.45a1.16,1.16,0,0,1-1.15,1.15h-3.28a1.13,1.13,0,0,1-.95-.5l-1.51-2.17A1.72,1.72,0,0,1,218.61,109.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-286",
    cx: 257.06,
    cy: 118.33,
    r: 20.12,
    transform: "translate(-19.81 59.82) rotate(-12.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M274.83,116.38l2.67-.3-.47-2.64-2.62.63c-.06-.25-.12-.5-.19-.74l2.58-.76-.92-2.52-2.46,1.06-.33-.68,2.41-1.2-1.34-2.32-2.24,1.47c-.14-.21-.3-.41-.45-.61l2.17-1.6-1.72-2.06L270,106l-.54-.54,1.86-2-2.06-1.72-1.61,2.16c-.2-.15-.4-.31-.61-.45l1.48-2.23-2.32-1.34L265,102.3c-.23-.11-.45-.23-.69-.33l1.08-2.46-2.52-.92-.77,2.58-.74-.19.63-2.62-2.64-.47-.31,2.66-.75,0,.16-2.7h-2.68l.17,2.7-.76,0-.31-2.66-2.64.47.63,2.62-.74.19-.77-2.58-2.51.92,1.07,2.46c-.23.1-.46.22-.69.33L248,99.89l-2.32,1.34,1.49,2.23c-.22.14-.41.3-.62.45l-1.61-2.16-2.05,1.72,1.85,2-.53.54-2-1.85-1.72,2.06,2.17,1.6c-.16.2-.31.4-.46.61L240,106.91l-1.34,2.32,2.41,1.2c-.11.23-.23.45-.33.68l-2.47-1.06-.91,2.52,2.57.76c-.07.24-.13.49-.19.74l-2.62-.63-.46,2.64,2.66.3c0,.26,0,.51,0,.76l-2.69-.15v2.68l2.69-.17c0,.25,0,.51,0,.76l-2.66.31.46,2.64,2.62-.63c.06.24.12.49.19.73l-2.57.77.91,2.52,2.46-1.07.33.68-2.4,1.21,1.34,2.32,2.23-1.48c.14.21.3.41.45.62l-2.16,1.61,1.72,2,1.95-1.86c.18.19.35.37.54.54l-1.85,2,2.05,1.72,1.6-2.17c.21.15.41.31.62.45l-1.48,2.24,2.32,1.34,1.21-2.41c.22.11.45.23.68.33l-1.06,2.47,2.51.91.77-2.58c.24.08.49.13.73.19l-.62,2.63,2.64.46.3-2.66.77.05-.17,2.69h2.68l-.16-2.69.76-.05.3,2.66,2.64-.46-.62-2.63c.25-.06.5-.11.74-.19l.76,2.58,2.52-.91-1.07-2.47c.24-.1.46-.22.69-.33l1.2,2.41,2.32-1.34L267,133.18c.21-.14.41-.3.61-.45l1.6,2.17,2.06-1.72-1.85-2c.18-.17.36-.35.53-.54l2,1.86,1.72-2-2.17-1.61.46-.62,2.23,1.48,1.34-2.32-2.41-1.21c.11-.22.23-.45.33-.68l2.46,1.07.92-2.52-2.58-.77c.07-.24.13-.49.19-.73l2.62.63.47-2.64-2.67-.31c0-.25,0-.51.05-.76l2.7.17V117l-2.7.15C274.87,116.89,274.86,116.64,274.83,116.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M257.06,104.07a14.26,14.26,0,1,0,14.26,14.26A14.25,14.25,0,0,0,257.06,104.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-289",
    x: 239.32,
    y: 96.22,
    width: 52.8,
    height: 30.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M305.88,81.94l-17.61-.31-36.3-8a4.19,4.19,0,0,1-3.29-4.19l.62-27.17,34.22,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M279.54,112.42A13.12,13.12,0,0,0,267.29,104H237.68V65l1.54-27.43a1.3,1.3,0,0,1,1.35-1.23c6.92.28,39.81,1.79,46.58,5,5.17,2.49,10.84,11.79,14.84,18,2.87,4.48,9.2,14.45,10.48,19.54,1.09,4.32,1.74,13.27,1.66,17.72-.09,5.89-1.8,23.51-1.8,23.51H282.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M287.05,41.78c-4.67-3.16-41.77-5.25-44.24-4.38s-.88,30.91.5,33.81S285.6,82.7,289.38,83.34s16.69.79,17.92-1.46S300,50.51,287.05,41.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M286.92,41.82c-4.62-3.1-41.44-5.29-43.82-4.32s-.77,30.48.59,33.33,41.78,11.28,45.5,11.9,16.5.78,17.71-1.43S299.68,50.39,286.92,41.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M286.79,41.86c-4.56-3-41.12-5.32-43.4-4.27-2.44,1.13-.66,30.07.68,32.86S285.33,81.51,289,82.12s16.29.77,17.49-1.4S299.39,50.26,286.79,41.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M286.66,41.9c-4.51-3-40.79-5.35-43-4.21-2.42,1.26-.56,29.64.77,32.38s40.75,10.84,44.38,11.45,16.09.74,17.27-1.38S299.1,50.14,286.66,41.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M286.53,41.94C282.08,39,246.06,36.57,244,37.78c-2.4,1.4-.45,29.22.86,31.91s40.23,10.63,43.82,11.22,15.88.73,17.05-1.35S298.81,50,286.53,41.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M286.4,42c-4.4-2.87-40.14-5.39-42.14-4.1-2.38,1.53-.34,28.79,1,31.42s39.72,10.42,43.26,11S304.15,81,305.3,79,298.52,49.89,286.4,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M286.26,42c-4.33-2.81-39.8-5.41-41.71-4.05-2.36,1.68-.24,28.38,1,31s39.2,10.2,42.7,10.77,15.47.7,16.61-1.3S298.23,49.77,286.26,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M286.13,42.06c-4.28-2.75-39.47-5.42-41.29-4C242.51,39.9,244.71,66,246,68.54s38.68,10,42.13,10.54,15.28.69,16.4-1.27S297.94,49.64,286.13,42.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M286,42.1c-4.22-2.69-39.13-5.43-40.87-3.94-2.3,2,0,27.53,1.22,30s38.17,9.77,41.57,10.31,15.07.68,16.18-1.24S297.65,49.52,286,42.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M285.87,42.14c-4.17-2.63-38.8-5.44-40.45-3.88-2.27,2.14.08,27.1,1.31,29.52s37.65,9.55,41,10.09,14.86.65,16-1.22S297.37,49.4,285.87,42.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M285.74,42.18c-4.11-2.57-38.45-5.45-40-3.83-2.23,2.3.19,26.69,1.4,29.05s37.14,9.34,40.45,9.86,14.66.64,15.74-1.19S297.08,49.27,285.74,42.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M285.6,42.22c-4.05-2.52-38.1-5.46-39.6-3.77-2.19,2.46.3,26.26,1.49,28.56s36.62,9.13,39.89,9.64,14.45.63,15.52-1.16S296.79,49.15,285.6,42.22Z"
  })), /*#__PURE__*/React.createElement("image", {
    width: 63,
    height: 76,
    transform: "translate(245.24 38.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAABMCAYAAADa6W+wAAAACXBIWXMAAAsSAAALEgHS3X78AAAEcElEQVR4XuWc3WscVRjGn/fsbD4lTdyIRtfaQBVJqeZS/SOCaMxHbbBUUqK9aKyVbqIOZInrRatps0nbbEygiAipoFYQL7z0zpvQSqIFCeLKypJty0qaguu+XmxmdzKdnckmsx8z5wfLzp592Tnvec4588zh7ICZob0G+45we+Bhbm3dx4P9R/jra9/yxMQE62O89CJmxuXoHKc3UngksA9nx1SMjo5CCAEhyPTdRw+WHwg+iujlBXzz3Q8InRnDU537MfL2CKGGIWbG9IXz/FBzI44Pn9xVZcPhMJuV+/0++BUfFMUHv6Jsvftw67dVLF5dwsWpKAaP9u/qnE5AP36/xH/Ek7tOvFSKNZRGd1cnXuk/hsnJSYTGxspaJ1qIzTCAiiVvhbFhgh0BxBMpPNfVjZd7exyvHy3EZrgWEi9GOBzmYEcA7W0t6OkdcrSewi6g2qiqSvFECut30rj+1eeWQ6ZUBDv6c+VBVVU6PnySllfWcC7yoWM1FoBjv1V2VFWlzYwfTU1NjlTaFcrrUVWVQqEQ3j/7wZ5r7irl9dQ31yES+WhPlXed8kBOfQDIZP6zC7Wk5mf7YmgNYGearBDs0m4PFBqgoaFhV0kIF+eeZ3x83C7EFOH23DX1py98UnIqAm6c8QxoDXD61JmSknG98hp30xtoDbTYhW3DtbO9EU39Uvy/YA90ez3LK2t2IXk8ozxQ+rXflQ7PilIawLXe3gk8YXKMaOq/+MJLltl55lJnxvCbr1t+79lury1/Wd33e27CM1LfXFf0O09d6oxoY//KpSumEnvO5JiRXE+alntaeaCgvhmeH/MaZp7fs7O9kfU76QfKPH2d19Aue8Hgk9vS9aTDK8aJE8PbPrt6AbMUzCY+qZQHgGtfxPIZSzHm9az+/nf+2BMLmDtF6/rR6SgDEioPAIeefgyABA7PjJ9+XgUgibfXo5/1pVQeyK3xSePtjcTmYvJ4eyPPH35W3m7/7qkReW5pjdz4dU3Obq/N+NIqn/5nU94xD0hocjSIJDY5fsUn540NACiKItctrR6plff7ffItY2koiiLPAqaRjXv35VW+ubFe3jGvKD45vT0AJJK35fT2H2/9SUGxC/QiJAiHDx6Q09sLIsx9dlVOby8EYfM+Vyb5xflZ3smOyEohiNDX91ruX9SVwJi81XaRcjP16Tl+5/R7VLEJT78lfHllDYvzsxxPpKrSCIJyp6xIt9fT0ztEqqpSY13u1NUYDkJUKXmNwTfeokPP7LcLKwtULeX1vDpwbMfbw53i0sxUYXOCVWAlKGV/vBMIEmhqrM8d28RWBFVVqburE4vzs2VvABKEX27eAFAjyQPAvc06xBMpu7A9I4jw5dJ1ADXk7QeG+omIONgRKOtjLIQgTJ2/mDu2ia0oTzweLLv6RISBo30E1JDyABD/608qhxXWG6lE8na+vKaSB4D2thYE2lq2HuEEMBhgxt30BpgZ2Swju/V4p2y28P5vJmN4/BPycZHIJGvl2WzhXP8DeXFlLHw5psgAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-292",
    cx: 261.4,
    cy: 128.91,
    r: 18.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M277.37,127.16l2.4-.27-.42-2.37-2.36.56c-.05-.22-.1-.44-.17-.66l2.32-.69-.83-2.26-2.21,1c-.09-.21-.2-.42-.3-.62l2.17-1.08-1.2-2.08-2,1.32c-.12-.19-.27-.37-.4-.55L276.3,118l-1.55-1.85L273,117.79l-.48-.48,1.66-1.75L272.33,114,270.88,116l-.55-.4,1.33-2-2.08-1.2-1.09,2.16-.62-.3,1-2.21-2.27-.82-.69,2.31-.66-.17.57-2.35-2.38-.42-.28,2.39-.67,0,.14-2.42h-2.41l.15,2.42-.68,0-.28-2.39L257,111l.57,2.35-.67.17-.69-2.31L254,112l1,2.21-.61.3-1.09-2.16-2.09,1.2,1.34,2-.56.4L250.47,114l-1.85,1.55,1.67,1.75q-.25.24-.48.48l-1.76-1.66L246.5,118l1.95,1.44c-.14.18-.28.36-.41.55l-2-1.32-1.2,2.08,2.16,1.08c-.1.2-.2.41-.29.62l-2.22-1-.82,2.26,2.31.69c-.06.22-.11.44-.17.66l-2.35-.56-.42,2.37,2.39.27c0,.23,0,.46,0,.69L243,127.7v2.41l2.42-.15c0,.23,0,.46,0,.69l-2.39.28.42,2.37,2.35-.57c.06.22.11.44.17.66l-2.31.69.82,2.27,2.21-1,.3.62-2.16,1.09,1.2,2.08,2-1.33c.12.19.27.37.4.55l-1.94,1.45,1.55,1.85L249.8,140l.48.48-1.66,1.76,1.85,1.55,1.44-1.95c.18.13.36.28.55.4l-1.33,2,2.09,1.2,1.08-2.17c.2.1.41.21.62.3l-1,2.22,2.26.82.69-2.32c.21.07.44.12.66.17l-.56,2.36,2.37.42.27-2.4c.23,0,.46,0,.69.05l-.15,2.42h2.41l-.14-2.42c.23,0,.46,0,.68-.05l.27,2.4,2.38-.42-.56-2.36c.22-.05.44-.1.66-.17l.68,2.32,2.27-.82-1-2.22c.21-.09.41-.2.62-.3l1.08,2.17,2.08-1.2-1.32-2c.19-.12.36-.27.55-.4l1.44,1.95,1.84-1.55-1.66-1.76L273,140l1.75,1.67,1.55-1.85-1.95-1.45c.14-.18.28-.36.41-.55l2,1.33,1.2-2.08L275.81,136c.1-.2.2-.41.29-.62l2.21,1,.83-2.27-2.32-.69c.07-.22.12-.44.17-.66l2.36.57.42-2.37-2.4-.28c0-.23,0-.46.05-.69l2.42.15V127.7l-2.42.15C277.4,127.62,277.4,127.39,277.37,127.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M261.4,117.48a11.43,11.43,0,1,0,11.43,11.43A11.43,11.43,0,0,0,261.4,117.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M261.4,125.46a3.45,3.45,0,1,0,3.45,3.45A3.44,3.44,0,0,0,261.4,125.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M261.4,126.51a2.4,2.4,0,1,0,2.4,2.4A2.39,2.39,0,0,0,261.4,126.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M261.36,127.14a1.77,1.77,0,1,0,1.77,1.77A1.77,1.77,0,0,0,261.36,127.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M261.35,123.29a.81.81,0,1,0,.81.81A.81.81,0,0,0,261.35,123.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M261.35,123.57a.52.52,0,0,0-.53.53.53.53,0,0,0,.53.53.53.53,0,0,0,.53-.53A.53.53,0,0,0,261.35,123.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M261.37,132.91a.81.81,0,1,0,.81.81A.81.81,0,0,0,261.37,132.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M261.37,133.19a.53.53,0,1,0,0,1.06.53.53,0,1,0,0-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M256.49,126.11a.79.79,0,0,0,.29,1.1.8.8,0,0,0,1.11-.29.81.81,0,0,0-.3-1.11A.8.8,0,0,0,256.49,126.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M256.73,126.25a.52.52,0,0,0,.19.72.54.54,0,0,0,.73-.19.53.53,0,0,0-.2-.73A.52.52,0,0,0,256.73,126.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M264.83,130.9a.81.81,0,1,0,1.1-.3A.81.81,0,0,0,264.83,130.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M265.07,131a.53.53,0,1,0,.73-.2A.54.54,0,0,0,265.07,131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M256.79,130.62a.81.81,0,0,0,.81,1.41.81.81,0,1,0-.81-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M256.93,130.86a.54.54,0,0,0-.19.73.52.52,0,0,0,.72.19.52.52,0,0,0,.2-.72A.53.53,0,0,0,256.93,130.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M265.11,125.79a.81.81,0,0,0-.29,1.11.81.81,0,1,0,1.4-.81A.81.81,0,0,0,265.11,125.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M265.25,126a.54.54,0,1,0,.73.2A.54.54,0,0,0,265.25,126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M314.29,115.18c-.13-1.56-12.51-1.63-12.88-1.35a20.94,20.94,0,0,1,3,7.72,66.46,66.46,0,0,1,.84,7.71s6.73,0,8.17-1.77C314.36,126.38,314.39,116.46,314.29,115.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M306,114.35c-.13.63.67,10.31,1.81,12,.87,1.29,4.18.63,4.85.67s2.12-7.92,1.51-11.83C314,114.08,306.17,113.37,306,114.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M306.25,114.41c-.12.6.73,9.53,1.78,11.08.81,1.21,3.91.72,4.53.76s2-7.48,1.44-11.08C313.83,114.15,306.44,113.46,306.25,114.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M306.53,114.46c-.11.58.79,8.75,1.75,10.19.75,1.13,3.63.82,4.21.85s1.94-7,1.38-10.32C313.7,114.22,306.7,113.55,306.53,114.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M306.81,114.51c-.09.55.84,8,1.72,9.3.69,1,3.35.91,3.89.94s1.84-6.61,1.31-9.56C313.57,114.29,307,113.63,306.81,114.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M307.1,114.57c-.09.52.9,7.2,1.68,8.4.63,1,3.08,1,3.57,1s1.75-6.18,1.25-8.81C313.44,114.36,307.23,113.72,307.1,114.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M307.38,114.62c-.07.49,1,6.42,1.65,7.51.57.88,2.8,1.1,3.25,1.12s1.65-5.75,1.18-8C313.3,114.43,307.5,113.81,307.38,114.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M307.66,114.68a29.19,29.19,0,0,0,1.63,6.61c.5.8,2.51,1.19,2.92,1.21s1.55-5.31,1.12-7.29C313.17,114.5,307.76,113.9,307.66,114.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M307.94,114.73a26.35,26.35,0,0,0,1.6,5.72,4.83,4.83,0,0,0,2.6,1.31c.36,0,1.45-4.89,1.05-6.55C313,114.56,308,114,307.94,114.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M308.22,114.78a24.21,24.21,0,0,0,1.57,4.83,4.8,4.8,0,0,0,2.28,1.4c.32,0,1.34-4.45,1-5.79C312.9,114.63,308.29,114.07,308.22,114.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M308.5,114.84a23.07,23.07,0,0,0,1.54,3.93,4.93,4.93,0,0,0,2,1.49c.27,0,1.23-4,.92-5C312.77,114.7,308.55,114.16,308.5,114.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M308.79,114.89a21.21,21.21,0,0,0,1.5,3,5.44,5.44,0,0,0,1.64,1.58,10.54,10.54,0,0,0,.86-4.28C312.63,114.77,308.82,114.25,308.79,114.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M309.07,115c0,.32,1.3,1.75,1.48,2.14a6.17,6.17,0,0,0,1.3,1.67,9.71,9.71,0,0,0,.8-3.52C312.47,114.85,309.08,114.34,309.07,115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M312,124.36a37.5,37.5,0,0,1-6.72-.12c.06,2.81-.05,5-.05,5s6.73,0,8.17-1.77c.34-.41.56-2,.69-4A8.79,8.79,0,0,1,312,124.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M314.29,115.18c-.13-1.56-12.51-1.63-12.88-1.35l.26,1.49a48,48,0,0,1,10.4-.22C313,115.26,314.32,115.56,314.29,115.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-313",
    x: 305.89,
    y: 113.73,
    width: 0.88,
    height: 15.51,
    transform: "translate(612.66 242.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-314",
    points: "282.81 129.24 305.89 129.24 305.89 112.38 279.44 112.38 282.81 124.1 282.81 129.24"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-315",
    x: 301.86,
    y: 112.38,
    width: 4.02,
    height: 16.86,
    transform: "translate(607.74 241.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-316",
    points: "288.31 129.24 282.93 129.24 283.24 121.95 279.54 112.38 288.31 112.38 288.31 129.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M305.88,125.46H284.16V124.1h18.62a4,4,0,0,1,2.44.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M281.59,112.38l2.56,9.14a21.5,21.5,0,0,1,.79,5.75v2h-2.13v-2.13a21.39,21.39,0,0,0-.83-5.9l-2.54-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M308.92,77.14c-.65-1.31-1.16-5.85-11.52-22.72-4.13-6.71-8.28-10.16-7.19-10.9h0c4.26,3.84,8.56,10.85,11.78,15.89,2.66,4.15,8.28,13,10.12,18.33l.09.29s.29.12.29.12,0,.45,0,.8C312.47,79,309.58,78.44,308.92,77.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M290.68,44c4.1,3.92,8.21,10.59,11.31,15.45,2.66,4.15,8.28,13,10.12,18.33l.09.29c-.91-.25-2.3-.76-2.73-1.62-.66-1.31-1.5-5.77-11.86-22.64C294.46,48.63,291.39,45.62,290.68,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M254.07,79.7a3,3,0,1,0,3-3A3,3,0,0,0,254.07,79.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M250.93,80.75H262.4a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H250.93a1,1,0,0,0-1,1h0A1,1,0,0,0,250.93,80.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 296.54,
    y: 105.07,
    width: 6.26,
    height: 3.28,
    rx: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 296.64,
    y: 105.1,
    width: 6.09,
    height: 3.17,
    rx: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 296.73,
    y: 105.14,
    width: 5.93,
    height: 3.06,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 296.82,
    y: 105.17,
    width: 5.76,
    height: 2.95,
    rx: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 296.92,
    y: 105.21,
    width: 5.59,
    height: 2.84,
    rx: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 297.01,
    y: 105.24,
    width: 5.42,
    height: 2.73,
    rx: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 297.1,
    y: 105.28,
    width: 5.26,
    height: 2.62,
    rx: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 297.19,
    y: 105.32,
    width: 5.09,
    height: 2.5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 297.29,
    y: 105.35,
    width: 4.92,
    height: 2.39,
    rx: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 297.38,
    y: 105.39,
    width: 4.76,
    height: 2.28,
    rx: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 297.47,
    y: 105.42,
    width: 4.59,
    height: 2.17,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 297.57,
    y: 105.46,
    width: 4.42,
    height: 2.06,
    rx: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 296.75,
    y: 105.16,
    width: 5.72,
    height: 2.75,
    rx: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 296.76,
    y: 105.17,
    width: 5.68,
    height: 2.66,
    rx: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 296.78,
    y: 105.17,
    width: 5.65,
    height: 2.58,
    rx: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 296.8,
    y: 105.18,
    width: 5.61,
    height: 2.5,
    rx: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 296.82,
    y: 105.19,
    width: 5.58,
    height: 2.41,
    rx: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 296.83,
    y: 105.19,
    width: 5.54,
    height: 2.33,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 296.85,
    y: 105.2,
    width: 5.51,
    height: 2.25,
    rx: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 296.87,
    y: 105.21,
    width: 5.47,
    height: 2.17,
    rx: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 296.89,
    y: 105.21,
    width: 5.44,
    height: 2.08,
    rx: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 296.9,
    y: 105.22,
    width: 5.4,
    height: 2,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 296.92,
    y: 105.23,
    width: 5.37,
    height: 1.92,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 296.94,
    y: 105.23,
    width: 5.33,
    height: 1.83,
    rx: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 296.96,
    y: 105.24,
    width: 5.3,
    height: 1.75,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 296.97,
    y: 105.25,
    width: 5.26,
    height: 1.67,
    rx: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 296.99,
    y: 105.26,
    width: 5.23,
    height: 1.58,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 297.01,
    y: 105.26,
    width: 5.19,
    height: 1.5,
    rx: 0.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 297.03,
    y: 105.27,
    width: 5.16,
    height: 1.42,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 297.04,
    y: 105.28,
    width: 5.12,
    height: 1.33,
    rx: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 297.06,
    y: 105.28,
    width: 5.09,
    height: 1.25,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 297.08,
    y: 105.29,
    width: 5.06,
    height: 1.17,
    rx: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 297.1,
    y: 105.3,
    width: 5.02,
    height: 1.09,
    rx: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 297.11,
    y: 105.3,
    width: 4.99,
    height: 1,
    rx: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M297.2,105.63a21.19,21.19,0,0,0,4.82.18c.19-.23.14-.47-.45-.51S297.17,105.3,297.2,105.63Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-173",
    width: 7,
    height: 8,
    transform: "translate(308.24 97.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAAAsSAAALEgHS3X78AAAAWklEQVQIW3WOwQnAIBRD81v3qEN4tKsFdB2X+i5Rj7+HogjVnJI8ApGUkmEh7y8cPZAUktKzav3gXM5+LFfaQufOPQwhwAFAzvn3OMYbYmZo7bFSClTrgCTlBTWLHF2gWwzaAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M314.72,99c0-.43-.12-.78-.33-.8l-4.77-.44c-.4,0-.75.7-.8,1.59l-.21,3.65c0,.59.14,1.08.4,1.13l4.86.84c.21,0,.42-.29.46-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M312.43,101.49c-.09,1.26,0,2.29.19,2.31s.43-1,.51-2.3,0-2.32-.2-2.32S312.51,100.23,312.43,101.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M312.93,99.18c-.19,0-.42,1-.5,2.31s0,2.29.19,2.31l-2.47-1.38.16-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M313.38,101.76c-.09,1.29,0,2.35.2,2.37s.45-1,.54-2.35,0-2.39-.21-2.38S313.47,100.47,313.38,101.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M308.61,102.94l.21-3.68c.05-.86.43-1.58.82-1.55l.76.06c.18,0,.31.32.29.72l-.28,5.34c0,.24-.12.43-.23.41l-1.16-.17C308.75,104,308.57,103.53,308.61,102.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M309.49,98.08c-.2.93,4,.36,4.49,1.06s.08,5.28.17,5.21.7-5.36.29-5.75C314.24,98.41,309.55,97.84,309.49,98.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M310.08,99.45c0,.76.06,1.37.21,1.36s.3-.65.34-1.43-.06-1.38-.21-1.36S310.12,98.69,310.08,99.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M309.92,102.44c-.05.77,0,1.39.18,1.41s.31-.61.36-1.39,0-1.4-.18-1.4S310,101.68,309.92,102.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M309.82,100.29c.77.08,3.29-.18,3.58.1s.13,4,.42,4.19a1.43,1.43,0,0,0,.36.12,1.18,1.18,0,0,0,.15-.5l.39-5.25v-.09c-.09-.42-.28-.7-.54-.72l-4.56-.43a.46.46,0,0,0-.22.06,1.37,1.37,0,0,0-.45.76,2.46,2.46,0,0,0-.07.29,3.5,3.5,0,0,0-.06.48l0,.39A1.15,1.15,0,0,0,309.82,100.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M314.29,104.41l-4.9-1.73c-.28-.1-.46-.64-.43-1.28l.06-1c.06-.93.06-1.77.46-2.11a4.11,4.11,0,0,1,1.71-.42l-.89-.08-.68-.07a.46.46,0,0,0-.22.06,1.37,1.37,0,0,0-.45.76,2.46,2.46,0,0,0-.07.29,3.5,3.5,0,0,0-.06.48l-.21,3.65c0,.59.14,1.08.4,1.13l4.86.84C314.05,105,314.22,104.73,314.29,104.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M252.26,104a41.09,41.09,0,0,0-8.52,8.64,16.64,16.64,0,0,0-2.15,5.85c-.82,5.61-.83,14.19-1.26,16.3a17.5,17.5,0,0,1-1.74,5.59,4.83,4.83,0,0,1-2.13,1.82s.7-6.54.77-10.9c.09-5.92.45-27.3.45-27.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-330",
    points: "252.26 104 237.68 104 237.65 105.61 250.23 105.61 252.26 104"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M287.15,41.36a14.33,14.33,0,0,1,3.54,2.6H238.86l.36-6.41a1.3,1.3,0,0,1,1.35-1.23C247.49,36.6,280.38,38.11,287.15,41.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M300,68s0,0,0-.06c-.37-.8-9.18-20-16.06-22.31-5.27-1.81-21.8-2.92-29.42-3.36a3.71,3.71,0,0,0-3.92,3.71V63.74a4.1,4.1,0,0,0,2.66,3.83l35.36,13.17a4.22,4.22,0,0,0,1.49.27h13.45a.59.59,0,0,0,.55-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M302.61,79.7s-4-12.33-6-15.81C294.36,60,287.51,48,283.52,46.82c-3.67-1.1-14.22-2.45-29.07-3.3h-.14a2.4,2.4,0,0,0-2.4,2.41V64.14a2.21,2.21,0,0,0,1.43,2.06l26.12,3.23a7.27,7.27,0,0,1,5.19,3.22l4.53,6.9a2.31,2.31,0,0,0,.83.15Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-83",
    width: 59,
    height: 43,
    transform: "translate(248.24 40.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAArCAYAAADG8/AoAAAACXBIWXMAAAsSAAALEgHS3X78AAADrElEQVRoQ91az2saWRz/vGkzQlq2hyhsL1UTctxCCISAudQGKuQP6J6kP445mC50ySkwxsOWBlq2h5Vtuw255/4sCeSQYL2kKeS4ZTQrQQjxmjGonz2EUZOoT/NDZ/qBz0Hn8x3f532+vnGeI0jCxpcvab548RvS6bQQQnBoaAherxderxeJRAKTk5MoFAooFouoVis4PCzi+/d/US6XUS5XUKmU8fLl7wIOhbDNzs3NMZlMYmxsDOl0+tSAhRD1GekQoVAIa2trKBQKyOVysCwL377twLJKWFhY6MuECJLIZrOcnp5GPp+HZVlXMhBd16nrOmwODAzg7OvNzU3k8/8hlUrh8LB4/ZNgGAY9Hg9HRkZIEr3i+Pg4Q6EQAZyiaZp89eqPaxkLpJT0+XzXcvJuCYCxWIwAuLu7S5W+W0JKyVAodOUnvgztlEulEhOJRar0nVITQqBarbbq8r6ApACAcDiMx49/Vck7xs0bNzRUKhWVrucgKYQQHB0dhWmaDAQCl168NE1zplmgnnAwGEQqler68ncWjjYL1A1HIhF8+vTPpQxrllVCuVxW6foK2/CzZ88Rj8cvbFgD4OhkbdiG5+fnVdKWcI1Z4MSwx+NBNpu9ULoaAMe38VkEg0F8/tz9guWqZIF6Oz96FFFJz8F1ZoG64W4vR640ayMSiXS1OrvyOwvU041GoyppDa5OFjhZrDpN19Vm7XRnZ2dVUgAubmMbJIXX68X7938r03V1so148uSpSvJjmCUpdF3Hu3d/tk1XA4CJiYl2GtegWm3fyTczmUxbgVtg3+zfv/8LHzwIN73R127fvoWtra0L7Q07EeHww9YHScI0zdq2pmrTyukEQCklmx3TACAQCIjl5WUAwNTU1A+RcFM0OpdSntu0Vs2k02iP2zAMnjvWrGBxcZG5XM61xtGilZWF6+vrPDg4cJVpAE03/pWFNpeWXnNjY8MVabdqZWVhM759+4b7+/uONg6A29vbPPWeqkhFKSWPj48JgMPDw/T7/Y4w3iwAZVGnNAyDmUyGfr+fPp+Pg4ODfTcNgMnkX7UxKAsuwo8fP9A0zb63OXDyf2/ttargspRS8ujoqC/Gz36WsuCqaBgGpZScmZnpqWkAXFp6TbKHZhtpGEbP2hwA9/b2SPbJbCNXV1evtc0bz6cU94p2m9vPVFylaeDkB0btOSgnIR6PMxqNYmVlBXfv/ox79/yqkrbQdR07O1/hSLON6HRPuB3u3PkJsdic+B/FVyTqxh8OuwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-83",
    width: 56,
    height: 41,
    transform: "translate(249.24 41.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAApCAYAAABgDOogAAAACXBIWXMAAAsSAAALEgHS3X78AAAEeElEQVRoQ9WYX0hbZxjGny/GK9cekjovqlnmIFNYNHjuXLCDOqG70IHaDu3AC8mFQ8h9J4FzkiaZXXGu1a5IVtaVDqReCN57oxfeBJxFVvDPigsI6/REyZaZnLy7qCdLmj/HNCY5+cELge89Od/zPc85H+djRAQAEEWRmpvfB8dxMJneQyKRwKtXfyISiUCSwohG/wERIR6PIxqNgoiSFY/LcLlcDBqEERH8fh+NjX0Fs9kMq9WKubk5tLe3Q6/X562xsTH09fWhoaEBL1/+DllOYGdnGwCwv7+PWCyGk5MTEBGi0X8rsgiMiLC6ukI3bnxx6pZ0pklYLBaqqanJEL22tpbR63Q6MTU1hRcvfsP29jbicRmh0B+IxWIIh49KKpwJgkAHBwdYXFzE7u5uSW7EGKNcY/Pz87DZbHj+fAN7e3vnL1gQBLLb7QSAUp+rchQAUkqZw8LCMxIE4dzmomMMSCQS+dagZBARU2plZYUBwMDAIIaHh+F2izldLwQdYwyyLKv1lQUiYgBgsVgwNDQMUSxepKYEAukie3t7ixapA6ApgcD/Inmeh9X6kVp7XnSMMcTjcbW+sqOIHBgYxOzszFu7qLmIpqKIPDo6xvT0d28lUq9lgcBrkYwxOjw8hNd7m27d+rqgPVKzEX0Tg8GAtrY2eDzugpzUdEQVlKj29X2OxsZGtfY0NPkWzYYiUpYTBW0dVeFgKg6Ho6Cto2qeQSB96zjrW7XqHFREXrnyyZmiqotE/oYsy6irq1Pr1RQ8z8NoNKi1vX7JWK3WqnTx2rXP4PN587qoU35Uk0AFi8UCjuPy9lStQMXF7u5P8347JgVW6qO3WEZHR9HU1JRzXAcAExMTORu0DBGx1dVVXLhwEXfvfpvdRSJCIBCo2LlMsYXTM52FhWeUbVwHAMfHR1haWoLdbgdjjPKdgmkNOn0WjcZL8Pt9mfNWlAqCQI8f/0SSJCVPupRSW8VKlzLPmZn79OYYO21I4naLxHEczGYz6ureQU9PD3iehyzLWF9fB52umNZgjFEwGERHR0fa/DIEpuLxuKm+vh5dXV24efNLSJIESZIQDoc1J5QxRk6nE0ajMf3gWM1+pTweNz158jNtbm5qMsLIEdO8DmZDFEXiuItoaWnB5cuNsNlsaeNUQWezxlRtZfKVz+elmZn7FAwGaWhoqOKuAqD+/n6anPwmeX/Vi85afr+PHj36kXZ2dioWYeV+Dx/+kLxnwRFVQ4mwyWTC1avdMBjSP2moxBHOiKnaqhRTgiDQvXvfUzAYJKfTWRZXAdDIyAh5vbeJ6BwjqlZ37kxSIBCgUChU0ggr//ngwSwRlSCiaoiiSHp9DVpbW9HfPwDG0hNL5xBhxhhtbPwKq7WNlV1gKsrz2tnZiadPf8H09HRyrBihjDEaHx9HQ8O75XcwF6IoUn39JXR2fgye5wEAy8vL2NraUrkyE4fDAbvdjuvXB7UjUEEURaqtrUVLy4dobv4A4XBY7ZKsHBz8hVAopD2BqZzlWDAfLpeL/QedX7EVCP4mJAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M286.83,59.08a17.25,17.25,0,0,0-14-9.58l-20.89-1.79h0V45.93a2.4,2.4,0,0,1,2.4-2.41h.14c14.85.85,25.4,2.2,29.07,3.3,4,1.19,10.84,13.22,13.06,17.07,2,3.48,6,15.81,6,15.81H290a2.31,2.31,0,0,1-.83-.15L287.49,77l5.64,0a1.55,1.55,0,0,0,1.39-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M280.36,69.6l8.82,10-4.67-32.87-1.22-.44,2.23,24.35a.71.71,0,0,1-1,.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M302.92,90.14c2.05,0,2.72-.92,2.72-1.44V84.43a.65.65,0,0,0-.72-.65H301a.73.73,0,0,0-.78.8c0,.58,0,3.28,0,4C300.23,89.14,301.06,90.14,302.92,90.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M301,83.82a.74.74,0,0,0-.73.81c0,.63,0,3.26,0,4a1.27,1.27,0,0,0,.56.87,3.48,3.48,0,0,0,2.08.6c2,0,2.65-.89,2.65-1.4v-4.2c0-.35-.25-.57-.71-.64H301Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M301,83.87a.74.74,0,0,0-.7.82c0,.66,0,3.23,0,3.9a1.27,1.27,0,0,0,.57.82,3.56,3.56,0,0,0,2,.56c1.9,0,2.58-.84,2.58-1.34V84.49c0-.34-.25-.55-.7-.63l-1.34,0h-1.61S301,83.85,301,83.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M301,83.91c-.29,0-.64.25-.65.84s0,3.2,0,3.83a1.23,1.23,0,0,0,.58.79,3.72,3.72,0,0,0,2,.51c1.84,0,2.52-.8,2.52-1.29V84.52c0-.33-.25-.54-.69-.62l-1.32,0h-1.59C301.8,83.88,301,83.89,301,83.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M301,84c-.28,0-.6.27-.61.84,0,.73,0,3.18.05,3.78,0,.23.23.49.57.74a3.86,3.86,0,0,0,1.93.48c1.76,0,2.45-.76,2.45-1.24v-4c0-.31-.25-.52-.69-.61l-1.29,0h-1.57A7,7,0,0,0,301,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M301,84c-.26,0-.56.29-.57.86,0,.76,0,3.15.05,3.72,0,.22.24.46.58.7a4.31,4.31,0,0,0,1.88.43c1.69,0,2.38-.72,2.38-1.19V84.59c0-.31-.25-.52-.68-.6-.09,0-1.15,0-1.28,0h-1.54A6.28,6.28,0,0,0,301,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M301,84.05c-.24,0-.52.3-.53.86,0,.8,0,3.13.06,3.67,0,.21.25.43.59.65a4.51,4.51,0,0,0,1.82.4c1.62,0,2.32-.68,2.32-1.14V84.62c0-.3-.25-.5-.67-.59-.11,0-1.11-.06-1.26-.06h-1.52A3.76,3.76,0,0,0,301,84.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M301,84.09c-.22,0-.48.32-.49.88,0,.83,0,3.1.07,3.61,0,.2.26.4.58.6a4.9,4.9,0,0,0,1.78.36c1.55,0,2.25-.64,2.25-1.08V84.65c0-.29-.25-.49-.66-.58-.13,0-1.06-.06-1.24-.06h-1.51A3.4,3.4,0,0,0,301,84.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M301,84.13c-.21.06-.44.35-.45.9,0,.86,0,3.07.07,3.55,0,.19.27.36.59.56a5.56,5.56,0,0,0,1.73.32c1.47,0,2.18-.6,2.18-1V84.68c0-.28-.25-.47-.65-.57-.15,0-1-.07-1.22-.07H301.8A3,3,0,0,0,301,84.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M301,84.18c-.18.06-.39.36-.4.9,0,.9,0,3,.07,3.5,0,.18.29.33.6.51a5.79,5.79,0,0,0,1.67.28c1.41,0,2.12-.56,2.12-1V84.71c0-.27-.25-.46-.65-.56-.16,0-1-.08-1.2-.08h-1.46A2.43,2.43,0,0,0,301,84.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M301.05,84.22c-.17.07-.35.38-.37.92a31.65,31.65,0,0,0,.09,3.44c0,.17.29.3.6.47a7,7,0,0,0,1.62.24c1.34,0,2.05-.53,2.05-.94V84.74c0-.26-.24-.45-.64-.54a8.46,8.46,0,0,0-1.18-.09h-1.44A2,2,0,0,0,301.05,84.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M301.05,84.27c-.14.07-.3.4-.32.92a27.89,27.89,0,0,0,.09,3.39c0,.16.28.32.6.42a6.4,6.4,0,0,0,1.58.2c1.26,0,2-.48,2-.88V84.77c0-.24-.24-.43-.63-.53a8,8,0,0,0-1.16-.1h-1.42A1.65,1.65,0,0,0,301.05,84.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M301.06,84.31c-.13.08-.26.42-.28.94a23.07,23.07,0,0,0,.09,3.33.82.82,0,0,0,.61.37,7.46,7.46,0,0,0,1.52.16c1.2,0,1.91-.44,1.91-.83V84.8c0-.23-.23-.42-.61-.52a6.48,6.48,0,0,0-1.14-.11h-1.41A1.46,1.46,0,0,0,301.06,84.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M301.07,84.36a1.53,1.53,0,0,0-.24,1,20.33,20.33,0,0,0,.1,3.27c0,.14.29.27.61.33A10.53,10.53,0,0,0,303,89c1.12,0,1.84-.4,1.84-.78V84.83c0-.22-.23-.4-.61-.51a6,6,0,0,0-1.12-.12h-1.38C301.5,84.2,301.12,84.27,301.07,84.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M301.07,84.4a2.28,2.28,0,0,0-.2,1,18,18,0,0,0,.11,3.22c0,.13.3.24.61.28a12.65,12.65,0,0,0,1.42.08c1.06,0,1.78-.36,1.78-.72V84.86c0-.21-.23-.39-.6-.49a4.43,4.43,0,0,0-1.1-.13h-1.36A1.24,1.24,0,0,0,301.07,84.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M301.08,84.45a2.6,2.6,0,0,0-.16,1,16.17,16.17,0,0,0,.11,3.16.8.8,0,0,0,.62.24s1.31,0,1.37,0c1,0,1.71-.32,1.71-.68V84.89c0-.2-.23-.37-.59-.48a3.83,3.83,0,0,0-1.08-.14h-1.34A.94.94,0,0,0,301.08,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M301.71,88.77H303c.91,0,1.64-.28,1.64-.62V84.93c0-.35-.73-.63-1.64-.63h-1.32c-.3,0-.56.08-.62.19a14.74,14.74,0,0,0,0,4.09C301.15,88.69,301.41,88.77,301.71,88.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M302.49,86.12c-.11-.21,1.32,3,2.64,2.86.72-.06.15-4.81,0-4.94-.41-.43-3.24-.3-3.71-.08S302.63,86.4,302.49,86.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M302.56,86c-.1-.2,1.26,2.8,2.51,2.69.7-.06.18-4.52.05-4.65-.39-.41-3.05-.29-3.51-.08S302.7,86.28,302.56,86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M302.64,85.93c-.09-.17,1.19,2.63,2.37,2.52.67-.06.2-4.22.08-4.35-.36-.39-2.86-.28-3.31-.09S302.77,86.16,302.64,85.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M302.72,85.83c-.08-.15,1.12,2.46,2.24,2.36.63-.06.21-3.93.1-4-.33-.38-2.67-.28-3.1-.1S302.84,86,302.72,85.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M302.8,85.74c-.08-.14,1.05,2.28,2.1,2.19.61-.06.23-3.64.13-3.76-.3-.35-2.48-.27-2.9-.1S302.91,85.92,302.8,85.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M302.88,85.64c-.07-.12,1,2.1,2,2,.58,0,.26-3.34.16-3.46-.27-.33-2.29-.26-2.7-.1S303,85.8,302.88,85.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M303,85.54c-.07-.09.9,1.93,1.82,1.86.55-.05.28-3.05.19-3.16-.24-.32-2.1-.25-2.49-.12S303.05,85.68,303,85.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M303,85.45c-.06-.08.83,1.75,1.69,1.68.52,0,.29-2.75.21-2.86-.21-.3-1.91-.24-2.29-.12S303.13,85.56,303,85.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M303.12,85.35c-.05-.06.76,1.58,1.55,1.52.49,0,.32-2.45.24-2.56-.18-.28-1.72-.24-2.08-.13S303.2,85.44,303.12,85.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M303.2,85.25c-.05,0,.69,1.4,1.41,1.35.46,0,.34-2.15.27-2.26-.16-.26-1.53-.23-1.88-.13S303.27,85.31,303.2,85.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M303.28,85.16s.62,1.22,1.28,1.18c.43,0,.35-1.86.29-2s-1.34-.22-1.68-.14S303.34,85.19,303.28,85.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M303.36,85.06s.55,1,1.14,1c.4,0,.38-1.57.32-1.67s-1.15-.22-1.47-.15S303.4,85.08,303.36,85.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M303.44,85s.48.88,1,.85.4-1.27.35-1.37-1-.21-1.27-.15S303.47,85,303.44,85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M303.52,84.87s.41.7.87.68.41-1,.37-1.08-.77-.2-1.07-.15S303.54,84.83,303.52,84.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M303.6,84.77a.89.89,0,0,0,.73.51c.31,0,.43-.67.4-.77s-.58-.19-.86-.17S303.61,84.72,303.6,84.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M303.68,84.67c0,.08.27.35.59.35s.45-.38.43-.48-.39-.18-.66-.17A.36.36,0,0,0,303.68,84.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M303.76,84.58c0,.09.2.17.45.17s.46-.08.46-.17-.2-.18-.46-.18S303.76,84.48,303.76,84.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-333"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(303.24 67.5)",
    xlinkHref: "#image-2"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "translate(302.24 67.5)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-334"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(301.24 67.5)",
    xlinkHref: "#image-2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-335"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 4,
    transform: "translate(303.24 83.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAYAAACk7+45AAAACXBIWXMAAAsSAAALEgHS3X78AAAAIUlEQVQIWwXBsQ0AIAwDMJOVjqj/fxrsg0LuDJCkaN4u+D3gA2z/jnOcAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 24,
    transform: "translate(298.24 61.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAYCAYAAAA20uedAAAACXBIWXMAAAsSAAALEgHS3X78AAAAb0lEQVQoU7WPMQrDMBAE5wTqbCK5MnpC8P8fZtJPiuBgcOJCoINtbncWlpyza2s+ahWw1KKKCoDTPLu2JvCVShyJ80WEz22Do+KssiwC/iUB0sUBUvq8f5oRcWN2k2lQbTfZv3PUlDG1t+Rr3wF4A23FMgrqovD4AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-336"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 2,
    transform: "translate(297.24 61.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAACCAYAAAB/qH1jAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQIWwXBsREAAAgCsaeX3nP/HSkxEdC9AyAJaoukjs3YPJfOCH48m4vsAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-337"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 4,
    transform: "translate(300.24 83.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAYAAACk7+45AAAACXBIWXMAAAsSAAALEgHS3X78AAAALElEQVQIW2Pk5uX9r6GpwcDEy8vLICQkxMD0//9/Bhk5OQYGCSmp/8zMzP8Bd+oHqJbkHooAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 3,
    height: 22,
    transform: "translate(300.24 63.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAWCAYAAAAFMyaXAAAACXBIWXMAAAsSAAALEgHS3X78AAAAjElEQVQYV22PMQ6CUBAFZ3/YThL9GEJiQaNewOhVLLg28RhILKB8FgtUbDd5mUkWQO+ukyQMEMDj9SRJMoBh+JIAjjkzT1PAbxw5VRUmicJd7g6ScHcBSgCWEkA4ySzS63K93Rcw49P3ETiUpSSxH9hgfznXtViuMDMubRtUN42ASK9yuMTLWy3nDMAfes8vWXhqrUoAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-338"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 2,
    transform: "translate(297.24 63.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAACCAYAAAB/qH1jAAAACXBIWXMAAAsSAAALEgHS3X78AAAAIklEQVQIWwXBwQ0AIAwAIXQTk+4/nj5PUEHozLShWvDu9QHTZQxHZG9LmAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M295.19,74.68h4a2.1,2.1,0,0,0,2.11-2.11V57.63A2.28,2.28,0,0,0,299,55.34h-3.89a1.08,1.08,0,0,0-1,.73,27.5,27.5,0,0,0-1.22,8.49,36.93,36.93,0,0,0,1.26,9.32A1.09,1.09,0,0,0,295.19,74.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M295.21,74.57h3.87a2.11,2.11,0,0,0,2.11-2.12V57.73a2.28,2.28,0,0,0-2.28-2.28h-3.76a1.06,1.06,0,0,0-1,.74,27.6,27.6,0,0,0-1.19,8.4,36.73,36.73,0,0,0,1.22,9.18A1.08,1.08,0,0,0,295.21,74.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M295.23,74.45H299a2.12,2.12,0,0,0,2.12-2.12V57.84a2.27,2.27,0,0,0-2.28-2.27h-3.62a1.05,1.05,0,0,0-1,.73A27.83,27.83,0,0,0,293,64.61a37,37,0,0,0,1.19,9A1.07,1.07,0,0,0,295.23,74.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M295.25,74.34h3.59A2.12,2.12,0,0,0,301,72.21V58a2.27,2.27,0,0,0-2.27-2.27H295.2a1,1,0,0,0-1,.73,28.08,28.08,0,0,0-1.13,8.22,36.41,36.41,0,0,0,1.16,8.93A1.05,1.05,0,0,0,295.25,74.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M295.26,74.22h3.45a2.13,2.13,0,0,0,2.13-2.13v-14a2.26,2.26,0,0,0-2.26-2.26h-3.36a1,1,0,0,0-1,.72,28.86,28.86,0,0,0-1.09,8.14,36.39,36.39,0,0,0,1.12,8.79A1,1,0,0,0,295.26,74.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M295.28,74.11h3.31A2.13,2.13,0,0,0,300.72,72V58.17a2.26,2.26,0,0,0-2.25-2.26h-3.23a1,1,0,0,0-1,.72,28.77,28.77,0,0,0-1.06,8.05,36.88,36.88,0,0,0,1.08,8.66A1,1,0,0,0,295.28,74.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M295.3,74h3.17a2.14,2.14,0,0,0,2.14-2.14V58.28A2.25,2.25,0,0,0,298.36,56h-3.09a1,1,0,0,0-1,.71,29.56,29.56,0,0,0-1,8,36.13,36.13,0,0,0,1.06,8.54A1,1,0,0,0,295.3,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M295.32,73.87h3a2.14,2.14,0,0,0,2.14-2.14V58.38a2.25,2.25,0,0,0-2.25-2.24h-2.95a1,1,0,0,0-.94.71,29.85,29.85,0,0,0-1,7.87,36.67,36.67,0,0,0,1,8.41A1,1,0,0,0,295.32,73.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M295.34,73.76h2.88a2.15,2.15,0,0,0,2.15-2.15V58.49a2.23,2.23,0,0,0-2.24-2.23h-2.82a1,1,0,0,0-.93.7,30.94,30.94,0,0,0-1,7.79,36.58,36.58,0,0,0,1,8.27A1,1,0,0,0,295.34,73.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M295.36,73.64h2.74a2.15,2.15,0,0,0,2.15-2.15V58.6A2.23,2.23,0,0,0,298,56.37h-2.69a1,1,0,0,0-.91.7,30.89,30.89,0,0,0-.93,7.7,36.54,36.54,0,0,0,.95,8.14A.94.94,0,0,0,295.36,73.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M295.38,73.53H298a2.16,2.16,0,0,0,2.15-2.16V58.71a2.21,2.21,0,0,0-2.22-2.22h-2.55a.91.91,0,0,0-.9.69,31.27,31.27,0,0,0-.9,7.61,36.81,36.81,0,0,0,.91,8A.93.93,0,0,0,295.38,73.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M295.4,73.41h2.46A2.16,2.16,0,0,0,300,71.25V58.82a2.22,2.22,0,0,0-2.22-2.22h-2.42a.91.91,0,0,0-.89.69,32.43,32.43,0,0,0-.87,7.53,36.61,36.61,0,0,0,.88,7.88A.92.92,0,0,0,295.4,73.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M295.42,73.3h2.32a2.17,2.17,0,0,0,2.16-2.17V58.93a2.21,2.21,0,0,0-2.21-2.21H295.4a.89.89,0,0,0-.87.68,32.4,32.4,0,0,0-.84,7.44,36.55,36.55,0,0,0,.85,7.75A.89.89,0,0,0,295.42,73.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M295.44,73.18h2.17A2.17,2.17,0,0,0,299.78,71V59a2.2,2.2,0,0,0-2.2-2.2h-2.16a.89.89,0,0,0-.86.68,33.87,33.87,0,0,0-.8,7.35,36.91,36.91,0,0,0,.81,7.63A.88.88,0,0,0,295.44,73.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M295.46,73.07h2a2.17,2.17,0,0,0,2.17-2.18V59.14A2.19,2.19,0,0,0,297.47,57h-2a.87.87,0,0,0-.85.67,34.5,34.5,0,0,0-.77,7.27,37.84,37.84,0,0,0,.77,7.49A.88.88,0,0,0,295.46,73.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M295.47,73h1.9a2.18,2.18,0,0,0,2.18-2.18V59.25a2.19,2.19,0,0,0-2.19-2.19h-1.89a.87.87,0,0,0-.84.67,36.09,36.09,0,0,0-.74,7.18,36.9,36.9,0,0,0,.75,7.36A.85.85,0,0,0,295.47,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M295.49,72.84h1.76a2.19,2.19,0,0,0,2.18-2.19V59.36a2.18,2.18,0,0,0-2.18-2.18h-1.76a.83.83,0,0,0-.82.67,35.93,35.93,0,0,0-.71,7.08,38.14,38.14,0,0,0,.71,7.24A.84.84,0,0,0,295.49,72.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M297.12,63.55c-.14-.74,1.76,10.46,3.51,10,1-.24.22-16.75-.53-17.39s-3.75-1-4.37-.22S297.31,64.52,297.12,63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M297.2,63.18c-.14-.68,1.66,9.84,3.32,9.44.93-.23.25-15.72-.46-16.34s-3.52-1-4.13-.25S297.38,64.06,297.2,63.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M297.27,62.8c-.13-.61,1.57,9.23,3.15,8.85.88-.21.26-14.69-.39-15.29s-3.31-1-3.9-.27S297.44,63.6,297.27,62.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M297.34,62.42c-.11-.54,1.48,8.61,3,8.27.84-.2.29-13.66-.32-14.25s-3.09-.92-3.66-.3S297.5,63.14,297.34,62.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M297.42,62c-.11-.47,1.38,8,2.78,7.68.81-.18.32-12.63-.25-13.2s-2.87-.9-3.42-.32S297.56,62.68,297.42,62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M297.49,61.67c-.1-.41,1.29,7.37,2.6,7.09.77-.17.35-11.61-.17-12.15s-2.66-.88-3.19-.35S297.63,62.22,297.49,61.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M297.57,61.29c-.09-.34,1.19,6.76,2.42,6.5.72-.15.36-10.57-.11-11.1s-2.44-.86-3-.37S297.69,61.76,297.57,61.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M297.64,60.91c-.08-.27,1.1,6.15,2.24,5.91.69-.14.39-9.54,0-10a2.87,2.87,0,0,0-2.73-.4C296.63,56.81,297.75,61.3,297.64,60.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M297.71,60.53c-.06-.2,1,5.53,2.06,5.33.65-.13.42-8.51,0-9a2.59,2.59,0,0,0-2.49-.42C296.84,56.82,297.82,60.84,297.71,60.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M297.79,60.16c-.06-.14.92,4.91,1.87,4.73.61-.11.44-7.48.11-8a2.27,2.27,0,0,0-2.25-.45C297.06,56.83,297.88,60.38,297.79,60.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M297.86,59.78c0-.07.83,4.3,1.7,4.15.57-.1.46-6.46.18-6.91a2,2,0,0,0-2-.47C297.28,56.84,298,59.92,297.86,59.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M297.94,59.4c-.05,0,.73,3.69,1.51,3.56.53-.08.49-5.42.25-5.86a1.77,1.77,0,0,0-1.78-.5C297.49,56.84,298,59.47,297.94,59.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M298,59c0,.08.64,3.07,1.33,3,.49-.07.51-4.4.33-4.82a1.51,1.51,0,0,0-1.55-.52C297.71,56.85,298.06,59,298,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M298.08,58.65c0,.14.55,2.45,1.16,2.38.45-.05.53-3.36.39-3.76a1.23,1.23,0,0,0-1.31-.55C297.93,56.86,298.11,58.55,298.08,58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M298.16,58.27c0,.21.45,1.84,1,1.8s.56-2.34.46-2.72a1,1,0,0,0-1.07-.57C298.14,56.87,298.18,58.09,298.16,58.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M298.23,57.89c0,.28.37,1.23.79,1.21s.59-1.31.54-1.67a.81.81,0,0,0-.85-.6C298.36,56.88,298.24,57.63,298.23,57.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M298.3,57.51a.62.62,0,0,0,.61.63.63.63,0,1,0-.61-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M368.23,335.05c3.79,4.3,28.75,2.5,46.26,2.5s48.08,1.15,50.72-3.89-15.79-23.17-20.56-25.52-49.92-3.58-54.71-.66S364.57,330.9,368.23,335.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M368.35,335c3.74,4.27,28.71,2.46,46.15,2.46s48,1.18,50.6-3.82-15.8-23.1-20.55-25.44-49.74-3.56-54.51-.66S364.74,330.88,368.35,335Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M368.47,335c3.69,4.23,28.66,2.42,46,2.42s47.92,1.21,50.49-3.76-15.82-23-20.55-25.35-49.55-3.55-54.31-.65S364.91,330.87,368.47,335Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M368.59,334.92c3.64,4.21,28.61,2.39,45.93,2.39s47.85,1.24,50.37-3.69-15.83-22.94-20.55-25.27-49.36-3.53-54.09-.65S365.08,330.85,368.59,334.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M368.71,334.88c3.59,4.17,28.57,2.35,45.82,2.35s47.77,1.28,50.26-3.63-15.85-22.86-20.55-25.18-49.17-3.52-53.89-.64S365.25,330.83,368.71,334.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M368.83,334.84c3.54,4.14,28.52,2.31,45.7,2.31s47.7,1.31,50.16-3.56-15.87-22.79-20.55-25.1-49-3.5-53.69-.64S365.42,330.81,368.83,334.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M369,334.79c3.49,4.11,28.48,2.28,45.59,2.28s47.62,1.34,50-3.5-15.88-22.71-20.54-25-48.8-3.5-53.48-.65S365.59,330.79,369,334.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M369.07,334.75c3.43,4.09,28.43,2.25,45.48,2.25s47.54,1.36,49.93-3.44-15.91-22.63-20.55-24.92-48.61-3.48-53.27-.64S365.75,330.78,369.07,334.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M369.19,334.7c3.37,4.06,28.38,2.22,45.37,2.22s47.47,1.39,49.81-3.38S448.45,311,443.83,308.71s-48.43-3.47-53.07-.64S365.92,330.76,369.19,334.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M369.31,334.66c3.32,4,28.34,2.18,45.26,2.18s47.39,1.43,49.7-3.31-15.94-22.48-20.54-24.75-48.24-3.45-52.87-.64S366.08,330.74,369.31,334.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M369.43,334.62c3.27,4,28.29,2.14,45.14,2.14s47.32,1.46,49.59-3.25-16-22.4-20.53-24.66-48.06-3.44-52.66-.63S366.25,330.73,369.43,334.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M369.55,334.57c3.22,4,28.24,2.11,45,2.11s47.24,1.49,49.48-3.18-16-22.32-20.54-24.58-47.86-3.42-52.45-.63S366.42,330.71,369.55,334.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M369.67,334.53c3.17,3.94,28.2,2.07,44.92,2.07s47.16,1.52,49.37-3.11-16-22.25-20.54-24.5-47.68-3.41-52.25-.62S366.59,330.69,369.67,334.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M369.8,334.49c3.11,3.9,28.14,2,44.8,2s47.09,1.55,49.25-3-16-22.17-20.53-24.41-47.49-3.4-52.05-.62S366.76,330.67,369.8,334.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M369.92,334.44c3.05,3.88,28.1,2,44.69,2s47,1.58,49.14-3-16-22.1-20.54-24.32-47.3-3.39-51.83-.63S366.92,330.65,369.92,334.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M370,334.4c3,3.84,28,2,44.57,2s46.94,1.61,49-2.93-16-22-20.53-24.23-47.11-3.38-51.63-.62S367.09,330.64,370,334.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M370.16,334.36c2.95,3.81,28,1.93,44.46,1.93s46.86,1.64,48.92-2.86S447.49,311.49,443,309.28s-46.93-3.36-51.43-.62S367.26,330.62,370.16,334.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M370.28,334.31c2.9,3.78,28,1.9,44.35,1.9s46.78,1.67,48.8-2.8-16.06-21.86-20.52-24.06-46.74-3.35-51.23-.62S367.43,330.6,370.28,334.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M370.4,334.27c2.85,3.75,27.91,1.86,44.24,1.86s46.7,1.7,48.69-2.73-16.08-21.79-20.53-24-46.55-3.33-51-.61S367.6,330.58,370.4,334.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M370.52,334.23c2.79,3.72,27.86,1.82,44.13,1.82s46.63,1.74,48.58-2.67-16.1-21.7-20.53-23.89-46.36-3.32-50.81-.61S367.77,330.56,370.52,334.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M370.64,334.18c2.74,3.69,27.82,1.79,44,1.79s46.56,1.77,48.47-2.6S447,311.74,442.6,309.56s-46.18-3.3-50.61-.6S367.93,330.54,370.64,334.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M370.76,334.14c2.69,3.66,27.77,1.76,43.9,1.76s46.48,1.79,48.36-2.55-16.13-21.55-20.52-23.72-46-3.29-50.4-.6S368.1,330.53,370.76,334.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M370.88,334.1c2.64,3.62,27.72,1.72,43.79,1.72s46.4,1.82,48.24-2.48-16.14-21.48-20.52-23.63-45.8-3.28-50.19-.61S368.27,330.51,370.88,334.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M371,334.05c2.59,3.6,27.68,1.69,43.68,1.69s46.32,1.85,48.13-2.41-16.16-21.4-20.52-23.55-45.61-3.27-50-.6S368.44,330.49,371,334.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M371.12,334c2.54,3.56,27.63,1.65,43.57,1.65s46.25,1.89,48-2.35S446.52,312,442.19,309.85s-45.43-3.25-49.79-.6S368.61,330.47,371.12,334Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M371.24,334c2.48,3.53,27.59,1.61,43.45,1.61s46.18,1.92,47.91-2.28-16.2-21.25-20.52-23.38-45.23-3.24-49.57-.6S368.77,330.45,371.24,334Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M371.36,333.92c2.43,3.5,27.54,1.58,43.34,1.58s46.1,1.95,47.8-2.22S446.28,312.11,442,310s-45.05-3.22-49.37-.59S368.94,330.44,371.36,333.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M371.48,333.88c2.38,3.47,27.49,1.54,43.23,1.54s46,2,47.68-2.15-16.23-21.09-20.51-23.21-44.87-3.21-49.17-.59S369.11,330.42,371.48,333.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M371.6,333.83c2.33,3.44,27.45,1.52,43.12,1.52s45.94,2,47.57-2.1-16.25-21-20.51-23.12-44.68-3.2-49-.58S369.28,330.4,371.6,333.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M371.72,333.79c2.28,3.41,27.4,1.48,43,1.48s45.87,2,47.45-2-16.26-20.94-20.51-23-44.49-3.19-48.75-.59S369.45,330.38,371.72,333.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "M371.84,333.75c2.23,3.37,27.35,1.44,42.89,1.44s45.8,2.07,47.35-2-16.28-20.86-20.51-22.94-44.3-3.18-48.55-.59S369.62,330.36,371.84,333.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M372,333.7c2.17,3.35,27.31,1.41,42.78,1.41s45.72,2.1,47.24-1.9-16.3-20.78-20.51-22.86-44.12-3.16-48.35-.58S369.78,330.34,372,333.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M372.09,333.66C374.2,337,399.34,335,414.75,335s45.64,2.13,47.12-1.84-16.31-20.7-20.5-22.77-43.93-3.15-48.14-.58S370,330.32,372.09,333.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M372.21,333.62c2.06,3.28,27.21,1.33,42.55,1.33s45.56,2.16,47-1.77-16.33-20.63-20.51-22.69-43.74-3.13-47.93-.58S370.12,330.3,372.21,333.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M372.33,333.57c2,3.25,27.16,1.3,42.43,1.3s45.5,2.2,46.9-1.7-16.34-20.56-20.5-22.61-43.55-3.12-47.73-.57S370.29,330.29,372.33,333.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M372.45,333.53c2,3.22,27.11,1.26,42.32,1.26s45.42,2.23,46.79-1.64-16.36-20.47-20.5-22.52-43.37-3.1-47.53-.57S370.46,330.27,372.45,333.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M372.57,333.49c1.91,3.18,27.07,1.23,42.21,1.23s45.34,2.25,46.67-1.58S445.08,312.74,441,310.7s-43.18-3.09-47.32-.56S370.63,330.25,372.57,333.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M372.69,333.44c1.86,3.16,27,1.2,42.1,1.2s45.26,2.28,46.56-1.52S445,312.8,440.85,310.78s-43-3.08-47.11-.57S370.79,330.23,372.69,333.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M372.81,333.4c1.81,3.12,27,1.16,42,1.16s45.18,2.31,46.45-1.45-16.41-20.25-20.5-22.26-42.8-3.07-46.91-.57S371,330.21,372.81,333.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M372.93,333.36c1.75,3.09,26.93,1.12,41.87,1.12s45.12,2.35,46.34-1.39-16.42-20.17-20.49-22.17-42.62-3.05-46.71-.56S371.13,330.19,372.93,333.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M373.05,333.31c1.7,3.06,26.88,1.09,41.76,1.09s45,2.38,46.23-1.32S444.6,313,440.54,311s-42.42-3-46.49-.56S371.3,330.17,373.05,333.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M373.17,333.27c1.65,3,26.84,1.05,41.65,1.05s45,2.41,46.11-1.26-16.46-20-20.49-22-42.24-3-46.29-.56S371.47,330.15,373.17,333.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M373.29,333.23c1.6,3,26.79,1,41.54,1s44.88,2.44,46-1.19-16.48-19.94-20.49-21.92-42-3-46.09-.55S371.64,330.13,373.29,333.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M373.41,333.18c1.55,3,26.74,1,41.43,1s44.8,2.46,45.89-1.14-16.5-19.86-20.49-21.83-41.87-3-45.88-.55S371.81,330.12,373.41,333.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M373.53,333.14c1.5,2.93,26.7.95,41.31.95s44.74,2.5,45.78-1.07-16.51-19.78-20.49-21.75-41.68-3-45.67-.54S372,330.1,373.53,333.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M373.65,333.1c1.45,2.9,26.65.91,41.2.91s44.66,2.53,45.67-1S444,313.3,440,311.35s-41.49-3-45.47-.55S372.15,330.08,373.65,333.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M373.77,333.05c1.4,2.87,26.6.88,41.09.88s44.58,2.56,45.55-.94-16.54-19.63-20.48-21.57-41.31-3-45.27-.55S372.31,330.06,373.77,333.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M373.89,333c1.35,2.83,26.56.84,41,.84s44.5,2.59,45.44-.87-16.56-19.56-20.48-21.49-41.12-2.95-45.06-.54S372.48,330,373.89,333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M374,333c1.3,2.8,26.51.8,40.87.8s44.42,2.62,45.32-.81-16.57-19.47-20.48-21.4-40.93-2.93-44.85-.54S372.65,330,374,333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M374.13,332.92c1.25,2.77,26.47.77,40.75.77s44.35,2.66,45.22-.74-16.59-19.4-20.48-21.32-40.74-2.92-44.65-.54S372.82,330,374.13,332.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M374.25,332.88c1.2,2.74,26.42.74,40.64.74s44.28,2.68,45.11-.69-16.61-19.32-20.48-21.23-40.56-2.9-44.45-.53S373,330,374.25,332.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M374.37,332.83c1.15,2.71,26.37.71,40.53.71s44.2,2.71,45-.62-16.62-19.25-20.48-21.15-40.36-2.89-44.23-.53S373.16,330,374.37,332.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "M374.5,332.79c1.09,2.68,26.32.67,40.41.67s44.12,2.74,44.88-.56-16.64-19.16-20.48-21.06-40.18-2.87-44-.52S373.33,329.94,374.5,332.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-390",
    d: "M374.62,332.75c1,2.64,26.27.63,40.3.63s44,2.77,44.76-.49-16.65-19.09-20.47-21-40-2.87-43.83-.53S373.5,329.92,374.62,332.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M374.74,332.7c1,2.61,26.22.6,40.18.6s44,2.81,44.66-.43-16.67-19-20.47-20.88-39.81-2.85-43.63-.53S373.67,329.9,374.74,332.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "M374.86,332.66c.94,2.58,26.18.56,40.07.56s43.9,2.84,44.54-.36-16.68-18.94-20.47-20.8-39.61-2.84-43.41-.52S373.84,329.88,374.86,332.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "M375,332.62c.89,2.54,26.13.52,40,.52s43.82,2.87,44.43-.29S442.67,314,438.9,312.13s-39.43-2.82-43.21-.52S374,329.86,375,332.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "M375.1,332.57c.84,2.51,26.09.5,39.85.5s43.74,2.89,44.32-.24-16.72-18.78-20.47-20.63-39.24-2.81-43-.52S374.18,329.84,375.1,332.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "M375.22,332.53c.79,2.48,26,.46,39.74.46s43.66,2.92,44.2-.17-16.74-18.71-20.46-20.55-39.06-2.79-42.8-.51S374.35,329.82,375.22,332.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-396",
    d: "M375.34,332.49c.74,2.44,26,.42,39.62.42s43.59,3,44.1-.11-16.76-18.63-20.47-20.46-38.86-2.78-42.59-.51S374.52,329.8,375.34,332.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "M375.46,332.44c.69,2.42,26,.39,39.51.39s43.52,3,44,0-16.77-18.55-20.46-20.38-38.68-2.76-42.39-.5S374.7,329.78,375.46,332.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "M375.58,332.4c.64,2.38,25.9.35,39.4.35s43.44,3,43.87,0-16.79-18.47-20.46-20.28-38.49-2.76-42.19-.51S374.87,329.76,375.58,332.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "M375.7,332.36c.59,2.34,25.85.31,39.29.31s43.36,3.05,43.76.09-16.81-18.4-20.47-20.2-38.3-2.75-42-.51S375,329.74,375.7,332.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-400",
    d: "M375.82,332.31c.55,2.32,25.81.28,39.18.28s43.28,3.08,43.64.15-16.82-18.32-20.46-20.11-38.12-2.73-41.77-.5S375.21,329.72,375.82,332.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-401",
    d: "M375.94,332.27c.5,2.28,25.76.25,39.06.25s43.21,3.11,43.54.21-16.84-18.24-20.46-20-37.93-2.72-41.57-.5S375.38,329.7,375.94,332.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-402",
    d: "M376.06,332.23c.45,2.24,25.72.21,38.95.21s43.14,3.14,43.42.27S441.58,314.55,438,312.77s-37.75-2.7-41.37-.5S375.55,329.68,376.06,332.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-403",
    d: "M376.18,332.18c.4,2.22,25.67.18,38.84.18s43.06,3.17,43.31.34-16.87-18.09-20.46-19.86-37.55-2.69-41.15-.49S375.73,329.66,376.18,332.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M376.3,332.14c.35,2.18,25.62.14,38.73.14s43,3.2,43.19.41-16.88-18-20.45-19.78-37.37-2.67-40.95-.49S375.9,329.64,376.3,332.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-405",
    d: "M376.42,332.1c.31,2.15,25.58.1,38.62.1s42.9,3.23,43.08.47-16.9-17.93-20.45-19.69-37.18-2.66-40.75-.48S376.07,329.62,376.42,332.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-406",
    d: "M376.54,332.05c.26,2.12,25.53.07,38.5.07s42.83,3.27,43,.54-16.92-17.86-20.45-19.6-37-2.65-40.54-.49S376.25,329.6,376.54,332.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-407",
    d: "M376.66,332c.22,2.08,25.48,0,38.39,0s42.76,3.3,42.86.6S441,314.86,437.46,313.13s-36.8-2.64-40.33-.49S376.43,329.58,376.66,332Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M376.78,332c.17,2.06,25.44,0,38.28,0s42.68,3.33,42.75.67-16.95-17.71-20.45-19.43-36.62-2.62-40.13-.48S376.59,329.56,376.78,332Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-409",
    d: "M369.12,332.63c0,1.24,5.51,2.25,12.3,2.25s12.3-1,12.3-2.25-5.51-2.25-12.3-2.25S369.12,331.39,369.12,332.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-410",
    d: "M439.53,332.63c0,1.24,5.5,2.25,12.3,2.25s12.29-1,12.29-2.25-5.5-2.25-12.29-2.25S439.53,331.39,439.53,332.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-411",
    x: 395.42,
    y: 298.47,
    width: 42.39,
    height: 13.22,
    rx: 2.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-412",
    x: 367.58,
    y: 197.39,
    width: 98.07,
    height: 85.32,
    transform: "translate(656.66 -176.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-413",
    points: "436.75 300.75 396.48 300.75 379.25 293.08 453.99 293.08 436.75 300.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-414",
    d: "M446.37,309.06h13a0,0,0,0,1,0,0v22.15a2.09,2.09,0,0,1-2.09,2.09h-8.78a2.09,2.09,0,0,1-2.09-2.09V309.06A0,0,0,0,1,446.37,309.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-415",
    d: "M461.41,321.13H445.58a.31.31,0,0,1-.34-.22L444,293.27h17.77v27.61C461.74,321,461.59,321.13,461.41,321.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-416",
    d: "M375.07,309.06h13.28a0,0,0,0,1,0,0v22.13a2.12,2.12,0,0,1-2.12,2.12h-9a2.12,2.12,0,0,1-2.12-2.12V309.06A0,0,0,0,1,375.07,309.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-417",
    d: "M388.93,321.13H372.72c-.19,0-.35-.11-.35-.25V293.27h18.2l-1.3,27.64C389.26,321,389.11,321.13,388.93,321.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-418",
    x: 405.71,
    y: 297.69,
    width: 22.65,
    height: 5.26,
    rx: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-419",
    d: "M428,303.09H406.09a.51.51,0,0,1-.52-.51v-4.51a.52.52,0,0,1,.52-.52H428a.52.52,0,0,1,.52.52v4.51A.51.51,0,0,1,428,303.09Zm-21.89-5.26a.24.24,0,0,0-.24.24v4.51a.24.24,0,0,0,.24.24H428a.24.24,0,0,0,.24-.24v-4.51a.24.24,0,0,0-.24-.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-420",
    x: 415.45,
    y: 188.66,
    width: 2.33,
    height: 102.07
  }), /*#__PURE__*/React.createElement("image", {
    width: 95,
    height: 107,
    transform: "translate(369.24 186.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAABrCAYAAAARp15OAAAACXBIWXMAAAsSAAALEgHS3X78AAADHElEQVR4Xu3dwW7TQBDG8VkrpIVbVJRIfYFyBN6n4sWA5yq35tRUJSkH1AaHeDmYRAleO15rxmvg/zs6G1WabD/PbjaJ+/T5o//+/CTo1+V0JiMRkTdXV+LEnRr/3/LiTw2Jkq9zWT8/lcXfybKsbjw0/Z7n+2pT+L6545m/M309DV1GV05k+biU7c/t0eVK8cfjsbSNf+daDgz4257rxLWuy6H7xUJms1nwnhqc+Y+rpcznc7m+/tDhz+HQ/WLhfc39mqBPiOIbK6d9eOrXFr9rNqI9Zn4PyPxEau+2Quz0JDLzYY/im+sQO52Wc6jwvsMNl8i3R+yYqy6yds0MsWOsodMkdvoQnfnQQreTTDnrIxdZxI49Ysec75L5TH0NUd3O+dm5iBA7ulpmvhcvd3eL0Fh0Ui28L8pr2Tr/UXnQOZE8zyvXES8qdqCv/Q3Xi3Cz1RT5Bjo3Wz3ETmLj8Th4PQtHDFNfT+TeDrGjpzF2qHM6WThheEn0EDvJRHU72p8/Qr2aVpOpr6eczKETgMSOsajYQX/Y2zFHt5PMidih0qnUrHB5QfQQO8nQ7QwUezvmImLHiyd2FBE7A8XejrmI2EF/aDWNxWU+ezvKiJ1BykLfgETs6ImLHREhdjQRO4NEt2OsOXb+KHR5eoHq6yF2BonYMUa3kxSxM0jEjrG4I+Ls7ShrjB0KnQqxY4xuJ6mIbofz+f0hdoztYie0dc+5HXP76lewyEqI2DFGt5NUQ7dDmdMhdozFfTKFvR1lEYss9IfYMRbV7fAGujZiZ5CC2wvEjp6o2ClRfT3EziAFV7jEjh5iJ6my+tvi+FegRYidpFhkGYvb2xERYkdTTLfD++e94fRCQjWZT+xo6fRjxLCXiQufKYE9YsdYY+xQ5nTI/ISIHWN0OwPFJ1MSGoUu7lLn5svNP7XcbYoASy4LB0yl+N57mUwuZDK5kE2+CT0HITUB8vbdeymKIvhYpfibfCMPXx9CY3FIIa1HIsebaWystaRQpv3ML3z4XwPxTm3XrL6t5NXZSxk5Ebm9nTcOhoKD1+PFqJzzvwCwSdX2WXQQEwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-421",
    x: 412.41,
    y: 188.66,
    width: 0.75,
    height: 102.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-422",
    x: 411.04,
    y: 282.21,
    width: 3.5,
    height: 5.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-423",
    x: 411.04,
    y: 192.18,
    width: 3.5,
    height: 5.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-424",
    x: 412.41,
    y: 290.74,
    width: 1.67,
    height: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-425",
    d: "M400.3,274.44h0a2,2,0,0,0,2,2h11.3v-4h-11.3A2,2,0,0,0,400.3,274.44Zm4.68,1.31h-2.79a1.31,1.31,0,0,1-1.31-1.31h0a1.31,1.31,0,0,1,1.31-1.31H405a.69.69,0,0,1,.69.69v1.25A.68.68,0,0,1,405,275.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-426",
    x: 420.28,
    y: 188.66,
    width: 0.75,
    height: 102.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-427",
    x: 418.91,
    y: 282.21,
    width: 3.5,
    height: 5.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-428",
    x: 418.91,
    y: 192.18,
    width: 3.5,
    height: 5.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-429",
    x: 419.36,
    y: 290.74,
    width: 1.67,
    height: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M431.05,272.46h-11.3v4h11.3a2,2,0,0,0,2-2h0A2,2,0,0,0,431.05,272.46Zm-3.39,2.61v-1.25a.68.68,0,0,1,.68-.69h2.79a1.31,1.31,0,0,1,1.31,1.31h0a1.3,1.3,0,0,1-1.31,1.31h-2.79A.67.67,0,0,1,427.66,275.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-431",
    d: "M382.46,207.9h-8.64v-3.21h8.64a1.6,1.6,0,0,1,1.6,1.6h0A1.6,1.6,0,0,1,382.46,207.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M374.49,207.23v-1.87h8a.94.94,0,1,1,0,1.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-433",
    cx: 374.11,
    cy: 204.11,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-434",
    cx: 374.11,
    cy: 208.33,
    r: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-435",
    d: "M382.46,242.51h-8.64V239.3h8.64a1.6,1.6,0,0,1,1.6,1.6h0A1.6,1.6,0,0,1,382.46,242.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-436",
    d: "M374.49,241.84V240h8a.94.94,0,1,1,0,1.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-437",
    cx: 374.11,
    cy: 238.72,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-438",
    cx: 374.11,
    cy: 242.94,
    r: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-439",
    d: "M382.46,277.12h-8.64v-3.21h8.64a1.6,1.6,0,0,1,1.6,1.6h0A1.6,1.6,0,0,1,382.46,277.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "M374.49,276.45v-1.87h8a.94.94,0,1,1,0,1.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-441",
    cx: 374.11,
    cy: 273.33,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-442",
    cx: 374.11,
    cy: 277.55,
    r: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-443",
    x: 373.61,
    y: 204.44,
    width: 1,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-444",
    x: 373.61,
    y: 239.05,
    width: 1,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-445",
    x: 373.61,
    y: 273.66,
    width: 1,
    height: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-446",
    d: "M450.7,207.9h8.63v-3.21H450.7a1.61,1.61,0,0,0-1.61,1.6h0A1.61,1.61,0,0,0,450.7,207.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "M458.67,207.23v-1.87h-8a.94.94,0,1,0,0,1.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-448",
    cx: 459.04,
    cy: 204.11,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-449",
    cx: 459.04,
    cy: 208.33,
    r: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-450",
    d: "M450.7,242.51h8.63V239.3H450.7a1.61,1.61,0,0,0-1.61,1.6h0A1.61,1.61,0,0,0,450.7,242.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-451",
    d: "M458.67,241.84V240h-8a.94.94,0,1,0,0,1.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-452",
    cx: 459.04,
    cy: 238.72,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-453",
    cx: 459.04,
    cy: 242.94,
    r: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-454",
    d: "M450.7,277.12h8.63v-3.21H450.7a1.61,1.61,0,0,0-1.61,1.6h0A1.61,1.61,0,0,0,450.7,277.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "M458.67,276.45v-1.87h-8a.94.94,0,1,0,0,1.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-456",
    cx: 459.04,
    cy: 273.33,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-457",
    cx: 459.04,
    cy: 277.55,
    r: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-458",
    x: 458.54,
    y: 204.44,
    width: 1,
    height: 3.7,
    transform: "translate(918.09 412.59) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-459",
    x: 458.54,
    y: 239.05,
    width: 1,
    height: 3.7,
    transform: "translate(918.09 481.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-460",
    x: 458.54,
    y: 273.66,
    width: 1,
    height: 3.7,
    transform: "translate(918.09 551.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-461",
    x: 377.9,
    y: 303.01,
    width: 14.43,
    height: 5.27,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-173",
    width: 14,
    height: 6,
    transform: "translate(378.24 302.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAGCAYAAADzG6+8AAAACXBIWXMAAAsSAAALEgHS3X78AAAAp0lEQVQYV4WKywmDUBREz33vkWRhAXZgEfYmceMitmAb9qMbESRKPoLEz80iYjYJDgxzBo6oKoCuy3p+MijWOgCxxhgNw5BxfDEMA33f83w+uN3udF1H215pmoa6rqmqiizLKMvi7ACSJCGKIjmd2E2e51oUJWZP/BeJ41gBjBFEPp2mGYDj8fAVRTb2fR9ZlkXT9ALAPM+oKiKCtXYTPc/DObc1CALeb7ZL8G0QeqcAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-462",
    x: 383.04,
    y: 299.27,
    width: 4.07,
    height: 12.46,
    rx: 0.56,
    transform: "translate(690.58 -79.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-462",
    x: 383.04,
    y: 299.27,
    width: 4.07,
    height: 12.46,
    rx: 0.56,
    transform: "translate(690.58 -79.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-463",
    d: "M381.18,307.23a1.4,1.4,0,1,0-1.54-1.39A1.47,1.47,0,0,0,381.18,307.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-464",
    d: "M385.12,307.23a1.4,1.4,0,1,0-1.54-1.39A1.47,1.47,0,0,0,385.12,307.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-463",
    d: "M389.05,307.23a1.4,1.4,0,1,0-1.54-1.39A1.47,1.47,0,0,0,389.05,307.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-465",
    x: 384.22,
    y: 300.75,
    width: 1.9,
    height: 11.67,
    rx: 0.7,
    transform: "translate(691.76 -78.58) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-466",
    d: "M391,307.14h0a.39.39,0,0,1-.38.4H379.71a.39.39,0,0,1-.37-.4h0a.39.39,0,0,1,.37-.39h10.92A.39.39,0,0,1,391,307.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-467",
    d: "M378.84,303.85V305a.56.56,0,0,1,.55-.57h11.37a.56.56,0,0,1,.55.57v-1.17c0-.21-.37-.38-.82-.38H379.66C379.21,303.47,378.84,303.64,378.84,303.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-468",
    x: 383.04,
    y: 303.62,
    width: 4.07,
    height: 3.76,
    transform: "translate(690.58 -79.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-469",
    d: "M382.73,298V303h6.32l4.5-5.06h-2.24L388,302.06a.66.66,0,0,1-.41.14H385.4a.6.6,0,0,1-.63-.55V298Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-470",
    x: 440.75,
    y: 303.01,
    width: 14.43,
    height: 5.27,
    rx: 0.63,
    transform: "translate(895.94 611.29) rotate(180)"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-173",
    width: 15,
    height: 6,
    transform: "translate(440.24 302.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAGCAYAAAAc2cSCAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQYV42QwQnDMBAER/JBXII6cSqI23Fa0M/uT53o4yB58wgyCQElA/tZZjk4JwmAWquGYeAfSimYmTOAGKMA5vnWX72RUpIBasU0XV3HP2nH/C+xh5OkbVvPov0AYN8fXwPvHcfxcgxwIQSVUmjJOQMwjhckfcTMAFiWO08hxj363Pc+HQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-462",
    x: 445.97,
    y: 299.27,
    width: 4.07,
    height: 12.46,
    rx: 0.56,
    transform: "translate(753.51 -142.51) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-462",
    x: 445.97,
    y: 299.27,
    width: 4.07,
    height: 12.46,
    rx: 0.56,
    transform: "translate(753.51 -142.51) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-463",
    d: "M451.9,307.23a1.4,1.4,0,1,1,1.54-1.39A1.47,1.47,0,0,1,451.9,307.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-464",
    d: "M448,307.23a1.4,1.4,0,1,1,1.54-1.39A1.47,1.47,0,0,1,448,307.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-463",
    d: "M444,307.23a1.4,1.4,0,1,1,1.54-1.39A1.47,1.47,0,0,1,444,307.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-471",
    x: 446.96,
    y: 300.75,
    width: 1.9,
    height: 11.67,
    rx: 0.7,
    transform: "translate(754.5 -141.33) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-466",
    d: "M442.08,307.14h0a.39.39,0,0,0,.38.4h10.91a.39.39,0,0,0,.38-.4h0a.39.39,0,0,0-.38-.39H442.46A.39.39,0,0,0,442.08,307.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-467",
    d: "M454.24,303.85V305a.55.55,0,0,0-.54-.57H442.32a.55.55,0,0,0-.54.57v-1.17c0-.21.36-.38.81-.38h10.84C453.88,303.47,454.24,303.64,454.24,303.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-468",
    x: 445.97,
    y: 303.62,
    width: 4.07,
    height: 3.76,
    transform: "translate(753.51 -142.51) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "M450.36,298V303H444l-4.5-5.06h2.25l3.35,4.11a.66.66,0,0,0,.41.14h2.15a.59.59,0,0,0,.62-.55V298Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-473",
    x: 369.96,
    y: 293.08,
    width: 93.31,
    height: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M368.23,149.37c3.79,4.31,28.75,2.5,46.26,2.5S462.57,153,465.21,148s-15.79-23.17-20.56-25.52-49.92-3.57-54.71-.66S364.57,145.23,368.23,149.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M368.35,149.33c3.74,4.27,28.71,2.46,46.15,2.46s48,1.18,50.6-3.82-15.8-23.1-20.55-25.44S394.81,119,390,121.88,364.74,145.21,368.35,149.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M368.47,149.29c3.69,4.24,28.66,2.42,46,2.42S462.43,152.92,465,148s-15.82-23-20.55-25.35-49.55-3.54-54.31-.65S364.91,145.19,368.47,149.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M368.59,149.24c3.64,4.21,28.61,2.39,45.93,2.39s47.85,1.25,50.37-3.69S449.06,125,444.34,122.67,395,119.14,390.25,122,365.08,145.17,368.59,149.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M368.71,149.2c3.59,4.18,28.57,2.35,45.82,2.35s47.77,1.28,50.26-3.63-15.85-22.86-20.55-25.17-49.17-3.53-53.89-.65S365.25,145.15,368.71,149.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M368.83,149.16c3.54,4.14,28.52,2.32,45.7,2.32s47.7,1.3,50.16-3.57-15.87-22.79-20.55-25.09-49-3.51-53.69-.65S365.42,145.13,368.83,149.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M369,149.11c3.49,4.12,28.48,2.29,45.59,2.29s47.62,1.33,50-3.5-15.88-22.71-20.54-25-48.8-3.5-53.48-.64S365.59,145.11,369,149.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M369.07,149.07c3.43,4.09,28.43,2.25,45.48,2.25s47.54,1.36,49.93-3.44S448.57,125.25,443.93,123s-48.61-3.48-53.27-.64S365.75,145.1,369.07,149.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M369.19,149c3.37,4.05,28.38,2.21,45.37,2.21s47.47,1.4,49.81-3.37S448.45,125.31,443.83,123s-48.43-3.47-53.07-.64S365.92,145.08,369.19,149Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M369.31,149c3.32,4,28.34,2.18,45.26,2.18s47.39,1.43,49.7-3.31-15.94-22.48-20.54-24.75-48.24-3.45-52.87-.63S366.08,145.07,369.31,149Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M369.43,148.94c3.27,4,28.29,2.14,45.14,2.14s47.32,1.46,49.59-3.24-16-22.4-20.53-24.67-48.06-3.44-52.66-.63S366.25,145.05,369.43,148.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M369.55,148.9c3.22,4,28.24,2.1,45,2.1s47.24,1.49,49.48-3.18-16-22.32-20.54-24.58-47.86-3.42-52.45-.63S366.42,145,369.55,148.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M369.67,148.85c3.17,3.94,28.2,2.08,44.92,2.08s47.16,1.51,49.37-3.12-16-22.25-20.54-24.49-47.68-3.42-52.25-.63S366.59,145,369.67,148.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M369.8,148.81c3.11,3.9,28.14,2,44.8,2s47.09,1.55,49.25-3.06-16-22.17-20.53-24.4-47.49-3.4-52.05-.63S366.76,145,369.8,148.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M369.92,148.77c3.05,3.87,28.1,2,44.69,2s47,1.58,49.14-3-16-22.09-20.54-24.32-47.3-3.39-51.83-.62S366.92,145,369.92,148.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M370,148.72c3,3.85,28,2,44.57,2s46.94,1.61,49-2.93-16-22-20.53-24.23-47.11-3.37-51.63-.62S367.09,145,370,148.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M370.16,148.68c2.95,3.81,28,1.93,44.46,1.93s46.86,1.64,48.92-2.86S447.49,125.81,443,123.6s-46.93-3.36-51.43-.62S367.26,144.94,370.16,148.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M370.28,148.64c2.9,3.78,28,1.89,44.35,1.89s46.78,1.67,48.8-2.79-16.06-21.87-20.52-24.07-46.74-3.34-51.23-.61S367.43,144.92,370.28,148.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M370.4,148.59c2.85,3.75,27.91,1.86,44.24,1.86s46.7,1.71,48.69-2.73-16.08-21.78-20.53-24-46.55-3.33-51-.61S367.6,144.9,370.4,148.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M370.52,148.55c2.79,3.72,27.86,1.83,44.13,1.83s46.63,1.73,48.58-2.67-16.1-21.71-20.53-23.9-46.36-3.32-50.81-.61S367.77,144.89,370.52,148.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M370.64,148.5c2.74,3.69,27.82,1.8,44,1.8s46.56,1.76,48.47-2.61S447,126.06,442.6,123.89s-46.18-3.31-50.61-.61S367.93,144.87,370.64,148.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M370.76,148.46c2.69,3.66,27.77,1.76,43.9,1.76S461.14,152,463,147.68,446.89,126.12,442.5,124s-46-3.3-50.4-.61S368.1,144.85,370.76,148.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M370.88,148.42c2.64,3.62,27.72,1.72,43.79,1.72s46.4,1.82,48.24-2.48S446.77,126.19,442.39,124s-45.8-3.28-50.19-.6S368.27,144.83,370.88,148.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M371,148.37c2.59,3.6,27.68,1.69,43.68,1.69s46.32,1.86,48.13-2.41-16.16-21.4-20.52-23.55-45.61-3.27-50-.6S368.44,144.81,371,148.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M371.12,148.33c2.54,3.57,27.63,1.65,43.57,1.65s46.25,1.89,48-2.35-16.19-21.32-20.52-23.46-45.43-3.25-49.79-.6S368.61,144.79,371.12,148.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M371.24,148.29c2.48,3.53,27.59,1.61,43.45,1.61s46.18,1.92,47.91-2.28-16.2-21.25-20.52-23.38-45.23-3.24-49.57-.59S368.77,144.78,371.24,148.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M371.36,148.24c2.43,3.51,27.54,1.58,43.34,1.58s46.1,2,47.8-2.22S446.28,126.44,442,124.31s-45.05-3.22-49.37-.59S368.94,144.76,371.36,148.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M371.48,148.2c2.38,3.47,27.49,1.55,43.23,1.55s46,2,47.68-2.16-16.23-21.09-20.51-23.21-44.87-3.21-49.17-.59S369.11,144.74,371.48,148.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M371.6,148.16c2.33,3.44,27.45,1.51,43.12,1.51s45.94,2,47.57-2.09-16.25-21-20.51-23.12-44.68-3.2-49-.59S369.28,144.72,371.6,148.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M371.72,148.11c2.28,3.41,27.4,1.48,43,1.48s45.87,2,47.45-2-16.26-20.94-20.51-23-44.49-3.19-48.75-.59S369.45,144.7,371.72,148.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "M371.84,148.07c2.23,3.38,27.35,1.44,42.89,1.44s45.8,2.07,47.35-2-16.28-20.86-20.51-23-44.3-3.17-48.55-.58S369.62,144.68,371.84,148.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M372,148c2.17,3.34,27.31,1.4,42.78,1.4s45.72,2.1,47.24-1.9-16.3-20.78-20.51-22.86-44.12-3.16-48.35-.58S369.78,144.66,372,148Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M372.09,148c2.11,3.32,27.25,1.37,42.66,1.37s45.64,2.13,47.12-1.83-16.31-20.71-20.5-22.78-43.93-3.14-48.14-.58S370,144.65,372.09,148Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M372.21,147.94c2.06,3.28,27.21,1.33,42.55,1.33s45.56,2.17,47-1.77-16.33-20.63-20.51-22.69-43.74-3.13-47.93-.57S370.12,144.63,372.21,147.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M372.33,147.9c2,3.25,27.16,1.3,42.43,1.3s45.5,2.19,46.9-1.71-16.34-20.56-20.5-22.61-43.55-3.11-47.73-.57S370.29,144.61,372.33,147.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M372.45,147.85c2,3.22,27.11,1.27,42.32,1.27s45.42,2.22,46.79-1.65S445.2,127,441.06,125s-43.37-3.1-47.53-.57S370.46,144.59,372.45,147.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M372.57,147.81c1.91,3.19,27.07,1.23,42.21,1.23s45.34,2.25,46.67-1.58S445.08,127.06,441,125s-43.18-3.1-47.32-.57S370.63,144.57,372.57,147.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M372.69,147.77c1.86,3.15,27,1.19,42.1,1.19s45.26,2.28,46.56-1.52S445,127.12,440.85,125.1s-43-3.08-47.11-.57S370.79,144.55,372.69,147.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M372.81,147.72c1.81,3.13,27,1.16,42,1.16s45.18,2.32,46.45-1.45-16.41-20.25-20.5-22.26-42.8-3.07-46.91-.56S371,144.53,372.81,147.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M372.93,147.68c1.75,3.09,26.93,1.12,41.87,1.12s45.12,2.35,46.34-1.38-16.42-20.17-20.49-22.18-42.62-3-46.71-.56S371.13,144.51,372.93,147.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M373.05,147.64c1.7,3.06,26.88,1.08,41.76,1.08s45,2.38,46.23-1.32-16.44-20.09-20.5-22.09-42.42-3-46.49-.56S371.3,144.49,373.05,147.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M373.17,147.59c1.65,3,26.84,1.06,41.65,1.06s45,2.4,46.11-1.26-16.46-20-20.49-22-42.24-3-46.29-.55S371.47,144.48,373.17,147.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M373.29,147.55c1.6,3,26.79,1,41.54,1s44.88,2.43,46-1.2-16.48-19.94-20.49-21.92-42-3-46.09-.55S371.64,144.46,373.29,147.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M373.41,147.5c1.55,3,26.74,1,41.43,1s44.8,2.47,45.89-1.13-16.5-19.86-20.49-21.84-41.87-3-45.88-.55S371.81,144.44,373.41,147.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M373.53,147.46c1.5,2.93,26.7.95,41.31.95s44.74,2.5,45.78-1.07-16.51-19.78-20.49-21.74-41.68-3-45.67-.55S372,144.42,373.53,147.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M373.65,147.42c1.45,2.9,26.65.91,41.2.91s44.66,2.53,45.67-1S444,127.62,440,125.67s-41.49-3-45.47-.55S372.15,144.4,373.65,147.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M373.77,147.37c1.4,2.87,26.6.88,41.09.88s44.58,2.56,45.55-.94-16.54-19.63-20.48-21.57-41.31-3-45.27-.54S372.31,144.38,373.77,147.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M373.89,147.33c1.35,2.84,26.56.84,41,.84s44.5,2.59,45.44-.87-16.56-19.55-20.48-21.49-41.12-2.94-45.06-.54S372.48,144.36,373.89,147.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M374,147.29c1.3,2.8,26.51.81,40.87.81s44.42,2.62,45.32-.82-16.57-19.47-20.48-21.4-40.93-2.93-44.85-.54S372.65,144.34,374,147.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M374.13,147.24c1.25,2.78,26.47.78,40.75.78s44.35,2.65,45.22-.75-16.59-19.4-20.48-21.32S398.88,123,395,125.42,372.82,144.32,374.13,147.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M374.25,147.2c1.2,2.74,26.42.74,40.64.74s44.28,2.68,45.11-.68S443.39,127.93,439.52,126s-40.56-2.9-44.45-.53S373,144.3,374.25,147.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M374.37,147.16c1.15,2.7,26.37.7,40.53.7s44.2,2.71,45-.62S443.27,128,439.41,126.1s-40.36-2.9-44.23-.54S373.16,144.28,374.37,147.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "M374.5,147.11c1.09,2.68,26.32.67,40.41.67s44.12,2.74,44.88-.55-16.64-19.17-20.48-21.06-40.18-2.88-44-.53S373.33,144.26,374.5,147.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-390",
    d: "M374.62,147.07c1,2.64,26.27.63,40.3.63s44,2.78,44.76-.49-16.65-19.09-20.47-21-40-2.87-43.83-.53S373.5,144.24,374.62,147.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M374.74,147c1,2.61,26.22.59,40.18.59s44,2.81,44.66-.42-16.67-19-20.47-20.89-39.81-2.85-43.63-.52S373.67,144.22,374.74,147Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "M374.86,147c.94,2.58,26.18.56,40.07.56s43.9,2.84,44.54-.36-16.68-18.93-20.47-20.8-39.61-2.84-43.41-.52S373.84,144.2,374.86,147Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "M375,146.94c.89,2.54,26.13.53,40,.53s43.82,2.86,44.43-.3-16.7-18.86-20.47-20.72-39.43-2.82-43.21-.52S374,144.18,375,146.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "M375.1,146.9c.84,2.51,26.09.49,39.85.49s43.74,2.89,44.32-.24-16.72-18.78-20.47-20.63-39.24-2.81-43-.51S374.18,144.16,375.1,146.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "M375.22,146.85c.79,2.48,26,.46,39.74.46s43.66,2.93,44.2-.17-16.74-18.71-20.46-20.55-39.06-2.79-42.8-.51S374.35,144.14,375.22,146.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-396",
    d: "M375.34,146.81c.74,2.44,26,.42,39.62.42s43.59,3,44.1-.11-16.76-18.62-20.47-20.45-38.86-2.79-42.59-.52S374.52,144.12,375.34,146.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "M375.46,146.77c.69,2.41,26,.38,39.51.38s43.52,3,44,0-16.77-18.55-20.46-20.37-38.68-2.77-42.39-.51S374.7,144.1,375.46,146.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "M375.58,146.72c.64,2.38,25.9.35,39.4.35s43.44,3,43.87,0-16.79-18.48-20.46-20.29-38.49-2.76-42.19-.51S374.87,144.08,375.58,146.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "M375.7,146.68c.59,2.35,25.85.31,39.29.31s43.36,3,43.76.09-16.81-18.4-20.47-20.2-38.3-2.74-42-.5S375,144.06,375.7,146.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-400",
    d: "M375.82,146.63c.55,2.32,25.81.29,39.18.29s43.28,3.08,43.64.15S441.82,128.75,438.18,127s-38.12-2.73-41.77-.5S375.21,144,375.82,146.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-401",
    d: "M375.94,146.59c.5,2.28,25.76.25,39.06.25s43.21,3.11,43.54.21-16.84-18.24-20.46-20-37.93-2.71-41.57-.5S375.38,144,375.94,146.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-402",
    d: "M376.06,146.55c.45,2.25,25.72.21,38.95.21s43.14,3.14,43.42.28S441.58,128.87,438,127.09s-37.75-2.7-41.37-.49S375.55,144,376.06,146.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-403",
    d: "M376.18,146.5c.4,2.22,25.67.18,38.84.18s43.06,3.17,43.31.34-16.87-18.09-20.46-19.86-37.55-2.68-41.15-.49S375.73,144,376.18,146.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M376.3,146.46c.35,2.18,25.62.14,38.73.14s43,3.2,43.19.41-16.88-18-20.45-19.77-37.37-2.68-40.95-.5S375.9,144,376.3,146.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-405",
    d: "M376.42,146.42c.31,2.15,25.58.1,38.62.1s42.9,3.24,43.08.47-16.9-17.93-20.45-19.68-37.18-2.67-40.75-.49S376.07,143.94,376.42,146.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-406",
    d: "M376.54,146.37c.26,2.12,25.53.07,38.5.07s42.83,3.27,43,.54-16.92-17.86-20.45-19.6-37-2.65-40.54-.49S376.25,143.92,376.54,146.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-407",
    d: "M376.66,146.33c.22,2.09,25.48,0,38.39,0s42.76,3.29,42.86.59S441,129.18,437.46,127.45s-36.8-2.64-40.33-.49S376.43,143.9,376.66,146.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M376.78,146.29c.17,2.05,25.44,0,38.28,0s42.68,3.32,42.75.66-16.95-17.7-20.45-19.43-36.62-2.62-40.13-.48S376.59,143.89,376.78,146.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M369.12,147c0,1.24,5.51,2.25,12.3,2.25s12.3-1,12.3-2.25-5.51-2.25-12.3-2.25S369.12,145.71,369.12,147Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-475",
    cx: 451.83,
    cy: 146.95,
    rx: 12.3,
    ry: 2.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-476",
    points: "418.06 0.65 417.97 0.65 371.72 0.65 371.72 78.95 417.97 79.77 418.05 79.77 464.31 78.95 464.31 0.65 418.06 0.65"
  }), /*#__PURE__*/React.createElement("image", {
    width: 95,
    height: 81,
    transform: "translate(370.24 -0.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAABRCAYAAAC0RnqFAAAACXBIWXMAAAsSAAALEgHS3X78AAAC1ElEQVR4Xu2dzU7bQBSFz0zssSMktnTHhi6oyrI8CX2/im15A6QCW/oMbcUCxKJKVKm09U98u3DsJCZNiEp8hHS+Te74jq1oZjznzozHdpeXF3Zw8Bqj8QhmhoYn2TDANrcH0aA5sHitzrHu+d28w3SIl0zUGNefr3H09gjAXEHUiQWe7Ov4G180iDApJ2sraKk9vebKipol/u3r+Ff51vkf+eb8q3whBETzVzp+d+we5xbPzfmnc/v29Qt83YssqSGxdTwAmMqegp8JqGqgb/y6DGJ7eLV4HhJcIq3gqvj7Zya4Kv3ekeASkeAS8Rpg8Zh2OwbdAf3jAdP0AgmvYIeHBJeI17waD8X5RLwiHR7eTIspLOYEVzXQNxrhEmkFV3XQP4rziWgli8hsbkfl3xsO9bNpElwiGuESUZxPRFPKRDS3Q0QPyhJRtENEI1wiWskiIsElokEWkXYla+nOObFVJLhEFGoSUcsnIsEl4s2AJEl0AxBQt0NEU8pEtJhCRIJLRHE+EQkuEbV8Imr5RGaCqzroHcX5RBTnE1GcT8Sbwh0aavlEFOcTUZxPRBviiOgda0QkuEQkuERawR0myZqs4rlRt0NEI1wiavlEJLhENMIlom6HiASXiFo+EQkuEQkuEXU7RCS4RNzp6Qf7Ph5j+uYpRIMIgCFNUjjn4J1DmqYAgDiO4eBwcvJe31BcwtnZRyvLAmYGM8OfLENlFSozZHmOsijhBx5vDg9xf3sHd3V1YWbAzs4O4jhGHAfs7u7CzBBCQFmWAAAzQ2UVsiyrP8tq9d5dM0NRFO0fyLKszl9naNOtP19Md++8TfYDZ1kOByAkoX1v2SY4t3hOEhLATd+B5qZpoD0WQoBzrj2vsZ1zcKh/02Ha2lEUYTKZoKoqPDz8RJ4XKIocox9j3N/eIbq5uen+pxfD/v5+vYHbDID9t/374dfUbj7osD17b+8V/gInd7qfE3M6mQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3,
    height: 4,
    transform: "translate(360.24 66.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAACXBIWXMAAAsSAAALEgHS3X78AAAAKklEQVQIW13JsREAIAgAsVcZwmMLj/1news60gYVwFflZvBmCvScCNT1AUeBC+nqqTQiAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 3,
    height: 7,
    transform: "translate(359.24 68.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAHCAYAAADNufepAAAACXBIWXMAAAsSAAALEgHS3X78AAAAOElEQVQIWz3LsQ2AMBTE0Jc/AGlRdgkR7L/T0UDcWbIlgZxjxC9I+Th6V621wHpuu0+iYK4L7AdeOiMSPDuG4JUAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-478"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3,
    height: 4,
    transform: "translate(358.24 73.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAACXBIWXMAAAsSAAALEgHS3X78AAAAIklEQVQIW13JsQ0AIBAAIeKOJu/+g5y10qKC9pmWT6jyzAVsYgsBxWnwuAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-479"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 3,
    transform: "translate(370.24 77.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAACXBIWXMAAAsSAAALEgHS3X78AAAAMUlEQVQIWy3JsQ0AIAhFwYcbKJAYFqNg/zm+jdeeAQKQZACrZ/BMToT4Q89ou+tW6QE3hA4OPEspyQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 23,
    transform: "translate(354.24 56.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAXCAYAAAAGAx/kAAAACXBIWXMAAAsSAAALEgHS3X78AAABKElEQVQ4T6XUW26DMBAF0LEJ2BAIwuG9DcteRNU2bdq0yv4XAf26/UrUNITJ40pXwvb4IH4QRASlNY3DIOiByLbv6WccuTk2sm5bElJyc2yEjmMAePzTxmGgKIq4OTaSiChSipvjY70DEUFICQB0bwkAmfUaQkoEQXA3dnyw3iEIAizC8C7sZGG9wyIMESl1M3a2Yb1DpBS01jdhk5vWO2itESfJ1djFA+sd4iTBMk2vwmYPrXdYpinSLGMx9k3WO6RZhlWez2IsdMBWeY68KC5iLHLo0+sL8qJAYcwkxgJ/+/y2QWEMTFmeYezl/91stzBlibKuTzD24lTfd58o6xpV0xwx9tKlfnx/oWoaNF2HhyAAtNvv0XQd2r6HAMD9smYjhMC6qugXRcUjXQyL6dEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-480"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 4,
    transform: "translate(354.24 54.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAYAAACk7+45AAAACXBIWXMAAAsSAAALEgHS3X78AAAAJklEQVQIWy3BMQ4AMAgDsSsjSPD/n5IpXbABbJvgvJ6xJCKr0C4ft1QLIRGFrUYAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-481"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 4,
    transform: "translate(369.24 87.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAACXBIWXMAAAsSAAALEgHS3X78AAAANUlEQVQIWwXBgQnCUBBAsXd8uBWEriG6SaHuP0hMQhWEen8/zjl2Fwrdv8fuqgyaGa/raqo/Wa4cCODNjFYAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 33,
    transform: "translate(351.24 57.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAhCAYAAADZPosTAAAACXBIWXMAAAsSAAALEgHS3X78AAABuUlEQVRIS62UTUsbURiFn3PnxmSCyRg1GBMQav1YdhHsru2qtKuCFBT0z0p/gfRfJC2SQjSN0/q6CKljEzMzyRy4m8vLwznnvVwBZmaiIDmA3U7H0gYz68vpqTFxSRFHlTC0OI75E8eFxHa/RyO892lzmeWAQoF+o7GBFbcS3OvDQ4ICHbpX+/t475FUjE8zo7O3V9jTcQCbjQaSCLxf3eWUfH55aS4ILPB+JacyezJVLpft78MDkojv75d66M+AAJLMl0o4ifF4nBvq/r8wM73pdufNZtIMEKC920ISYRjmX9JL5XbfnlilUrGwWs21pJkOk5JkYbWKJG6Hw0x9zo08lZlpdHcHwHqtlin+QuBU9SjidjhMGwMyAM1MHz9/Yr1Wox5FqS4XdpjUwdGR9Xs9JPFrMHixz8xAmCypHkXIOQY3N3OhqZGTMjPVomjhTC4gPP1Mm9vbc6PlBn6/vta7D+8B2Go2Z6C5OkyqHkVWWltDEj/7/X99Lg2EyZK2mk0k8aPXEywROSkz08Hx8bO7lYAArZ0dnHO02m2DFSNPdXZxYd+urpBUDBAmfTrnVo88lZnp6/kZjxnzW6+Bj7vKAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-482"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3,
    height: 4,
    transform: "translate(350.24 56.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAACXBIWXMAAAsSAAALEgHS3X78AAAALElEQVQIWwXBsRGAIAAAscdKocLBvGP/YWJSpYIujLlWVQPtd7ufWeg7B/oB4WYUUfW3AgEAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M349.8,74.68h4a2.1,2.1,0,0,0,2.11-2.11V57.62a2.3,2.3,0,0,0-2.29-2.29h-3.89a1.09,1.09,0,0,0-1,.74,27.44,27.44,0,0,0-1.22,8.49,36.93,36.93,0,0,0,1.26,9.32A1.09,1.09,0,0,0,349.8,74.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M349.82,74.57h3.87a2.11,2.11,0,0,0,2.11-2.12V57.73a2.28,2.28,0,0,0-2.28-2.28h-3.76a1.08,1.08,0,0,0-1,.73,27.78,27.78,0,0,0-1.18,8.41,36.73,36.73,0,0,0,1.22,9.18A1.08,1.08,0,0,0,349.82,74.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M349.84,74.45h3.73a2.11,2.11,0,0,0,2.11-2.12V57.84a2.28,2.28,0,0,0-2.27-2.28h-3.62a1.07,1.07,0,0,0-1,.73,28,28,0,0,0-1.16,8.32,36.51,36.51,0,0,0,1.19,9A1.07,1.07,0,0,0,349.84,74.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M349.85,74.34h3.6a2.12,2.12,0,0,0,2.12-2.13V58a2.27,2.27,0,0,0-2.27-2.27h-3.49a1,1,0,0,0-1,.72,28.16,28.16,0,0,0-1.13,8.23,36.41,36.41,0,0,0,1.16,8.93A1,1,0,0,0,349.85,74.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M349.87,74.22h3.45a2.13,2.13,0,0,0,2.13-2.13v-14a2.27,2.27,0,0,0-2.26-2.27h-3.36a1,1,0,0,0-1,.73,28.83,28.83,0,0,0-1.09,8.13,36.41,36.41,0,0,0,1.12,8.8A1,1,0,0,0,349.87,74.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M349.89,74.11h3.31A2.13,2.13,0,0,0,355.33,72V58.17a2.26,2.26,0,0,0-2.26-2.26h-3.22a1,1,0,0,0-1,.72,28.77,28.77,0,0,0-1.06,8.05,36.88,36.88,0,0,0,1.08,8.66A1,1,0,0,0,349.89,74.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M349.91,74h3.17a2.13,2.13,0,0,0,2.13-2.14V58.27A2.25,2.25,0,0,0,353,56h-3.08a1,1,0,0,0-1,.72,29.56,29.56,0,0,0-1,8A36.13,36.13,0,0,0,349,73.24,1,1,0,0,0,349.91,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M349.93,73.87h3a2.14,2.14,0,0,0,2.14-2.14V58.38a2.24,2.24,0,0,0-2.25-2.24h-3a1,1,0,0,0-.94.71,29.85,29.85,0,0,0-1,7.87,36.67,36.67,0,0,0,1,8.41A1,1,0,0,0,349.93,73.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M350,73.76h2.88A2.15,2.15,0,0,0,355,71.61V58.49a2.24,2.24,0,0,0-2.24-2.24h-2.82A1,1,0,0,0,349,57a30.4,30.4,0,0,0-1,7.79A36.66,36.66,0,0,0,349,73,1,1,0,0,0,350,73.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M350,73.64h2.74a2.15,2.15,0,0,0,2.15-2.15V58.6a2.23,2.23,0,0,0-2.23-2.23h-2.69a.93.93,0,0,0-.91.7,30.89,30.89,0,0,0-.93,7.7,35.94,35.94,0,0,0,.95,8.14A.94.94,0,0,0,350,73.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M350,73.53h2.6a2.16,2.16,0,0,0,2.15-2.16V58.71a2.22,2.22,0,0,0-2.22-2.23H350a.94.94,0,0,0-.9.7,31.8,31.8,0,0,0-.9,7.61,36.64,36.64,0,0,0,.92,8A.93.93,0,0,0,350,73.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M350,73.41h2.46a2.16,2.16,0,0,0,2.16-2.16V58.82a2.22,2.22,0,0,0-2.22-2.22H350a.91.91,0,0,0-.89.69,32.43,32.43,0,0,0-.87,7.53,36.61,36.61,0,0,0,.88,7.88A.92.92,0,0,0,350,73.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M350,73.3h2.31a2.17,2.17,0,0,0,2.17-2.17V58.92a2.21,2.21,0,0,0-2.21-2.21H350a.89.89,0,0,0-.87.69,32.4,32.4,0,0,0-.84,7.44,36.55,36.55,0,0,0,.85,7.75A.89.89,0,0,0,350,73.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M350,73.18h2.18A2.17,2.17,0,0,0,354.39,71V59a2.21,2.21,0,0,0-2.2-2.2H350a.88.88,0,0,0-.86.68,33.7,33.7,0,0,0-.8,7.35,36.91,36.91,0,0,0,.81,7.63A.89.89,0,0,0,350,73.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M350.06,73.07h2a2.17,2.17,0,0,0,2.17-2.18V59.14a2.2,2.2,0,0,0-2.19-2.2h-2a.86.86,0,0,0-.84.68,34.31,34.31,0,0,0-.78,7.27,37.64,37.64,0,0,0,.78,7.49A.88.88,0,0,0,350.06,73.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M350.08,73H352a2.18,2.18,0,0,0,2.18-2.18V59.25a2.2,2.2,0,0,0-2.2-2.19h-1.88a.86.86,0,0,0-.84.67,35.24,35.24,0,0,0-.74,7.18,36.9,36.9,0,0,0,.75,7.36A.85.85,0,0,0,350.08,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M350.1,72.84h1.75A2.19,2.19,0,0,0,354,70.65V59.36a2.19,2.19,0,0,0-2.19-2.19H350.1a.84.84,0,0,0-.82.67,36.06,36.06,0,0,0-.71,7.09,37.3,37.3,0,0,0,.71,7.24A.84.84,0,0,0,350.1,72.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M351.73,63.55c-.14-.74,1.76,10.46,3.51,10,1-.24.22-16.75-.53-17.39s-3.75-1-4.37-.22S351.92,64.52,351.73,63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M351.81,63.18c-.14-.68,1.66,9.84,3.32,9.44.93-.23.25-15.73-.46-16.35s-3.53-1-4.13-.24S352,64.06,351.81,63.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M351.88,62.8c-.13-.61,1.57,9.23,3.14,8.85.89-.21.27-14.69-.39-15.29s-3.31-1-3.89-.28S352.05,63.6,351.88,62.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M352,62.42c-.11-.54,1.48,8.61,3,8.27.84-.2.29-13.67-.32-14.25s-3.09-.93-3.66-.3S352.11,63.14,352,62.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M352,62c-.11-.47,1.38,8,2.78,7.68.8-.18.32-12.63-.25-13.2s-2.87-.9-3.43-.32S352.17,62.68,352,62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M352.1,61.67c-.1-.41,1.29,7.37,2.6,7.08.77-.16.34-11.6-.17-12.15s-2.66-.87-3.2-.34S352.24,62.22,352.1,61.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M352.17,61.29c-.08-.34,1.2,6.76,2.42,6.5.73-.16.37-10.57-.1-11.1s-2.44-.86-3-.38S352.3,61.76,352.17,61.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M352.25,60.91c-.08-.27,1.1,6.15,2.24,5.91.69-.14.39-9.54,0-10a2.85,2.85,0,0,0-2.72-.4C351.23,56.81,352.36,61.3,352.25,60.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M352.32,60.53c-.06-.2,1,5.53,2.06,5.33.65-.13.42-8.52,0-9a2.57,2.57,0,0,0-2.49-.42C351.45,56.81,352.43,60.84,352.32,60.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M352.4,60.16c-.06-.14.91,4.91,1.87,4.73.61-.11.44-7.48.11-8a2.29,2.29,0,0,0-2.25-.44C351.67,56.82,352.49,60.38,352.4,60.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M352.47,59.78c-.05-.07.83,4.3,1.7,4.15.57-.1.46-6.46.18-6.91a2,2,0,0,0-2-.48C351.88,56.83,352.56,59.92,352.47,59.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M352.54,59.4s.74,3.68,1.52,3.56c.53-.08.49-5.42.25-5.86a1.75,1.75,0,0,0-1.78-.5C352.1,56.84,352.6,59.47,352.54,59.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M352.62,59c0,.08.64,3.07,1.33,3,.49-.07.51-4.4.32-4.82a1.48,1.48,0,0,0-1.54-.52C352.32,56.85,352.67,59,352.62,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M352.69,58.65c0,.13.55,2.45,1.15,2.38s.54-3.37.4-3.77a1.24,1.24,0,0,0-1.31-.54C352.54,56.86,352.72,58.54,352.69,58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M352.77,58.27c0,.21.45,1.84,1,1.8s.56-2.34.46-2.72a1,1,0,0,0-1.08-.58C352.75,56.87,352.79,58.09,352.77,58.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M352.84,57.89c0,.28.36,1.23.79,1.21s.58-1.31.54-1.67a.8.8,0,0,0-.85-.6C353,56.88,352.85,57.63,352.84,57.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M352.91,57.51a.62.62,0,0,0,.61.63.63.63,0,1,0-.61-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M464.6,78.74c-1.1-10.92-5.29-28.11-7.42-36.37a6.53,6.53,0,0,0-6.11-4.9s-10.53-1.15-33.1-1.15c-25.86,0-33,1.15-33,1.15a6.53,6.53,0,0,0-6.11,4.9c-2.12,8.26-6.31,25.45-7.41,36.37a235.47,235.47,0,0,0-.68,35.15,45.77,45.77,0,0,0,5.17,15H460.1a45.77,45.77,0,0,0,5.17-15A236.24,236.24,0,0,0,464.6,78.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-413",
    d: "M445.23,136.66h13.36a.26.26,0,0,0,.28-.2l1.08-8H445v8A.25.25,0,0,0,445.23,136.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-413",
    d: "M375.18,136.66h13.37a.26.26,0,0,0,.28-.22v-8h-15l1.07,8A.28.28,0,0,0,375.18,136.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-484",
    d: "M447,126.1h10.94a0,0,0,0,1,0,0v19.41a1.8,1.8,0,0,1-1.8,1.8h-7.34a1.8,1.8,0,0,1-1.8-1.8V126.1A0,0,0,0,1,447,126.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M376.06,126.1H387a0,0,0,0,1,0,0v19.41a1.8,1.8,0,0,1-1.8,1.8h-7.34a1.8,1.8,0,0,1-1.8-1.8V126.1A0,0,0,0,1,376.06,126.1Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-173",
    width: 20,
    height: 8,
    transform: "translate(370.24 97.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsSAAALEgHS3X78AAAA0ElEQVQoU52OPWqGQBRFzxNBRRQsxF5wFZZuwOW4Kldg+23BytZai3Fw/JsUIYGEiElO9d7lXLgyDINt2xYRQUQA/nSLCEopjDE0TYMLEIbhrfxT9v1floUsy3i9Xrht21LXNUVRvJv/pO97O44jThAEFEXx5D8SxzEAjjHmQf0dURTheR7OdV0AnOdpt22zD71bPhZK13U2SRL2fX+o3DOOI0opyrLErapKrLVflimlOI6DdV3RWn+WlmVhnmfmeWaaJnzfx1pLmqZorcnznDfhblzAOtlKjgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-486",
    d: "M387.91,104.8,371.6,104a1.23,1.23,0,0,1-1.16-1.23V99.51a1.23,1.23,0,0,1,1.23-1.23H388a1.23,1.23,0,0,1,1.23,1.23v4.06A1.24,1.24,0,0,1,387.91,104.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M375.55,98.28h-3.88a1.23,1.23,0,0,0-1.23,1.23v3.21A1.23,1.23,0,0,0,371.6,104l3.95.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-487",
    d: "M381.67,101.42a2.37,2.37,0,1,1-2.37-2.37A2.38,2.38,0,0,1,381.67,101.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-488",
    d: "M387.63,101.42a2.37,2.37,0,1,1-2.37-2.37A2.38,2.38,0,0,1,387.63,101.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-489",
    d: "M374.06,100.68h-1.88a.81.81,0,0,1-.81-.81h0a.81.81,0,0,1,.81-.81h1.88a.81.81,0,0,1,.81.81h0A.81.81,0,0,1,374.06,100.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-490",
    d: "M374.06,103h-1.88a.81.81,0,0,1-.81-.81h0a.81.81,0,0,1,.81-.81h1.88a.81.81,0,0,1,.81.81h0A.81.81,0,0,1,374.06,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-491",
    d: "M379.3,98.28h-7.63a1.23,1.23,0,0,0-1.23,1.23v3.21A1.23,1.23,0,0,0,371.6,104l16.31.85a1.22,1.22,0,0,0,1.14-.66l-16.58-1.3a1.2,1.2,0,0,1-1.1-1.2v-1.5A1.19,1.19,0,0,1,372.45,99Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-492",
    x: 371.28,
    y: 98.44,
    width: 17.77,
    height: 2.71,
    rx: 1.16
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-173",
    width: 21,
    height: 8,
    transform: "translate(444.24 97.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAICAYAAAAWX7TTAAAACXBIWXMAAAsSAAALEgHS3X78AAAA20lEQVQoU52RQWqGUAyEvzwi8stTcekVPZYn8BDeQjyAC0XRhfjAdNFWaP9S/3ZgyCRMksWImQFY3/c0TYOIICI45550COGaAZf+7KuqAhAFbFkWuq4jSZIfF0SE4ziI4/jLk+81hEAURSZmZuu6kqYpwPvFf8LMTERwAKp6538J4zgC4EIIN9bXcZ4nAE5V2ff9xv4rbJomq+vaPkJHzvO0eZ6Zpom2bRmGgSiKyPOcx+OBc46yLMmyjDRN8d6jqjjnUNWL27YBUBQFYmas62ree5ZleUr9jxSAN/6zWQ2NzHBhAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-493",
    d: "M447,104.8l16.31-.85a1.23,1.23,0,0,0,1.16-1.23V99.51a1.23,1.23,0,0,0-1.23-1.23H447a1.23,1.23,0,0,0-1.23,1.23v4.06A1.24,1.24,0,0,0,447,104.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M459.38,98.28h3.88a1.23,1.23,0,0,1,1.23,1.23v3.21a1.23,1.23,0,0,1-1.16,1.23l-3.95.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-494",
    d: "M453.26,101.42a2.37,2.37,0,1,0,2.37-2.37A2.38,2.38,0,0,0,453.26,101.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-495",
    d: "M447.31,101.42a2.37,2.37,0,1,0,2.37-2.37A2.38,2.38,0,0,0,447.31,101.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-496",
    d: "M460.87,100.68h1.88a.81.81,0,0,0,.81-.81h0a.81.81,0,0,0-.81-.81h-1.88a.82.82,0,0,0-.81.81h0A.81.81,0,0,0,460.87,100.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "M460.87,103h1.88a.81.81,0,0,0,.81-.81h0a.81.81,0,0,0-.81-.81h-1.88a.81.81,0,0,0-.81.81h0A.81.81,0,0,0,460.87,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-498",
    d: "M455.63,98.28h7.63a1.23,1.23,0,0,1,1.23,1.23v3.21a1.23,1.23,0,0,1-1.16,1.23L447,104.8a1.21,1.21,0,0,1-1.13-.66l16.57-1.3a1.2,1.2,0,0,0,1.1-1.2v-1.5A1.18,1.18,0,0,0,462.49,99Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-499",
    x: 445.89,
    y: 98.44,
    width: 17.77,
    height: 2.71,
    rx: 1.16,
    transform: "translate(909.54 199.59) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-500",
    x: 370.31,
    y: 98.44,
    width: 94.38,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-501",
    x: 370.31,
    y: 97.9,
    width: 94.38,
    height: 0.54
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-173",
    width: 38,
    height: 8,
    transform: "translate(398.24 97.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAICAYAAACVm43oAAAACXBIWXMAAAsSAAALEgHS3X78AAAAnElEQVQ4T82TPQ6DMAxGn1El/nIEegh6/zNwibIwMmGWuEPbEKpSSofCW2LHn+XPiiJmZk3TMI7KkTgB5HmGCIC8nCDPYFNt0vxS6/v+bkxVqetLkB8AS9YUe5EApGm2pvsnBiBmZtHl7s/ZtlerqjPy8GUAXdfhnKMois/dG5nv/p5hGCjLMuQSNYXAe8+3xEOnX7qsWUJVY2NyA1cfNwOWfBhLAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-502",
    d: "M445.51,97.65h-29v0H390.62l2.88,10.38a3.68,3.68,0,0,0,3.55,2.69h42a3.68,3.68,0,0,0,3.55-2.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-503",
    points: "443.4 105.22 392.73 105.22 391.68 101.45 444.45 101.45 443.4 105.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-504",
    points: "444.46 101.45 391.68 101.45 390.62 97.67 445.51 97.67 444.46 101.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-505",
    d: "M441.76,109H394.37a.81.81,0,0,1-.78-.59l-.87-3.19H443.4l-.9,3.22A.76.76,0,0,1,441.76,109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-506",
    d: "M445.51,97.65h-29v0H390.62l2.88,10.38a3.68,3.68,0,0,0,3.55,2.69h42a3.68,3.68,0,0,0,3.55-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-507",
    d: "M464,113.89H370.31c-.37,0-.67.22-.65.5a80.87,80.87,0,0,0,1.44,9.86,31.05,31.05,0,0,0,.91,3.53,1.26,1.26,0,0,0,1.24.73H461.1a1.26,1.26,0,0,0,1.24-.73,31.05,31.05,0,0,0,.91-3.53,80.87,80.87,0,0,0,1.44-9.86C464.71,114.11,464.41,113.89,464,113.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-508",
    d: "M405.49,122H394.21a3.34,3.34,0,0,1-3-2l-1.32-2.94H401a3.21,3.21,0,0,1,2.87,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-509",
    d: "M430.63,122h11.28a3.35,3.35,0,0,0,3.06-2l1.31-2.94H435.1a3.23,3.23,0,0,0-2.87,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-510",
    d: "M464,114h-6.11v14.53h3.17a1.27,1.27,0,0,0,1.24-.72,31.05,31.05,0,0,0,.91-3.51,79.75,79.75,0,0,0,1.44-9.8C464.71,114.21,464.41,114,464,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-511",
    d: "M375.88,114h-5.57c-.37,0-.67.23-.65.5a79.75,79.75,0,0,0,1.44,9.8,31.05,31.05,0,0,0,.91,3.51,1.27,1.27,0,0,0,1.24.72h2.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-418",
    x: 406.73,
    y: 116.94,
    width: 22.65,
    height: 5.26,
    rx: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-419",
    d: "M429,122.34h-21.9a.51.51,0,0,1-.51-.52v-4.5a.51.51,0,0,1,.51-.52H429a.51.51,0,0,1,.51.52v4.5A.51.51,0,0,1,429,122.34Zm-21.9-5.26a.24.24,0,0,0-.24.24v4.5a.24.24,0,0,0,.24.24H429a.24.24,0,0,0,.24-.24v-4.5a.24.24,0,0,0-.24-.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-512",
    x: 378.83,
    y: 118.09,
    width: 5.37,
    height: 2.96,
    rx: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 379.11,
    y: 118.4,
    width: 5,
    height: 2.62,
    rx: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-345",
    x: 379.15,
    y: 118.41,
    width: 4.93,
    height: 2.57,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 379.19,
    y: 118.43,
    width: 4.86,
    height: 2.53,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-513",
    x: 379.23,
    y: 118.44,
    width: 4.79,
    height: 2.48,
    rx: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-514",
    x: 379.27,
    y: 118.46,
    width: 4.72,
    height: 2.43,
    rx: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-515",
    x: 379.31,
    y: 118.47,
    width: 4.65,
    height: 2.39,
    rx: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-516",
    x: 379.35,
    y: 118.49,
    width: 4.58,
    height: 2.34,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-517",
    x: 379.39,
    y: 118.5,
    width: 4.51,
    height: 2.3,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-518",
    x: 379.43,
    y: 118.52,
    width: 4.44,
    height: 2.25,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-519",
    x: 379.47,
    y: 118.53,
    width: 4.37,
    height: 2.2,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-520",
    x: 379.5,
    y: 118.55,
    width: 4.3,
    height: 2.16,
    rx: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-521",
    x: 379.54,
    y: 118.56,
    width: 4.23,
    height: 2.11,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-522",
    x: 379.58,
    y: 118.58,
    width: 4.16,
    height: 2.06,
    rx: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-523",
    x: 379.62,
    y: 118.59,
    width: 4.09,
    height: 2.02,
    rx: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-524",
    x: 379.66,
    y: 118.61,
    width: 4.02,
    height: 1.97,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-525",
    x: 379.7,
    y: 118.62,
    width: 3.95,
    height: 1.92,
    rx: 0.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-526",
    x: 379.74,
    y: 118.64,
    width: 3.88,
    height: 1.88,
    rx: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-527",
    x: 379.78,
    y: 118.65,
    width: 3.81,
    height: 1.83,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-528",
    x: 379.82,
    y: 118.67,
    width: 3.74,
    height: 1.78,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 379.86,
    y: 118.68,
    width: 3.67,
    height: 1.74,
    rx: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-529",
    x: 379.89,
    y: 118.7,
    width: 3.6,
    height: 1.69,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 379.93,
    y: 118.71,
    width: 3.53,
    height: 1.64,
    rx: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-530",
    x: 379.28,
    y: 118.47,
    width: 4.56,
    height: 2.19,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-531",
    x: 379.29,
    y: 118.48,
    width: 4.54,
    height: 2.13,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-532",
    x: 379.31,
    y: 118.48,
    width: 4.51,
    height: 2.06,
    rx: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-533",
    x: 379.32,
    y: 118.49,
    width: 4.48,
    height: 1.99,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-534",
    x: 379.33,
    y: 118.5,
    width: 4.45,
    height: 1.93,
    rx: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-535",
    x: 379.35,
    y: 118.5,
    width: 4.42,
    height: 1.86,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-536",
    x: 379.36,
    y: 118.51,
    width: 4.4,
    height: 1.79,
    rx: 0.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-537",
    x: 379.38,
    y: 118.51,
    width: 4.37,
    height: 1.73,
    rx: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-538",
    x: 379.39,
    y: 118.52,
    width: 4.34,
    height: 1.66,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-539",
    x: 379.4,
    y: 118.52,
    width: 4.31,
    height: 1.6,
    rx: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-540",
    x: 379.42,
    y: 118.53,
    width: 4.29,
    height: 1.53,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-541",
    x: 379.43,
    y: 118.53,
    width: 4.26,
    height: 1.46,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-542",
    x: 379.45,
    y: 118.54,
    width: 4.23,
    height: 1.4,
    rx: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-543",
    x: 379.46,
    y: 118.55,
    width: 4.2,
    height: 1.33,
    rx: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-544",
    x: 379.47,
    y: 118.55,
    width: 4.17,
    height: 1.26,
    rx: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-545",
    x: 379.49,
    y: 118.56,
    width: 4.15,
    height: 1.2,
    rx: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-546",
    x: 379.5,
    y: 118.56,
    width: 4.12,
    height: 1.13,
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-547",
    x: 379.51,
    y: 118.57,
    width: 4.09,
    height: 1.07,
    rx: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-548",
    x: 379.53,
    y: 118.57,
    width: 4.06,
    height: 1,
    rx: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-549",
    x: 379.54,
    y: 118.58,
    width: 4.04,
    height: 0.93,
    rx: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-550",
    x: 379.56,
    y: 118.59,
    width: 4.01,
    height: 0.87,
    rx: 0.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-551",
    x: 379.57,
    y: 118.59,
    width: 3.98,
    height: 0.8,
    rx: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M379.64,118.85a16.73,16.73,0,0,0,3.84.14c.16-.18.12-.37-.35-.4S379.61,118.59,379.64,118.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-512",
    x: 450.81,
    y: 118.09,
    width: 5.37,
    height: 2.96,
    rx: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 451.1,
    y: 118.4,
    width: 5,
    height: 2.62,
    rx: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-345",
    x: 451.13,
    y: 118.41,
    width: 4.93,
    height: 2.57,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 451.17,
    y: 118.43,
    width: 4.86,
    height: 2.53,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-513",
    x: 451.21,
    y: 118.44,
    width: 4.79,
    height: 2.48,
    rx: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-514",
    x: 451.25,
    y: 118.46,
    width: 4.72,
    height: 2.43,
    rx: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-515",
    x: 451.29,
    y: 118.47,
    width: 4.65,
    height: 2.39,
    rx: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-516",
    x: 451.33,
    y: 118.49,
    width: 4.58,
    height: 2.34,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-517",
    x: 451.37,
    y: 118.5,
    width: 4.51,
    height: 2.3,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-518",
    x: 451.41,
    y: 118.52,
    width: 4.44,
    height: 2.25,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-519",
    x: 451.45,
    y: 118.53,
    width: 4.37,
    height: 2.2,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-520",
    x: 451.49,
    y: 118.55,
    width: 4.3,
    height: 2.16,
    rx: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-521",
    x: 451.52,
    y: 118.56,
    width: 4.23,
    height: 2.11,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-522",
    x: 451.56,
    y: 118.58,
    width: 4.16,
    height: 2.06,
    rx: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-523",
    x: 451.6,
    y: 118.59,
    width: 4.09,
    height: 2.02,
    rx: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-524",
    x: 451.64,
    y: 118.61,
    width: 4.02,
    height: 1.97,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-525",
    x: 451.68,
    y: 118.62,
    width: 3.95,
    height: 1.92,
    rx: 0.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-526",
    x: 451.72,
    y: 118.64,
    width: 3.88,
    height: 1.88,
    rx: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-527",
    x: 451.76,
    y: 118.65,
    width: 3.81,
    height: 1.83,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-528",
    x: 451.8,
    y: 118.67,
    width: 3.74,
    height: 1.78,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 451.84,
    y: 118.68,
    width: 3.67,
    height: 1.74,
    rx: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-529",
    x: 451.88,
    y: 118.7,
    width: 3.6,
    height: 1.69,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 451.91,
    y: 118.71,
    width: 3.53,
    height: 1.64,
    rx: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-552",
    x: 451.26,
    y: 118.47,
    width: 4.56,
    height: 2.19,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-553",
    x: 451.27,
    y: 118.48,
    width: 4.54,
    height: 2.13,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-554",
    x: 451.29,
    y: 118.48,
    width: 4.51,
    height: 2.06,
    rx: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-555",
    x: 451.3,
    y: 118.49,
    width: 4.48,
    height: 1.99,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-556",
    x: 451.31,
    y: 118.5,
    width: 4.45,
    height: 1.93,
    rx: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-557",
    x: 451.33,
    y: 118.5,
    width: 4.42,
    height: 1.86,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-558",
    x: 451.34,
    y: 118.51,
    width: 4.4,
    height: 1.79,
    rx: 0.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-559",
    x: 451.36,
    y: 118.51,
    width: 4.37,
    height: 1.73,
    rx: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-560",
    x: 451.37,
    y: 118.52,
    width: 4.34,
    height: 1.66,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-561",
    x: 451.38,
    y: 118.52,
    width: 4.31,
    height: 1.6,
    rx: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-562",
    x: 451.4,
    y: 118.53,
    width: 4.29,
    height: 1.53,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-563",
    x: 451.41,
    y: 118.53,
    width: 4.26,
    height: 1.46,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-564",
    x: 451.43,
    y: 118.54,
    width: 4.23,
    height: 1.4,
    rx: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-565",
    x: 451.44,
    y: 118.55,
    width: 4.2,
    height: 1.33,
    rx: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-566",
    x: 451.45,
    y: 118.55,
    width: 4.17,
    height: 1.26,
    rx: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-567",
    x: 451.47,
    y: 118.56,
    width: 4.15,
    height: 1.2,
    rx: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-568",
    x: 451.48,
    y: 118.56,
    width: 4.12,
    height: 1.13,
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-569",
    x: 451.5,
    y: 118.57,
    width: 4.09,
    height: 1.07,
    rx: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-570",
    x: 451.51,
    y: 118.57,
    width: 4.06,
    height: 1,
    rx: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-571",
    x: 451.52,
    y: 118.58,
    width: 4.04,
    height: 0.93,
    rx: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-572",
    x: 451.54,
    y: 118.59,
    width: 4.01,
    height: 0.87,
    rx: 0.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-551",
    x: 451.55,
    y: 118.59,
    width: 3.98,
    height: 0.8,
    rx: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M451.62,118.85a16.73,16.73,0,0,0,3.84.14c.16-.18.12-.37-.35-.4S451.59,118.59,451.62,118.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-573"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3,
    height: 3,
    transform: "translate(462.24 77.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAJ0lEQVQIW2P4//8/AwMDw39dfX0Iw9jM9D8HJ+d/BqjI/////zMAABjpDsIWvbBvAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 23,
    transform: "translate(463.24 56.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAXCAYAAADpwXTaAAAACXBIWXMAAAsSAAALEgHS3X78AAABN0lEQVQ4T63TzU7CQBSG4beFhSALTAxUSNhpwAQaJa0LrsHovatXAIL8FBoXxaDwuUAbESg/7UlmNTPPnDlzBknEHfmzvACZJBR122bnqfuM+8eH5DI7zeUASAR7eXqmaFnxr2mVSgLiX/OiXJZz51K3bSQZhqRdezbGdaOhtGkyGPTp996QZByV2a3rKm2ajIbDEIIjHsBttfQ1m+F5I3rdbggBpKM2/o8bx9H885PJeEy387oCwQGY3WxK8zm+P6HTbq9BsCd2Wa1q4nkEQcA0CDZCsEfNrmo1vfs+QCQERDdtuVIRoEKxqOXS6AbeOnFeKISdvQuJxAqWdTAkaf0BMtmsPqbT3xJsr8+GWMHMVEpaLIDDIfiDGYYRftJjIPhpjSQgAINloYF4EIDZdB1OMpnYEMA3R6mxjuKv0UEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-574"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 4,
    transform: "translate(480.24 54.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAYAAACk7+45AAAACXBIWXMAAAsSAAALEgHS3X78AAAAJklEQVQIWy3BwQ0AEAAEsBID8BMJ9p/yfLTmWkmiIND66Pa5qu8BomQF2rGLXDgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-575"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3,
    height: 4,
    transform: "translate(463.24 87.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAACXBIWXMAAAsSAAALEgHS3X78AAAAMElEQVQIWyXGsQ0AIAzAsJSlcAzqUMH/n4UBT0ZFZa710/cIOCLCzGRXQd/jrlLlAUo0FHV/C7/iAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 21,
    height: 33,
    transform: "translate(464.24 57.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAhCAYAAAA2/OAtAAAACXBIWXMAAAsSAAALEgHS3X78AAABQ0lEQVRIS62SwU7CQBRFzzQlLMSKG8oEpejSxJKgYNLoD2jg34kbxA/AtayExXOhhVItnU7nJm8xMy8n7907SkRwpUajIdvtVnlljVXk+z5KKfHLGqvoeTbl/W2J00mV8nidz91Cl4sFp0GAchmUUkoAt5MCiIi79G/ieLeyM+hJq8XtcAiAky+Vepmq9qQXUbQDiogCB9Cw0wH2wPRgXXeTsQDyg9nfW3sanAWy/lwDuSmxDCobTB4IFp6Ok+QoECyguhsCxcD00biKgsmXsadlPmZltH4VIBhAda8nXa0BMyAYQF9mUz5Wq7K2Qx0z/LLfNwrGOKiqPmb17/qh1tZAKIKGIYPrKysg8NfT5OnRysdsHRza5+3aQJFMUHWCycsDiEcjZ0D4hQ4GEeAGCODfP0xk87Up66skr9lsAu6mBPgGweaDvKoI59QAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-576"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 4,
    transform: "translate(483.24 56.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAYAAACk7+45AAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQIWwXBAQ0AIAgAsEMCDOLoXwoi6B94kHUKJNxuubMBHz94BJBpM8LhAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M486.24,74.68h-4a2.11,2.11,0,0,1-2.11-2.11V57.62a2.3,2.3,0,0,1,2.29-2.29h3.89a1.1,1.1,0,0,1,1,.74,27.44,27.44,0,0,1,1.22,8.49,36.93,36.93,0,0,1-1.26,9.32A1.09,1.09,0,0,1,486.24,74.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M486.22,74.57h-3.88a2.12,2.12,0,0,1-2.11-2.12V57.73a2.28,2.28,0,0,1,2.29-2.28h3.75a1.07,1.07,0,0,1,1,.73,27.68,27.68,0,0,1,1.19,8.41,36.61,36.61,0,0,1-1.23,9.18A1.07,1.07,0,0,1,486.22,74.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M486.2,74.45h-3.73a2.12,2.12,0,0,1-2.12-2.12V57.84a2.28,2.28,0,0,1,2.28-2.28h3.62a1.05,1.05,0,0,1,1,.73,28,28,0,0,1,1.16,8.32,36.51,36.51,0,0,1-1.19,9A1,1,0,0,1,486.2,74.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M486.18,74.34h-3.59a2.12,2.12,0,0,1-2.12-2.13V58a2.26,2.26,0,0,1,2.27-2.27h3.49a1,1,0,0,1,1,.72,28.27,28.27,0,0,1,1.12,8.23,36.53,36.53,0,0,1-1.15,8.93A1.06,1.06,0,0,1,486.18,74.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M486.16,74.22h-3.45a2.12,2.12,0,0,1-2.12-2.13v-14a2.27,2.27,0,0,1,2.26-2.27h3.35a1,1,0,0,1,1,.73,28.34,28.34,0,0,1,1.1,8.13,36.28,36.28,0,0,1-1.13,8.8A1,1,0,0,1,486.16,74.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M486.14,74.11h-3.31A2.14,2.14,0,0,1,480.7,72V58.17A2.26,2.26,0,0,1,483,55.91h3.22a1,1,0,0,1,1,.72,29.16,29.16,0,0,1,1.06,8.05,36.2,36.2,0,0,1-1.09,8.66A1,1,0,0,1,486.14,74.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M486.12,74H483a2.14,2.14,0,0,1-2.14-2.14V58.27A2.25,2.25,0,0,1,483.07,56h3.09a1,1,0,0,1,.95.72,29.56,29.56,0,0,1,1,8,36.82,36.82,0,0,1-1.05,8.54A1,1,0,0,1,486.12,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M486.1,73.87h-3a2.14,2.14,0,0,1-2.14-2.14V58.38a2.24,2.24,0,0,1,2.24-2.24h3a1,1,0,0,1,.94.71,30,30,0,0,1,1,7.87,36.11,36.11,0,0,1-1,8.41A1,1,0,0,1,486.1,73.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M486.08,73.76H483.2a2.14,2.14,0,0,1-2.14-2.15V58.49a2.24,2.24,0,0,1,2.23-2.24h2.82A1,1,0,0,1,487,57a30.26,30.26,0,0,1,1,7.79A36.51,36.51,0,0,1,487,73,1,1,0,0,1,486.08,73.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M486.07,73.64h-2.75a2.15,2.15,0,0,1-2.15-2.15V58.6a2.23,2.23,0,0,1,2.23-2.23h2.69a.94.94,0,0,1,.92.7,31.39,31.39,0,0,1,.93,7.7,36.54,36.54,0,0,1-.95,8.14A.94.94,0,0,1,486.07,73.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M486.05,73.53h-2.6a2.16,2.16,0,0,1-2.16-2.16V58.71a2.23,2.23,0,0,1,2.22-2.23h2.56a.94.94,0,0,1,.9.7,31.27,31.27,0,0,1,.9,7.61,36.81,36.81,0,0,1-.91,8A.94.94,0,0,1,486.05,73.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M486,73.41h-2.46a2.16,2.16,0,0,1-2.16-2.16V58.82a2.21,2.21,0,0,1,2.22-2.22h2.42a.9.9,0,0,1,.88.69,31.87,31.87,0,0,1,.87,7.53,36.61,36.61,0,0,1-.88,7.88A.9.9,0,0,1,486,73.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M486,73.3h-2.32a2.17,2.17,0,0,1-2.16-2.17V58.92a2.21,2.21,0,0,1,2.21-2.21H486a.91.91,0,0,1,.88.69,33,33,0,0,1,.84,7.44,36.55,36.55,0,0,1-.85,7.75A.9.9,0,0,1,486,73.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M486,73.18h-2.18A2.17,2.17,0,0,1,481.64,71V59a2.21,2.21,0,0,1,2.21-2.2H486a.88.88,0,0,1,.86.68,33.53,33.53,0,0,1,.81,7.35,37.64,37.64,0,0,1-.81,7.63A.89.89,0,0,1,486,73.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M486,73.07h-2a2.17,2.17,0,0,1-2.18-2.18V59.14a2.21,2.21,0,0,1,2.2-2.2h2a.87.87,0,0,1,.85.68,34.5,34.5,0,0,1,.77,7.27,36.88,36.88,0,0,1-.78,7.49A.87.87,0,0,1,486,73.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M486,73h-1.89a2.17,2.17,0,0,1-2.18-2.18V59.25a2.19,2.19,0,0,1,2.19-2.19H486a.85.85,0,0,1,.83.67,35.24,35.24,0,0,1,.74,7.18,37.91,37.91,0,0,1-.74,7.36A.85.85,0,0,1,486,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M485.93,72.84h-1.75A2.18,2.18,0,0,1,482,70.65V59.36a2.18,2.18,0,0,1,2.18-2.19h1.75a.85.85,0,0,1,.83.67,37.09,37.09,0,0,1,.7,7.09,38.37,38.37,0,0,1-.7,7.24A.85.85,0,0,1,485.93,72.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M484.3,63.55c.15-.74-1.75,10.46-3.5,10-1-.24-.22-16.75.53-17.39s3.74-1,4.37-.22S484.11,64.52,484.3,63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M484.23,63.18c.14-.68-1.66,9.84-3.33,9.44-.92-.23-.24-15.73.46-16.35s3.53-1,4.14-.24S484.05,64.06,484.23,63.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M484.15,62.8c.13-.61-1.56,9.23-3.14,8.85-.88-.21-.27-14.69.39-15.29s3.31-1,3.9-.28S484,63.6,484.15,62.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M484.08,62.42c.12-.54-1.47,8.61-3,8.27-.85-.2-.3-13.67.32-14.25s3.09-.93,3.66-.3S483.92,63.14,484.08,62.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M484,62c.1-.47-1.38,8-2.78,7.68-.81-.18-.32-12.63.24-13.2s2.88-.9,3.43-.32S483.86,62.68,484,62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M483.93,61.67c.1-.41-1.29,7.37-2.6,7.08-.76-.16-.34-11.6.18-12.15s2.66-.87,3.19-.34S483.8,62.22,483.93,61.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M483.86,61.29c.09-.34-1.2,6.76-2.42,6.5-.73-.16-.37-10.57.1-11.1s2.45-.86,3-.38S483.74,61.76,483.86,61.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M483.79,60.91c.07-.27-1.11,6.15-2.24,5.91-.69-.14-.39-9.54,0-10a2.85,2.85,0,0,1,2.72-.4C484.8,56.81,483.67,61.3,483.79,60.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M483.71,60.53c.07-.2-1,5.53-2.06,5.33-.64-.13-.41-8.52,0-9a2.55,2.55,0,0,1,2.48-.42C484.58,56.81,483.61,60.84,483.71,60.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M483.64,60.16c.05-.14-.92,4.91-1.88,4.73-.61-.11-.44-7.48-.11-8a2.29,2.29,0,0,1,2.25-.44C484.37,56.82,483.54,60.38,483.64,60.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M483.56,59.78c.05-.07-.82,4.3-1.69,4.15-.57-.1-.46-6.46-.18-6.91a2,2,0,0,1,2-.48C484.15,56.83,483.47,59.92,483.56,59.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M483.49,59.4c.05,0-.73,3.68-1.51,3.56-.53-.08-.49-5.42-.26-5.86a1.76,1.76,0,0,1,1.79-.5C483.93,56.84,483.43,59.47,483.49,59.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M483.42,59c0,.08-.64,3.07-1.34,3-.49-.07-.51-4.4-.32-4.82a1.5,1.5,0,0,1,1.55-.52C483.72,56.85,483.37,59,483.42,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M483.34,58.65c0,.13-.55,2.45-1.15,2.38-.45-.05-.54-3.37-.39-3.77a1.24,1.24,0,0,1,1.31-.54C483.5,56.86,483.31,58.54,483.34,58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M483.27,58.27c0,.21-.46,1.84-1,1.8s-.56-2.34-.47-2.72a1,1,0,0,1,1.08-.58C483.28,56.87,483.25,58.09,483.27,58.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M483.19,57.89c0,.28-.36,1.23-.78,1.21s-.59-1.31-.54-1.67a.79.79,0,0,1,.84-.6C483.07,56.88,483.18,57.63,483.19,57.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M483.12,57.51a.62.62,0,0,1-.61.63.63.63,0,0,1,0-1.25A.61.61,0,0,1,483.12,57.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-577"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 4,
    transform: "translate(473.24 66.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAYAAACk7+45AAAACXBIWXMAAAsSAAALEgHS3X78AAAALElEQVQIWwXB0REAEAxEwZce5IMaxBn6L82c3SjJz4a5yoCjJO97iD6GWyYf6IsKt3P55IYAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 7,
    transform: "translate(473.24 68.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAHCAYAAAAvZezQAAAACXBIWXMAAAsSAAALEgHS3X78AAAAUUlEQVQIWz3LIQ6AMBTA0H7kNNyBkCwTBG6DgMsT5octAoJ7oiWX4nbsqqgEIIAafGCcJl9KB3C3xrwu/EU/DKaUVAmViDCXQq31XdRQuc6TB1JpMecPxJNSAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-578"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 4,
    transform: "translate(475.24 73.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAYAAACk7+45AAAACXBIWXMAAAsSAAALEgHS3X78AAAALUlEQVQIW2PU1df//+rVKwYmBgYGhr9/fjMw/fv3l8HSxoaBgV9A4D8DA8N/AAJrDRnZhnUmAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M454.2,47.73a4.57,4.57,0,0,0-4.33-3.47l-31.81-.74H418l-31.81.74a4.56,4.56,0,0,0-4.32,3.47c-1.67,6.84-5.28,22.37-6,31l42.09.82h.08l42.1-.82C459.48,70.1,455.86,54.57,454.2,47.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-579",
    d: "M452.51,49.37a2.49,2.49,0,0,0-2.36-1.84l-32-.72-32.29.72a2.49,2.49,0,0,0-2.36,1.84c-1.4,5.14-5.32,20.09-6,28.77l40.65.81,40.36-.81C457.83,69.46,453.91,54.51,452.51,49.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-580",
    d: "M462.52,80.47s-33.37.92-44.5.92-44.5-.92-44.5-.92V82.3s33.4,1.58,44.54,1.58,44.46-1.58,44.46-1.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-581"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-582",
    d: "M453.23,67.65a2.6,2.6,0,0,0-2.57-2.25h-1.84v-.85a2.75,2.75,0,0,0-.83-5.38h-6.08a2.75,2.75,0,0,0-.83,5.38v.85h-1.84a2.59,2.59,0,0,0-2.57,2.25l-2.14,16h20.84Zm-11.08-3h5.6v.71h-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-582",
    d: "M417.09,67.65a2.59,2.59,0,0,0-2.56-2.25h-1.85v-.85a2.75,2.75,0,0,0-.83-5.38h-6.08a2.75,2.75,0,0,0-.82,5.38v.85H403.1a2.6,2.6,0,0,0-2.57,2.25l-2.14,16h20.84Zm-11.08-3h5.6v.71H406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-582",
    d: "M397,67.65a2.6,2.6,0,0,0-2.57-2.25h-1.85v-.85a2.75,2.75,0,0,0-.82-5.38h-6.08a2.75,2.75,0,0,0-.83,5.38v.85H383a2.59,2.59,0,0,0-2.56,2.25l-2.14,16h20.84Zm-11.08-3h5.6v.71h-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-582",
    d: "M445,95.3a11.75,11.75,0,1,1,11.74-11.74A11.75,11.75,0,0,1,445,95.3Zm0-21.48a9.74,9.74,0,1,0,9.74,9.74A9.75,9.75,0,0,0,445,73.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-583",
    points: "392.89 45.44 388.88 79.77 409.74 80.47 410.23 45.29 392.89 45.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-584",
    points: "421.6 46.17 422.39 81.36 453.69 80.47 447.46 45.24 421.6 46.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-585",
    points: "385.26 46.8 379.74 80.64 384.99 81.32 389.92 45.63 385.26 46.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-586",
    d: "M457.18,42.37a6.53,6.53,0,0,0-6.11-4.9l-7.81-.28,9,82.52H464a36.34,36.34,0,0,0,1.28-5.82,236.24,236.24,0,0,0-.67-35.15C463.5,67.82,459.31,50.63,457.18,42.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-587",
    d: "M392.11,37.22l-7.15.25a6.53,6.53,0,0,0-6.11,4.9c-2.12,8.26-6.31,25.45-7.41,36.37a235.47,235.47,0,0,0-.68,35.15,35.29,35.29,0,0,0,1.29,5.82h11.07Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 4,
    transform: "translate(396.24 74.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAECAYAAABsgwTvAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQYV5WOsQrCQBiDv384eghyOMjJQZ9EocWhj1zwWYqbxa6WutmLi4MdhBoIJAQ+YpI41bWuXUcqS3xR4JwjxchrnnmMI5e2NVbI9jHqOU1sQ0A5kz/+zln6uUnikBL3vjc7VpUWdFue+KebtGCt1rlptAuBjffchgHMeAPaH0qMDNFFfwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-588",
    d: "M414.59,78.22A.69.69,0,0,1,414,77a.62.62,0,0,1,.76.37A.61.61,0,0,1,414.59,78.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-589",
    d: "M402.83,77.79h0a.42.42,0,0,1,.44-.4l22.22,1a.41.41,0,0,1,.4.43h0C425.88,79.05,402.82,78,402.83,77.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-590",
    d: "M399,78.73l-4.68-.19,1.21-1.63a1,1,0,0,1,1-.36l2.4.54a.61.61,0,0,1,.35.21l.28.3A.68.68,0,0,1,399,78.73Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 4,
    transform: "translate(418.24 73.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAECAYAAABsgwTvAAAACXBIWXMAAAsSAAALEgHS3X78AAAAcklEQVQYV5XMMQqFMBRE0ftAXIN8jGJh4yq+hVl0GhdhYSmIRaosIAaelYUgiqcbmBlRVXprNc8yYkqcRueEj+Q/DHqGPUaaqmLz/mlza3ROLmdPyqJgWVdCCMzTxM8YTF3TtS17SmzeI6rvX7217yXgAEZ3KZFzhz8dAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-591",
    d: "M418.84,76.37a.69.69,0,0,0,.74-1.11.69.69,0,0,0-.74,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-592",
    d: "M430.55,77.4h0a.42.42,0,0,0-.38-.45L408,75.17a.43.43,0,0,0-.46.39h0C407.52,75.79,430.54,77.63,430.55,77.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-590",
    d: "M433.83,78.9h4.68l-1.14-1.68a.94.94,0,0,0-.95-.4l-2.42.45a.66.66,0,0,0-.37.19l-.28.29A.68.68,0,0,0,433.83,78.9Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckDamage);
export default __webpack_public_path__ + "static/media/truck_damage.063b7c5f61120affbc340cebd260061d.svg";
export { ForwardRef as ReactComponent };